import { codVendCompradorDoUsuario } from '../../shared/comprador-por-usuario';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import * as XLSX from 'xlsx';
// @ts-ignore
import { Component, OnInit, OnDestroy, Input, signal, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SankhyaGatewayService, DemonstrativoCotacao } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import { PermissaoAcessoService } from '../../services/permissao-acesso.service';
import { MoneyMaskDirective } from '../../directives/money-mask.directive';
import { ProdutoService } from '../../services/produto.service';
import { SerialService } from '../../services/serial.service';

interface OpcaoCampo {
  valor: string;
  opcao: string;
}

interface ClienteSugestao {
  codparc: string | number;
  nomeparc: string;
  docparc?: string;
  adCom?: string;
  inscEstadual?: string;
  cidade?: string;
  uf?: string;
  bloquear?: string;
}

interface TituloClientePosicionado {
  label: string;
  left: number;
}

interface Endereco {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cep: string;
  cidade: string;
  uf: string;
}

/** Um dos endereços disponíveis para o mesmo CNPJ/CPF (um por CODPARC). */
interface EnderecoDisponivel {
  codparc: string | number;
  nomeparc: string;
  ENDERECO?: string;
  NUMEND?: string;
  COMPLEMENTO?: string;
  BAIRRO?: string;
  CEP?: string;
  NOMECID?: string;
  UF?: string;
  adCom?: string;
  inscEstadual?: string;
}

interface ItemPedido {
  id: number;
  codprod: string;          // REFFORN digitado pelo usuário (PN)
  codprodOriginal?: string; // PN salvo ao carregar produto — usado para restaurar após edição parcial
  adCondicao?: string;      // AD_CONDICAO da peça
  codprodInterno?: number;  // CODPROD numérico do Sankhya (preenchido ao buscar)
  codlocalpadrao?: number;  // CODLOCALPADRAO do produto em TGFPRO
  descricao: string;
  unidade: string;
  quantidade: number;
  precoUsd: number;         // VLRVENDA de TGFEXC (mais recente) — exibido em USD
  precoUnitario: number;    // precoUsd × cotação — calculado, não editável
  desconto: number;
  vlrDesc: number;          // VLRDESC — desconto por valor (subtrai do total)
  vlrAcrescDesc: number;    // VLRACRESCDESC — acréscimo (soma ao total)
  total: number;            // total BRL com desconto
  totalUsd: number;         // total USD com desconto
  controlaCore: boolean;    // AD_CONTROLACORE = 'S' em TGFPRO
  vlrCore: number;          // AD_VLRCORE em TGFPRO — Core Unit U$ (preço unitário CORE em USD)
  coreUnitBrl: number;      // vlrCore × cotação — Core Unit R$ (preço unitário CORE em BRL)
  totalCoreUsd: number;     // qtd × vlrCore
  totalCoreBrl: number;     // qtd × coreUnitBrl
  estoque: number;          // saldo disponível (TGFEST: ESTOQUE - RESERVADO)
  precoUsdStr?: string;      // texto digitado no input — evita cursor pular ao formatar
  vlrDescStr?: string;       // texto digitado no Desc. Vlr — evita cursor pular ao formatar
  totalItemStr?: string;     // texto digitado no Subtotal R$ — dispara cálculo reverso de desconto
  buscando?: boolean;
  // Impostos fiscais (calculados pelo Sankhya após gravar — lidos de TGFITE em modo edição)
  ncm?: string;             // TGFPRO.NCM — lido junto com os impostos (modo edição / rascunho de impostos)
  aliqIpi?: number;         // ALIQIPI — alíquota IPI %
  vlrBaseIpi?: number;      // VLRBASEIPI — base de cálculo IPI
  vlrIpi?: number;          // VLRIPI — valor do IPI
  aliqIcmsst?: number;      // ALIQICMSST — alíquota ST %
  vlrBaseIcmsst?: number;   // VLRBASEICMSST — base de cálculo ST
  vlrIcmsst?: number;       // VLRICMSST — valor do ST
  // Preço desatualizado (mesma regra do F3/F7) — atualizado a cada busca de preço (buscarPrecoExc)
  dataUltAtualPreco?: string;    // TGFEXC.DHALTREG do registro de preço mais recente (dd/MM/yyyy)
  limitePrazoAtualDias?: number; // TGFMAR.AD_PRAZO_ATUAL_DIAS do fabricante do produto
  precoDesatualizado?: boolean;
  // true quando o VALOR negociado no item (Vl. Unit. U$, ou Vl. Unit. R$ se
  // fabricante70) diverge do VLRVENDA ATUAL da TGFEXC — diferente de
  // precoDesatualizado acima (que só olha a DATA do registro, "há quanto
  // tempo ninguém mexe no catálogo"). Um catálogo pode ter sido atualizado
  // AGORA (registro "novo", precoDesatualizado=false) enquanto o item ainda
  // carrega um valor negociado ANTIGO — esse flag pega esse caso.
  precoDivergenteCatalogo?: boolean;
  origem?: string;               // TGFMAR.AD_ORIGEM (texto bruto) — exibido para o vendedor (informativo)
  /** true quando TGFPRO.CODMARCA = 70 — para este fabricante o vendedor informa
   *  o preço diretamente em Vl. Unit. R$ e o Vl. Unit. U$ é calculado de forma
   *  inversa (R$ ÷ cotação do dia), ao contrário do fluxo normal. */
  fabricante70?: boolean;
  precoUnitarioStr?: string;     // texto digitado no Vl. Unit. R$ quando fabricante70 (evita cursor pular)
  // Produto controlado (venda limitada por tipo de documento do cliente) — TGFPRO
  controlado?: boolean;          // GPL_CONTROLADO = 'S'
  ctrlLimPf?: number;            // GPL_CTRL_LIM_PF — limite de quantidade/mês para cliente CPF
  ctrlLimPj?: number;            // GPL_CTRL_LIM_PJ — limite de quantidade/mês para cliente CNPJ
  controladoBloqueado?: boolean; // true quando qtd (deste item, ou já vendido no mês + este item) excede o limite
  controladoMensagem?: string;   // mensagem detalhada (com NUNOTA das vendas do mês) — usada no bloqueio de salvar()
  // Local de estoque escolhido pra este item — inicia igual a codlocalpadrao,
  // mas o usuário pode trocar clicando na coluna "Local" (ver seletorLocal*).
  codlocal?: number;             // CODLOCAL que vai pro payload (TGFITE.CODLOCALORIG)
  descrLocal?: string;           // texto exibido ("5-D-4" etc.) — só carregado ao abrir o seletor (ou vindo do modo edição)
}

/** Uma linha lida do Excel para importação de itens. */
interface ExcelImportRow {
  pn: string;           // PN lido do Excel (coluna A)
  quantidade: number;   // Quantidade lida do Excel (coluna B)
  status: 'pendente' | 'encontrado' | 'nao_encontrado';
  descricao?: string;   // Descrição preenchida após validação
  codprodInterno?: number;
  codlocalpadrao?: number;
  prodData?: any;       // Objeto completo retornado pelo backend — usado em _preencherItemComProduto
  proximosData?: any[]; // Resultados aproximados quando não há match exato (para o usuário escolher)
  /** Usado apenas quando excelImportOrigemOS — indica se a linha (encontrada)
   *  deve ser incluída na gravação. undefined/true = incluída (padrão). */
  selecionado?: boolean;
  /** Desconto (positivo) / acréscimo (negativo) em R$ vindo da Venda do Sistema
   *  Legado/Aerosys — já com o sinal invertido pra nossa convenção (ver
   *  itensImportadosDeOS). Aplicado ao item em confirmarImportacaoExcel(). */
  vlrDescAcresc?: number;
}

interface ComissaoItem {
  codpco: number;
  codparc: number;
  nomeparc: string;
  perccomissao: number;
  datacriacao?: string;
}

interface VendedorOpcao {
  codVend: string | number;
  apelido: string;
}

// @ts-ignore
@Component({
  selector: 'app-pedido-venda',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule, MoneyMaskDirective],
  templateUrl: './pedido-venda.component.html',
  styleUrls: [
    '../../shared/styles/pedido-form-shared.css',
    '../../shared/styles/busca-pecas-shared.css',
    './pedido-venda.component.css',
  ]
})
export class PedidoVendaComponent implements OnInit, OnDestroy {

  @Output() voltarLista = new EventEmitter<void>();
  @Output() abaSelecionada = new EventEmitter<string>();
  /** Emitido quando um pedido vindo de "Gerar Venda a Partir da O.S" é gravado
   *  automaticamente — o gateway deve abrir esse pedido já selecionado. */
  @Output() osVendaGravada = new EventEmitter<number>();

  // ── Modo edição ─────────────────────────────────────────────
  // @Input() é definido como propriedade simples; a lógica de edição
  // é iniciada em ngOnInit (após Angular garantir que o valor está definido).
  @Input() nunotaEditar: number | null = null;
  modoEdicao     = false;
  nunotaAtual: number | null = null;
  carregandoEdicao = false;

  // ── Rascunho silencioso p/ cálculo real de impostos (IPI/ICMS-ST) ──
  // Enquanto o usuário lança itens num pedido NOVO (ainda não salvo), com
  // cliente já selecionado, gravamos o cabeçalho + itens em segundo plano
  // (sem o usuário perceber) só para o ImpostosHelpper nativo poder calcular
  // IPI/ST de verdade — a estimativa local em calcularTotal() só cobre IPI
  // de forma aproximada e nunca calcula ICMS-ST. Quando o usuário salva de
  // verdade, o MESMO NUNOTA é reaproveitado (UPDATE) — nunca duplica pedido.
  // Se a tela for fechada sem salvar, o rascunho é marcado CANCELADO
  // (ver _descartarRascunhoAbandonado) para não sobrar um ABERTO órfão.
  private nunotaRascunho: number | null = null;
  private _rascunhoEmAndamento = false;
  private _ultimoPayloadRascunho: any = null;
  private _rascunhoSubject = new Subject<void>();
  private _rascunhoSubscription?: Subscription;

  /** Quando true (aberto como modal "Editar Dados da Venda" pela Lista de
   *  Pedidos), restringe a tela apenas à aba Dados (cliente, endereço,
   *  aeronave, tipo negociação, observações) — Itens e Comissionado ficam
   *  ocultos e intocados; a gravação reaproveita o fluxo normal de salvar(). */
  @Input() somenteCabecalho = false;

  /** Quando true (aberto via "Status ▸ Finalizar Venda" na Lista de Pedidos,
   *  só habilitado com GPL_STATUS=PRONTO), o botão "Salvar Alterações" desta
   *  tela grava o GPL_STATUS como 'FINALIZADO' em vez de manter o valor
   *  atual do pedido — ver salvar() e _montarPayloadPedido(). */
  @Input() forcarFinalizarAoSalvar = false;

  // ── Importação de itens a partir de uma O.S (Gerar Venda a Partir da O.S) ──
  // Preenchido pelo gateway antes de navegar para um pedido NOVO; reaproveita
  // o mesmo mecanismo de revisão/validação da importação de Excel.
  // vlrDescAcresc: só vem preenchido quando a origem é uma Venda do Sistema
  // Legado/Aerosys (ver onSelecionarVendaLegado em gateway.component.ts) — já
  // com o sinal invertido pra nossa convenção (positivo=desconto, negativo=
  // acréscimo). O.S. não tem esse campo.
  @Input() itensImportadosDeOS: { pn: string; quantidade: number; vlrDescAcresc?: number }[] | null = null;
  @Input() observacaoInicial: string | null = null;
  /** Dados da O.S. de origem, para pré-preencher Cliente e Aeronave automaticamente. */
  @Input() origemOS: {
    numOs?: string | number;
    empresaNome?: string;
    clienteNome?: string;
    aeronaveMatricula?: string;
  } | null = null;

  // ── Ação de status "silenciosa" (Cancelar leve / Estornar, disparados pela
  // Lista de Pedidos) — carrega o pedido em segundo plano, troca só o(s)
  // campo(s) de status e grava, sem o vendedor nunca ver o formulário.
  @Input() acaoStatusPendente: {
    nunota: number;
    novoGplStatus: string;
    novoCodTipOper?: number;
  } | null = null;
  @Output() acaoStatusConcluida = new EventEmitter<{ nunota: number; sucesso: boolean; mensagem?: string }>();
  /** Controla o overlay que cobre a tela inteira durante a ação silenciosa. */
  acaoStatusGravando = false;
  /** Enquanto true, salvar() não dispara sua navegação padrão (voltarLista/
   *  osVendaGravada) — quem decide a navegação é _executarAcaoStatusSilenciosa. */
  private _suprimirNavegacaoAutomatica = false;

  // ── Cabeçalho ──────────────────────────────────────────────
  clienteBusca = '';
  clienteSelecionado: ClienteSugestao | null = null;
  clienteSugestoes: ClienteSugestao[] = [];
  clienteCarregando = false;
  mostrarDropdownCliente = false;
  private _clienteTimer: any = null;
  /** Guarda o cliente selecionado antes de limpar o campo ao focar, para
   *  poder restaurá-lo se o usuário clicar fora sem digitar/escolher nada. */
  private _clienteAnterior: ClienteSugestao | null = null;

  /** Snapshot completo do estado carregado para o cliente anterior — permite
   *  restaurar sem re-chamar os serviços, preservando seleções já feitas. */
  private _snapshotCliente: {
    endFaturamento: Endereco;
    endEntrega: Endereco;
    endEntregaIgualFaturamento: boolean;
    mostrarEnderecos: boolean;
    aeronaveOpcoes: any[];
    aeronaveSelecionada: string | number;
    aeronaveBusca?: string;
    enderecosDisponiveis: EnderecoDisponivel[];
    enderecosEntregaDisponiveis: EnderecoDisponivel[];
    codparcFaturamentoSelecionado: string | number;
    codparcEntregaSelecionado: string | number;
    pessoaEntregaSelecionada: ClienteSugestao | null;
    pessoaEntregaBusca: string;
    titulosPessoaEntregaPosicionados: TituloClientePosicionado[];
    creditoInfo: any;
    titulosClientePosicionados: TituloClientePosicionado[];
  } | null = null;

  // Modal de seleção de produto (PN duplicado)
  produtoModalAberta = false;
  produtoModalLista: any[] = [];
  private _produtoModalItem: ItemPedido | null = null;

  // Modal de busca avançada de peças (Enter vazio / F3)
  private _buscaPecasItem: ItemPedido | null   = null;
  /** Referência ao input do PN que disparou a abertura do modal (para devolver o foco ao fechar) */
  private _buscaPecasPnInputOrigem: HTMLInputElement | null = null;
  buscaPecasAberta        = false;
  buscaPecasTermo         = '';
  buscaPecasResultados: any[] = [];
  buscaPecasCarregando    = false;
  buscaPecasSemResultado  = false;
  // Produto selecionado dentro da lista (highlight + painel de estoque) — pode ser
  // o produto principal OU um alternativo, dependendo de qual foi clicado por último.
  buscaPecasProdutoSelecionado: any | null = null;
  // Produto principal cuja sub-lista de alternativos está expandida na tela. Fica
  // fixo no produto principal mesmo quando o usuário clica em um alternativo — só
  // assim a lista de alternativos continua visível ao selecionar um deles (senão a
  // tela "recolhe": o *ngIf da sub-lista dependia de buscaPecasProdutoSelecionado).
  buscaPecasProdutoExpandido: any | null = null;
  buscaPecasLocais: { codLocal: number; codemp: number; nomeEmp: string; descrLocal: string; qtdTotal: number; qtdReservada: number; disponivel: number }[] = [];
  buscaPecasLocaisCarregando = false;
  buscaPecasAlternativos: any[] = [];
  buscaPecasAlternativosCarregando = false;
  // Imagem do produto selecionado (painel lateral direito) — reaproveita o mesmo
  // serviço/campo "principal" (TGFPRO.IMAGEM) já usado na Edição de Produtos.
  buscaPecasImagemUrl: string | null = null;
  buscaPecasImagemCarregando = false;
  private _buscaPecasImagemToken = 0;
  // Todas as imagens do produto (principal do TGFPRO + histórico do GPL_PRODUTOSIMG),
  // usadas para montar a faixa de miniaturas e navegar no preview ampliado.
  buscaPecasImagensExtras: string[] = [];
  buscaPecasImagemIndexAtivo = 0;
  // Preview ampliado (lightbox) ao clicar na imagem do painel lateral.
  imagemPreviewAberta = false;

  /** Abre o preview ampliado da imagem já carregada no painel lateral. */
  abrirPreviewImagemBusca(): void {
    if (!this.buscaPecasImagemUrl) return;
    this.imagemPreviewAberta = true;
  }

  fecharPreviewImagemBusca(): void {
    this.imagemPreviewAberta = false;
  }

  /** Troca a imagem em destaque (painel lateral e preview ampliado) pela de índice `index`. */
  selecionarImagemBusca(index: number): void {
    if (index < 0 || index >= this.buscaPecasImagensExtras.length) return;
    this.buscaPecasImagemIndexAtivo = index;
    this.buscaPecasImagemUrl = this.buscaPecasImagensExtras[index];
  }

  /** Navega pra imagem anterior/próxima dentro do preview ampliado (quando há mais de uma). */
  imagemPreviewNavegar(passo: 1 | -1, event?: Event): void {
    event?.stopPropagation();
    const total = this.buscaPecasImagensExtras.length;
    if (total < 2) return;
    const novo = (this.buscaPecasImagemIndexAtivo + passo + total) % total;
    this.selecionarImagemBusca(novo);
  }
  private _buscaPecasSubject = new Subject<string>();
  /** Token da busca em andamento: respostas de buscas antigas (digitação rápida) são descartadas. */
  private _buscaPecasToken = 0;
  private _buscaPecasTermoExecutado = '';
  private _buscaPecasUltimaExecucao = 0;
  private _buscaPecasSubscription?: Subscription;

  // Busca de Cliente via modal (lupa), igual ao padrão Marca/Vendedor/Grupo
  clienteModalAberta = false;
  filtroClienteModal = '';
  clienteSugestoesModal: ClienteSugestao[] = [];
  clienteModalCarregando = false;
  private _clienteModalTimer: any = null;

  /**
   * Títulos (CNPJ/CPF, COM, Insc. Estadual) posicionados acima do trecho
   * correspondente dentro do input do Cliente. Como tudo fica em um único
   * texto ("Nome | Doc | AD_COM | IE"), a posição de cada título é calculada
   * dinamicamente medindo a largura real do texto (canvas), para acompanhar
   * nomes de tamanhos diferentes. Só inclui os campos que o cliente tiver.
   */
  titulosClientePosicionados: TituloClientePosicionado[] = [];

  /** Largura, em px, do texto até o início do input (ícone de lupa + padding).
   *  Precisa bater EXATAMENTE com o CSS real do .form-input (.input-icon-wrap
   *  .form-input { padding-left: 32px } e .form-input { font-size: 14px } —
   *  ver pedido-venda.component.css) pro canvas medir o mesmo texto que o
   *  navegador desenha. Estavam em 34px/13px (bug: título ficava desalinhado,
   *  "puxado" pra esquerda — o desvio crescia com o tamanho do nome do
   *  cliente porque a fonte usada pra medir era menor que a real). */
  private readonly CLIENTE_INPUT_TEXT_START_PX = 33.5; // border-left (1.5px) + padding-left (32px) do .form-input
  private readonly CLIENTE_INPUT_FONT = '400 14px "Segoe UI", Roboto, Arial, sans-serif';
  private _clienteCanvasCtx: CanvasRenderingContext2D | null = null;
  // Fonte/canvas usados só pra medir a largura do RÓTULO principal (Cliente/
  // Pessoa de Entrega/Transportadora/Parceiro) -- necessário pra evitar que
  // os títulos extras (CNPJ/CPF, COM, Insc. Estadual), que são posicionados
  // a partir da largura do NOME do parceiro, fiquem por baixo do próprio
  // rótulo quando o nome é mais curto que o texto do rótulo (ex.: "Pessoa
  // de Entrega" é mais largo que "GOIAS AVIACAO").
  private readonly CLIENTE_LABEL_FONT = '700 12px "Segoe UI", Roboto, Arial, sans-serif';
  private _labelCanvasCtx: CanvasRenderingContext2D | null = null;

  /** Largura mínima (em px, a partir do início do rótulo) que os títulos
   *  extras devem respeitar pra não ficar embaixo do texto do rótulo
   *  principal -- soma a largura do texto do rótulo (medida via canvas,
   *  já que letter-spacing não é medido pelo canvas, com folga extra pra
   *  compensar) + espaço do ícone inline quando existir (só Pessoa de
   *  Entrega tem ícone dentro do <label>). */
  private _larguraMinimaRotulo(texto: string, temIconeInline: boolean): number {
    if (!this._labelCanvasCtx) {
      const c = document.createElement('canvas');
      this._labelCanvasCtx = c.getContext('2d');
    }
    const ctx = this._labelCanvasCtx;
    if (!ctx) return 0;
    ctx.font = this.CLIENTE_LABEL_FONT;
    const largura = ctx.measureText(texto.toUpperCase()).width;
    const espacoIcone = temIconeInline ? 22 : 0; // ícone (~13px) + gap (5px) + folga
    const folgaLetterSpacing = 14; // canvas não mede letter-spacing: 0.5px por char
    return this.CLIENTE_INPUT_TEXT_START_PX + largura + espacoIcone + folgaLetterSpacing;
  }

  /** Ponto X (a partir da borda externa do input, em px) onde o TEXTO do
   *  input deve começar, pra cada campo. Igual ao padrão (33.5px) na
   *  maioria dos casos -- só aumenta (empurrando o padding-left do input
   *  junto, via [style.padding-left.px] no template) quando o NOME
   *  selecionado é tão curto que o primeiro título extra (CNPJ/CPF) ficaria
   *  por baixo do próprio rótulo (ex.: "Pessoa de Entrega" é mais largo que
   *  "GOIAS AVIACAO"). Recalculado a cada seleção em
   *  _calcularStartXInput -- NÃO é um valor fixo por campo, senão nomes
   *  longos (maioria dos casos) ficavam com um padding-left artificialmente
   *  grande e um vão feio entre o ícone de busca e o texto. */
  clienteInputStartX       = this.CLIENTE_INPUT_TEXT_START_PX;
  pessoaEntregaInputStartX = this.CLIENTE_INPUT_TEXT_START_PX;
  transpInputStartX        = this.CLIENTE_INPUT_TEXT_START_PX;
  comissaoInputStartX      = this.CLIENTE_INPUT_TEXT_START_PX;

  /** startX = maior entre o padrão (33.5px) e (largura mínima do rótulo -
   *  largura do nome) -- ou seja, só empurra o suficiente pra o 1º título
   *  extra não ficar embaixo do rótulo; se o nome já é largo o bastante
   *  sozinho, o resultado cai de volta no padrão. */
  private _calcularStartXInput(labelTexto: string, temIconeInline: boolean, larguraNome: number): number {
    const larguraMinimaRotulo = this._larguraMinimaRotulo(labelTexto, temIconeInline);
    return Math.max(this.CLIENTE_INPUT_TEXT_START_PX, larguraMinimaRotulo - larguraNome);
  }

  // Campos de opções do TGFCAB (TDDCAM/TDDOPC) — mesmo padrão para todos:
  // Prioridade, Despachar, Faturamento Imediato e Tipo.
  prioridade = 'NORMAL';
  prioridadeOpcoes: OpcaoCampo[] = [];

  /** % Comissão (TGFCAB.GPL_COMISSAO) — nunca pode ficar vazio; se ficar
   *  vazio ou com um valor inválido, volta pro padrão de 2%. */
  gplComissao: number = 2;

  /** Normaliza o % Comissão ao sair do campo: nunca vazio/inválido/negativo
   *  (volta pro padrão de 2%), nunca acima de 100%. */
  onBlurGplComissao(): void {
    const valor = Number(this.gplComissao);
    this.gplComissao = (this.gplComissao === null || this.gplComissao === undefined || isNaN(valor) || valor < 0)
      ? 2
      : Math.min(valor, 100);
  }

  // ── Transporte ──────────────────────────────────────────────
  tipFrete = '';
  tipFreteOpcoes: OpcaoCampo[] = [];
  codParcTransp: number | null = null;
  transpBusca = '';
  transpSugestoes: ClienteSugestao[] = [];
  transpSelecionada: ClienteSugestao | null = null;
  transpCarregando = false;
  mostrarDropdownTransp = false;
  titulosTranspPosicionados: TituloClientePosicionado[] = [];
  private _transpTimer: any = null;
  private _transpCanvasCtx: CanvasRenderingContext2D | null = null;
  private _transpAnterior: ClienteSugestao | null = null;
  cifFob = '';
  cifFobOpcoes: OpcaoCampo[] = [];
  formaEnvio = '';
  formaEnvioOpcoes: OpcaoCampo[] = [];
  qtdVol: number | null = null;
  pesoBruto: number | null = null;
  vlrFrete: number | null = null;
  vlrFreteTotalTransporte: number | null = null;

  // Desconto geral no cabeçalho (TGFCAB)
  vlrDescGeral: number | null = null;  // VLRDESCTOT
  percDescGeral: number | null = null; // PERCDESC
  /** Quando true, vlrDescGeral é espelho de totalDesconto (não subtrai novamente em totalPedido). */
  private _vlrDescGeralEhEspelho = false;
  /** "Outros" (TGFCAB.VLROUTROS) — editável na área de Totais, soma no totalPedido.
   *  Pré-preenchido automaticamente com a soma do desc/acréscimo dos itens quando
   *  o pedido vem de uma importação do Sistema Legado/Aerosys (ver
   *  onSelecionarVendaLegado em gateway.component.ts + confirmarImportacaoExcel
   *  abaixo), mas pode ser editado livremente depois — o que estiver na tela ao
   *  salvar é o que grava em VLROUTROS (ver _montarPayloadPedido). */
  vlrOutros: number = 0;

  /** Getter/setter para o campo Desc. Geral em U$ — converte via cotação ao editar. */
  get vlrDescGeralUsd(): number | null {
    const cambio = this.cotacaoValorNumerico;
    if (!cambio || this.vlrDescGeral == null) return null;
    return parseFloat((this.vlrDescGeral / cambio).toFixed(2));
  }
  set vlrDescGeralUsd(val: number | null) {
    const cambio = this.cotacaoValorNumerico;
    if (val == null) {
      // Campo apagado: zera igual aos campos % e R$ (senão o getter recalcula
      // a partir do vlrDescGeral antigo e o valor "volta" na tela).
      this.vlrDescGeral = 0;
      this.onDescGeralVlrChange();
      return;
    }
    if (!cambio) return;
    this.vlrDescGeral = parseFloat((val * cambio).toFixed(2));
    this.onDescGeralVlrChange();
  }

  // Input editável do Total do Pedido R$ — dispara rateio de desconto entre itens
  totalPedidoDesejadoStr: string = '';

  // ── Modal de aviso simples (OK) ──────────────────────────────────────────
  modalAvisoAberto   = false;
  modalAvisoMensagem = '';

  /** Callback opcional executado ao fechar o modal de aviso (ex.: devolver o
   *  foco pro campo de quantidade depois do aviso de preço desatualizado). */
  private _modalAvisoOnFechar: (() => void) | null = null;

  fecharModalAviso(): void {
    this.modalAvisoAberto = false;
    const cb = this._modalAvisoOnFechar;
    this._modalAvisoOnFechar = null;
    cb?.();
  }

  private _abrirModalAviso(mensagem: string, onFechar?: () => void): void {
    this.modalAvisoMensagem = mensagem;
    this.modalAvisoAberto   = true;
    this._modalAvisoOnFechar = onFechar ?? null;
    // Foca o OK -- além do Enter já fechar o modal direto (ver
    // onEnterKeyModalAviso), isso deixa visualmente claro que o Enter vai
    // confirmar, sem o usuário precisar tirar a mão do teclado.
    setTimeout(() => document.getElementById('pv-modal-aviso-ok')?.focus(), 60);
  }

  /** Foca (e seleciona) o campo Qtd da linha correspondente ao item — mesma
   *  lógica usada ao terminar de carregar um produto novo (ver
   *  _buscarPrecoExcItem), reaproveitada para devolver o foco após modais
   *  de aviso que interrompem o fluxo (ex.: preço desatualizado). */
  private _focarQtdDoItem(item: ItemPedido): void {
    setTimeout(() => {
      const idx = this.itens.indexOf(item);
      const rows = document.querySelectorAll<HTMLElement>('.itens-table tbody tr');
      const qtd = rows[idx]?.querySelector<HTMLInputElement>('.cell-qtd-input');
      qtd?.focus();
      qtd?.select();
    }, 50);
  }

  // ---- Seletor de Local de estoque (coluna "Local" da grade de itens) ----
  // Permite trocar, por item, o local de onde o produto será baixado
  // (CODLOCALORIG). Por padrão vem preenchido com codlocalpadrao do produto.
  seletorLocalItemId: number | null = null;
  seletorLocalOpcoes: { codLocal: number; codemp: number; nomeEmp: string; descrLocal: string; qtdTotal?: number; qtdReservada?: number; disponivel: number }[] = [];
  seletorLocalCarregando = false;

  async abrirSeletorLocal(item: ItemPedido, event: Event): Promise<void> {
    event.stopPropagation();
    if (this.seletorLocalItemId === item.id) {
      this.fecharSeletorLocal();
      return;
    }
    this.seletorLocalItemId = item.id;
    this.seletorLocalOpcoes = [];
    if (!item.codprodInterno) { return; }
    this.seletorLocalCarregando = true;
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarEstoquePorLocal(item.codprodInterno));
      const body = res?.responseBody ?? res;
      this.seletorLocalOpcoes = body?.locais ?? [];
    } catch (err) {
      console.warn('[PedidoVenda] Falha ao buscar locais de estoque:', err);
      this.seletorLocalOpcoes = [];
    } finally {
      this.seletorLocalCarregando = false;
    }
  }

  fecharSeletorLocal(): void {
    this.seletorLocalItemId = null;
    this.seletorLocalOpcoes = [];
  }

  selecionarLocalItem(item: ItemPedido, opcao: { codLocal: number; descrLocal: string }): void {
    item.codlocal = opcao.codLocal;
    item.descrLocal = opcao.descrLocal;
    this.fecharSeletorLocal();
  }

  // ── Modal de conflito: desconto/acréscimo existente ao editar total ──────
  modalConflitoAberto    = false;
  modalConflitoMensagem  = '';
  modalConflitoOp1Label  = '';
  modalConflitoOp2Label  = '';
  private _modalConflitoCallback:
    ((op: 'op1' | 'op2' | 'cancelar') => void) | null = null;

  onModalConflito(op: 'op1' | 'op2' | 'cancelar'): void {
    this.modalConflitoAberto = false;
    this._modalConflitoCallback?.(op);
    this._modalConflitoCallback = null;
  }

  private _abrirModalConflito(
    mensagem: string,
    op1: string,
    op2: string,
    callback: (op: 'op1' | 'op2' | 'cancelar') => void
  ): void {
    this.modalConflitoMensagem = mensagem;
    this.modalConflitoOp1Label = op1;
    this.modalConflitoOp2Label = op2;
    this._modalConflitoCallback = callback;
    this.modalConflitoAberto = true;
  }


  // Aba Comissões
  comissoes: ComissaoItem[] = [];
  comissaoBusca = '';
  comissaoSugestoes: ClienteSugestao[] = [];
  comissaoUsuarioSelecionado: ClienteSugestao | null = null;
  comissaoCarregando = false;
  mostrarDropdownComissao = false;
  comissaoPerc: number | null = null;
  comissaoSalvando = false;
  comissaoErro = '';
  titulosComissaoPosicionados: TituloClientePosicionado[] = [];
  private _comissaoTimer: any = null;
  private _comissaoCanvasCtx: CanvasRenderingContext2D | null = null;
  private _comissaoAnterior: ClienteSugestao | null = null;

  despachar = '';
  despacharOpcoes: OpcaoCampo[] = [];

  fatImediato = '';
  fatImediatoOpcoes: OpcaoCampo[] = [];

  tipoGpl = '';
  tipoGplOpcoes: OpcaoCampo[] = [];

  // Alguns valores de campos LISTA (GPL_TIPO, GPL_DESPACHAR, GPL_FATIMEDIATO,
  // GPL_FORMAENVIO, GPL_STATUS) ficaram com o texto de exibição corrompido na
  // origem (DataDictionary GPL/datadictionary/CabecalhoDaNota.xml salvo com
  // caracteres substituídos/irrecuperáveis -- já corrigido lá, mas o Oracle
  // ainda mantém o TDDOPC.OPCAO antigo até o DataDictionary ser reaplicado no
  // Sankhya). Enquanto isso não acontece, ignoramos o texto vindo do banco
  // pra esses valores conhecidos e usamos o texto correto direto -- o
  // "valor" (código) sempre veio íntegro, só o "opcao" (rótulo) que quebrava.
  private readonly _textosOpcaoCorrigidos: Record<string, string> = {
    NAO:                 'NÃO',
    IMPORTACAO:          'IMPORTAÇÃO',
    PAC:                 'PAC - ENCOMENDA ECONÔMICA',
    VOO:                 'PRÓXIMO VOO',
    DIA:                 'PRÓXIMO DIA',
    CARGOAMANHA:         'CARGO AMANHÃ',
    DOMICILIO:           'ENTREGA A DOMICÍLIO',
    SEPARACAO:           'SEPARAÇÃO',
    'SEPARACAO TOTAL':   'SEPARAÇÃO TOTAL',
  };

  /** Usar no lugar de `o.opcao` em qualquer <option> de campo LISTA do Sankhya. */
  corrigirTextoOpcao(o: OpcaoCampo): string {
    return this._textosOpcaoCorrigidos[o.valor] ?? o.opcao;
  }

  // TGFCAB.AD_CATEGORIA — Receita ou Transferência. Selecionar Transferência
  // troca automaticamente o Tipo de Operação para a TOP 1152 (ver
  // onAdCategoriaChange) — a venda nasce direto nessa TOP (nunca passa por
  // Orçamento/1000) mas segue o mesmo fluxo de Autorização/Separação/
  // Conferência de um Pedido de Venda normal. Autorizar não tenta converter
  // a TOP quando ela já é 1152 (ver autorizarPedido no GPL/model).
  adCategoria = '';
  adCategoriaOpcoes: OpcaoCampo[] = [];

  gplStatus = 'ABERTO';
  gplStatusOpcoes: OpcaoCampo[] = [];
  modoSomenteLeitura = false;

  /** true quando o gplStatus atual não está entre as opções cadastradas no
   *  domínio GPL_STATUS do Sankhya (ex.: CANCELADO ainda não configurado lá)
   *  — usado só para exibir um fallback no <select> somente leitura. */
  gplStatusNaoListado(): boolean {
    return this.gplStatusOpcoes.length > 0
      && !this.gplStatusOpcoes.some(o => o.valor === this.gplStatus);
  }

  tipoOperacao = '';
  dataEmissao = '';
  dtNegociacao = '';

  /** Data de hoje em formato ISO (yyyy-MM-dd), calculada localmente (não
   *  toISOString, que é UTC e vira o dia seguinte após 21h no Brasil).
   *  Usada como teto do campo Data de Negociação (não aceita data futura). */
  get hojeIso(): string {
    const hoje = new Date();
    const yyyy = hoje.getFullYear();
    const mm = String(hoje.getMonth() + 1).padStart(2, '0');
    const dd = String(hoje.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  /** Bloqueia Data de Negociação futura: se o usuário digitar/colar uma data
   *  maior que hoje, avisa e volta pra data de hoje. */
  onChangeDtNegociacao(): void {
    if (this.dtNegociacao && this.dtNegociacao > this.hojeIso) {
      this._abrirModalAviso('A Data de Negociação não pode ser maior que a data de hoje.');
      this.dtNegociacao = this.hojeIso;
    }
  }
  // TGFCAB.NUMPEDIDO2 — texto livre, fica acima da Observação.
  numPedido2 = '';
  // TGFCAB.AD_OBS — Observação Venda, fica acima das demais observações.
  adObs = '';
  observacao = '';
  // TGFCAB.AD_OBSINT — fica ao lado da Observação (Nota) na mesma linha.
  observacaoInterna = '';
  /** Nº Título (TGFCAB.AD_NUMTITULO) — gerado pelo addon ao gravar se vazio. */
  numTitulo = '';
  // TGFCAB.AD_FRETEOBS — Observação Frete, fica abaixo do Vlr. Frete na aba frete.
  adFreteObs = '';

  // Tipo Negociação (Condição de Pagamento — TGFTPV), entre Vendedor e Cotação.
  // Mesmo padrão da Marca (Duplicar Produto): input editável mostrando
  // "CÓDIGO - Descrição" — digitar altera só o código, a lupa abre modal
  // com a lista completa (filtrável). Padrão: código 1 = A VISTA DINHEIRO.
  tiposNegociacaoOpcoes: { codTipVenda: string | number; descricao: string }[] = [
    { codTipVenda: '1', descricao: 'A VISTA DINHEIRO' },
  ];
  tipoNegociacaoSelecionado: string | number = '1';
  tiposNegociacaoCarregando = false;
  tipoNegociacaoModalAberta = false;
  filtroTipoNegociacao = '';

  get tiposNegociacaoFiltradas(): { codTipVenda: string | number; descricao: string }[] {
    const termo = this.filtroTipoNegociacao.trim().toUpperCase();
    let base = this.tiposNegociacaoOpcoes;

    if (this.clienteSelecionado?.bloquear === 'S') {
      base = base.filter(t => {
         const desc = String(t.descricao).toUpperCase();
         return desc.includes('A VISTA DINHEIRO') || desc.includes('PIX');
      });
    }

    if (!termo) {
      return base;
    }
    return base.filter(t => (t.descricao || '').toUpperCase().includes(termo));
  }

  /** Retorna a descrição de uma condição de pagamento (CODTIPVENDA) pelo código. */
  descricaoTipoNegociacao(codigo: string | number): string {
    const codigoAtual = String(codigo ?? '').trim();
    const opcao = this.tiposNegociacaoOpcoes.find(t => String(t.codTipVenda) === codigoAtual);
    return opcao ? opcao.descricao : '';
  }

  /** Valor exibido no input: "CÓDIGO - Descrição", igual ao campo Marca. */
  valorExibidoTipoNegociacao(codigo: string | number): string {
    const codigoAtual = String(codigo ?? '').trim();
    const descricao = this.descricaoTipoNegociacao(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  /** Valor selecionado antes do usuário clicar no campo (pra reverter se
   *  clicar fora sem digitar nada) e flag indicando se já digitou algo
   *  desde o foco — usados por onFocus/onInput/onBlur de Tipo Negociação. */
  private _tipoNegFocoValor: string | number = '1';
  private _tipoNegTeveInput = false;

  /** Limpa o campo ao ganhar foco/clique, guardando o valor atual pra
   *  poder voltar caso o usuário clique fora sem digitar nada. */
  onFocusTipoNegociacao(event: Event): void {
    const input = event.target as HTMLInputElement;
    this._tipoNegFocoValor = this.tipoNegociacaoSelecionado;
    this._tipoNegTeveInput = false;
    input.value = '';
  }

  /**
   * Disparado a cada tecla digitada — considera código apenas o trecho
   * antes do primeiro " - " (igual ao onInputMarca do Duplicar Produto) e
   * reescreve o valor exibido com a descrição já atualizada. Só aceita a
   * tecla se o código resultante ainda for prefixo de algum código válido
   * da lista -- impede digitar um valor que não existe.
   */
  onInputTipoNegociacao(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;

    const idx = valorDigitado.indexOf(' - ');
    let novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

    this._tipoNegTeveInput = true;

    const valido = novoCodigo === '' ||
      this.tiposNegociacaoOpcoes.some(t => String(t.codTipVenda).startsWith(novoCodigo));
    if (!valido) {
      // Código digitado não é prefixo de nenhum válido -- rejeita a tecla.
      novoCodigo = String(this.tipoNegociacaoSelecionado ?? '');
    }

    this.tipoNegociacaoSelecionado = novoCodigo;

    const novoValor = this.valorExibidoTipoNegociacao(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  /** Ao sair do campo: se não digitou nada, volta pro valor anterior; se
   *  digitou algo que não é um código válido da lista, também volta pro
   *  anterior. Se for válido, mantém (e ainda aplica a regra de cliente
   *  bloqueado, que força A VISTA DINHEIRO/PIX). */
  onBlurTipoNegociacao(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!this._tipoNegTeveInput) {
      this.tipoNegociacaoSelecionado = this._tipoNegFocoValor;
    } else {
      const codigoAtual = String(this.tipoNegociacaoSelecionado ?? '').trim();
      const valido = codigoAtual !== '' &&
        this.tiposNegociacaoOpcoes.some(t => String(t.codTipVenda) === codigoAtual);
      if (!valido) {
        this.tipoNegociacaoSelecionado = this._tipoNegFocoValor;
      }
    }

    if (this.clienteSelecionado?.bloquear === 'S') {
        const item = this.tiposNegociacaoOpcoes.find(t => String(t.codTipVenda) === String(this.tipoNegociacaoSelecionado));
        if (item) {
           const desc = String(item.descricao).toUpperCase();
           if (!desc.includes('A VISTA DINHEIRO') && !desc.includes('PIX')) {
                this.tipoNegociacaoSelecionado = '1';
           }
        } else {
            this.tipoNegociacaoSelecionado = '1';
        }
    }

    input.value = this.valorExibidoTipoNegociacao(this.tipoNegociacaoSelecionado);
  }

  async abrirBuscaTipoNegociacao(): Promise<void> {
    this.filtroTipoNegociacao = '';
    this.tipoNegociacaoModalAberta = true;
    await this._carregarTiposNegociacao();
  }

  fecharBuscaTipoNegociacao(): void {
    this.tipoNegociacaoModalAberta = false;
  }

  selecionarTipoNegociacao(t: { codTipVenda: string | number; descricao: string }): void {
    this.tipoNegociacaoSelecionado = t.codTipVenda;
    this.tipoNegociacaoModalAberta = false;
  }

  limparTipoNegociacao(): void {
    this.tipoNegociacaoSelecionado = '';
  }

  // Centro de Resultado (TGFCEN — TGFCAB.CODCENCUS). Mesmo padrão do Tipo
  // Negociação/Vendedor: input editável "CÓDIGO - Descrição" + lupa com
  // modal de busca. Padrão: 202000 - VENDAS.
  centrosResultadoOpcoes: { codCen: string | number; descricao: string }[] = [
    { codCen: '0',      descricao: '' },
    { codCen: '202000', descricao: 'VENDAS' },
  ];
  centroResultadoSelecionado: string | number = '202000';
  centrosResultadoCarregando = false;
  centroResultadoModalAberta = false;
  filtroCentroResultado = '';

  get centrosResultadoFiltrados(): { codCen: string | number; descricao: string }[] {
    const termo = this.filtroCentroResultado.trim().toUpperCase();
    if (!termo) {
      return this.centrosResultadoOpcoes;
    }
    return this.centrosResultadoOpcoes.filter(c => (c.descricao || '').toUpperCase().includes(termo));
  }

  descricaoCentroResultado(codigo: string | number): string {
    const codigoAtual = String(codigo ?? '').trim();
    const opcao = this.centrosResultadoOpcoes.find(c => String(c.codCen) === codigoAtual);
    return opcao ? opcao.descricao : '';
  }

  valorExibidoCentroResultado(codigo: string | number): string {
    const codigoAtual = String(codigo ?? '').trim();
    const descricao = this.descricaoCentroResultado(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  onInputCentroResultado(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;

    const idx = valorDigitado.indexOf(' - ');
    const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

    this.centroResultadoSelecionado = novoCodigo;

    const novoValor = this.valorExibidoCentroResultado(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  async abrirBuscaCentroResultado(): Promise<void> {
    this.filtroCentroResultado = '';
    this.centroResultadoModalAberta = true;
    await this._carregarCentrosResultado();
  }

  fecharBuscaCentroResultado(): void {
    this.centroResultadoModalAberta = false;
  }

  selecionarCentroResultado(c: { codCen: string | number; descricao: string }): void {
    this.centroResultadoSelecionado = c.codCen;
    this.centroResultadoModalAberta = false;
  }

  limparCentroResultado(): void {
    this.centroResultadoSelecionado = '';
  }

  // Natureza (TGFNAT — TGFCAB.CODNAT). Mesmo padrão acima. Padrão: 1010101 - DUPLICATAS A RECEBER.
  naturezasOpcoes: { codNat: string | number; descricao: string }[] = [
    { codNat: '0',       descricao: '' },
    { codNat: '1010101', descricao: 'DUPLICATAS A RECEBER' },
  ];
  naturezaSelecionada: string | number = '1010101';
  naturezasCarregando = false;
  naturezaModalAberta = false;
  filtroNatureza = '';

  get naturezasFiltradas(): { codNat: string | number; descricao: string }[] {
    const termo = this.filtroNatureza.trim().toUpperCase();
    if (!termo) {
      return this.naturezasOpcoes;
    }
    return this.naturezasOpcoes.filter(n => (n.descricao || '').toUpperCase().includes(termo));
  }

  descricaoNatureza(codigo: string | number): string {
    const codigoAtual = String(codigo ?? '').trim();
    const opcao = this.naturezasOpcoes.find(n => String(n.codNat) === codigoAtual);
    return opcao ? opcao.descricao : '';
  }

  valorExibidoNatureza(codigo: string | number): string {
    const codigoAtual = String(codigo ?? '').trim();
    const descricao = this.descricaoNatureza(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  onInputNatureza(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;

    const idx = valorDigitado.indexOf(' - ');
    const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

    this.naturezaSelecionada = novoCodigo;

    const novoValor = this.valorExibidoNatureza(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  async abrirBuscaNatureza(): Promise<void> {
    this.filtroNatureza = '';
    this.naturezaModalAberta = true;
    await this._carregarNaturezas();
  }

  fecharBuscaNatureza(): void {
    this.naturezaModalAberta = false;
  }

  selecionarNatureza(n: { codNat: string | number; descricao: string }): void {
    this.naturezaSelecionada = n.codNat;
    this.naturezaModalAberta = false;
  }

  limparNatureza(): void {
    this.naturezaSelecionada = '';
  }

  // Aeronave (AD_TCADAERO, vinculada ao cliente via AD_AEROPAR/CNPJ), após a Cotação.
  // Só fica disponível depois que um cliente é selecionado.
  aeronaveOpcoes: { codaero: string | number; prefixo: string; codparc?: string | number; nomeProprietario?: string }[] = [];
  aeronaveSelecionada: string | number = '';
  aeronaveCarregando = false;
  aeronaveBusca = '';
  aeronaveSugestoes: any[] = [];
  mostrarDropdownAeronave = false;
  private _aeronaveTimeout: any;
  /** true quando a aeronave gravada no pedido (carregarPedidoParaEdicao) não
   *  está vinculada ao cliente atual — o Sankhya nativo bloqueia o Salvar
   *  nessa condição ("Aeronave não pertence a este parceiro"). Avisa o
   *  usuário antes disso acontecer, pra ele trocar/limpar a aeronave. */
  aeronaveNaoVinculadaAoCliente = false;

  /** Retorna o prefixo da aeronave atualmente selecionada, ou '' se nenhuma. */
  get aeronaveAtualPrefixo(): string {
    if (!this.aeronaveSelecionada || !this.aeronaveOpcoes.length) return '';
    const op = this.aeronaveOpcoes.find(a => String(a.codaero) === String(this.aeronaveSelecionada));
    return op?.prefixo ?? '';
  }

  /** Prefixo + proprietário ("PREFIXO — PROPRIETARIO") para exibição no cabeçalho. */
  get aeronaveAtualPrefixoComProprietario(): string {
    if (!this.aeronaveSelecionada || !this.aeronaveOpcoes.length) return '';
    const op = this.aeronaveOpcoes.find(a => String(a.codaero) === String(this.aeronaveSelecionada));
    if (!op?.prefixo) return '';
    return op.nomeProprietario ? `${op.prefixo} — ${op.nomeProprietario}` : op.prefixo;
  }

  /**
   * Replica no front, na hora de gravar, o que o evento de banco
   * EV_INLCUIOBS_GLOBAL faz na OBSERVACAO — para não depender de o evento
   * disparar (evita o problema relatado de a observação às vezes não
   * atualizar ao gravar/alterar o pedido). Remove a linha antiga de
   * "Prefixo" e de "Ordem de Compra" (se existirem) e reescreve com os
   * valores atuais, sempre — igual à lógica do REGEXP_REPLACE da procedure.
   * Se o evento também rodar no servidor, o resultado é o mesmo texto
   * (idempotente), então não há conflito entre os dois.
   */
  /** Remove as linhas auto-geradas (Prefixo/Cert.(COM) e Ordem de Compra) de
   *  um texto de Observação Nota, deixando só o texto livre do usuário. */
  private _removerLinhasAutomaticasObservacao(texto: string): string {
    let obs = texto ?? '';
    obs = obs.replace(/(^|\n)Prefixo\s*:[^\n]*/, '');
    obs = obs.replace(/(^|\n)Ordem de Compra\s*:[^\n]*/, '');
    return obs.replace(/^\n+|\n+$/g, '');
  }

  /** Linha(s) auto-geradas (Prefixo/Cert.(COM), Ordem de Compra) que serão
   *  anexadas à Observação Nota ao salvar — mostradas travadas (somente
   *  leitura) abaixo do campo, para o usuário não editar/apagar por engano. */
  get linhaObservacaoAutomatica(): string {
    const linhas: string[] = [];

    const prefixo = this.aeronaveAtualPrefixo;
    if (prefixo) {
      const adCom = this.clienteSelecionado?.adCom ?? '';
      linhas.push(`Prefixo : ${prefixo}. Cert.(COM) : ${adCom}.`);
    }

    const numPedido = (this.numPedido2 ?? '').trim();
    if (numPedido) {
      linhas.push(`Ordem de Compra : ${numPedido}`);
    }

    return linhas.join('\n');
  }

  /** Texto livre da Observação Nota (sem as linhas automáticas) — é isso que
   *  o usuário efetivamente vê e edita no textarea; as linhas automáticas
   *  ficam travadas em um bloco à parte (linhaObservacaoAutomatica). */
  get observacaoNotaLivre(): string {
    return this._removerLinhasAutomaticasObservacao(this.observacao ?? '');
  }
  set observacaoNotaLivre(valor: string) {
    this.observacao = valor;
  }

  /**
   * Replica no front, na hora de gravar, o que o evento de banco
   * EV_INLCUIOBS_GLOBAL faz na OBSERVACAO — para não depender de o evento
   * disparar (evita o problema relatado de a observação às vezes não
   * atualizar ao gravar/alterar o pedido). Remove a linha antiga de
   * "Prefixo" e de "Ordem de Compra" (se existirem) e reescreve com os
   * valores atuais, sempre — igual à lógica do REGEXP_REPLACE da procedure.
   * Se o evento também rodar no servidor, o resultado é o mesmo texto
   * (idempotente), então não há conflito entre os dois.
   */
  private _observacaoSincronizada(): string {
    const livre = this._removerLinhasAutomaticasObservacao(this.observacao ?? '');
    const linhaAuto = this.linhaObservacaoAutomatica;
    // No texto GRAVADO a linha automática vem ANTES do texto livre (mesmo
    // que na tela o bloco travado apareça visualmente depois do textarea).
    const obs = linhaAuto ? (livre ? `${linhaAuto}\n${livre}` : linhaAuto) : livre;

    // Atualiza também o campo em tela — sem isso o texto novo só ia pro
    // payload de gravação, e a tela continuava mostrando o prefixo antigo.
    this.observacao = obs;
    return obs;
  }

  /** Formata o TIPO_VINCULO (AD_AEROPAR) bruto — ex: "PROPRIETARIO" — para exibição. */
  formatarVinculo(tipo: string | null | undefined): string {
    const t = (tipo ?? '').trim().toUpperCase();
    if (t === 'PROPRIETARIO') return 'Proprietário';
    if (t === 'PILOTO')       return 'Piloto';
    if (t === 'OFICINA')      return 'Oficina';
    return t ? t.charAt(0) + t.slice(1).toLowerCase() : '—';
  }

  onAeronaveInput() {
    if (this._aeronaveTimeout) clearTimeout(this._aeronaveTimeout);
    this._aeronaveTimeout = setTimeout(() => {
      this._buscarAeronavesDropdown();
    }, 400);
  }

  private async _buscarAeronavesDropdown() {
    const termo = this.aeronaveBusca.trim();
    if (termo.length < 2) {
      this.aeronaveSugestoes = [];
      this.mostrarDropdownAeronave = termo.length > 0;
      return;
    }
    this.aeronaveCarregando = true;
    this.mostrarDropdownAeronave = true;
    try {
      const res: any = await this.sankhyaGateway.buscarAeronavesEClientesGlobal(termo).toPromise();
      const body = res?.responseBody ?? res;
      if (body?.sucesso && Array.isArray(body?.prefixos)) {
        this.aeronaveSugestoes = body.prefixos;
      } else {
        this.aeronaveSugestoes = [];
      }
    } catch (e) {
      this.aeronaveSugestoes = [];
    } finally {
      this.aeronaveCarregando = false;
    }
  }

  aeronaveModalAberta = false;
  aeronaveModalCarregando = false;
  filtroAeronaveModal = '';
  aeronaveSugestoesModal: any[] = [];
  private _aeronaveModalTimer: any = null;

  async selecionarAeronaveAutocomplete(a: any) {
    this.mostrarDropdownAeronave = false;
    this.aeronaveSugestoes = [];
    this.aeronaveNaoVinculadaAoCliente = false;

    // Check if we need to load the client
    if (!this.clienteSelecionado || String(this.clienteSelecionado.codparc) !== String(a.codparc)) {
        const clienteSugestao = {
            codparc: a.codparc,
            nomeparc: a.nomeparc,
            docparc: a.docparc,
            adCom: a.adCom,
            inscEstadual: a.inscEstadual,
            cidade: a.cidade,
            uf: a.uf
        };
        await this.selecionarCliente(clienteSugestao);
    }
    
    // Now that cliente is selected, we can set aeronaveSelecionada!
    this.aeronaveSelecionada = a.codaero;
    this.aeronaveBusca = a.prefixo;
    // "a" vem da busca global (aeronaveSugestoes), que é uma lista diferente
    // de "aeronaveOpcoes" (só as aeronaves do cliente, carregada por
    // _carregarAeronaves). Se o mesmo cliente já estava selecionado, esse
    // segundo carregamento é pulado e "aeronaveOpcoes" fica com a lista
    // antiga — sem isso, o getter aeronaveAtualPrefixo (usado ao gravar,
    // para montar a Observação Nota) não encontra a aeronave recém-
    // selecionada e acaba usando o prefixo anterior. Garante que ela sempre
    // esteja na lista.
    const jaNaLista = this.aeronaveOpcoes.some(op => String(op.codaero) === String(a.codaero));
    if (!jaNaLista) {
      this.aeronaveOpcoes = [...this.aeronaveOpcoes, {
        codaero: a.codaero,
        prefixo: a.prefixo,
        codparc: a.codparc,
        nomeProprietario: a.nomeProprietario,
      }];
    }
  }

  abrirBuscaAeronave() {
    this.filtroAeronaveModal = '';
    this.aeronaveSugestoesModal = [];
    this.aeronaveModalAberta = true;
  }

  fecharBuscaAeronave() {
    this.aeronaveModalAberta = false;
  }

  onFiltroAeronaveModalChange() {
    clearTimeout(this._aeronaveModalTimer);
    const termo = this.filtroAeronaveModal.trim();
    if (termo.length < 2) {
      this.aeronaveSugestoesModal = [];
      this.aeronaveModalCarregando = false;
      return;
    }
    this.aeronaveModalCarregando = true;
    this._aeronaveModalTimer = setTimeout(() => this._buscarAeronavesModal(termo), 350);
  }

  private async _buscarAeronavesModal(termo: string) {
    try {
      const res: any = await this.sankhyaGateway.buscarAeronavesEClientesGlobal(termo).toPromise();
      const body = res?.responseBody ?? res;
      if (body?.sucesso && Array.isArray(body?.prefixos)) {
        this.aeronaveSugestoesModal = body.prefixos;
      } else {
        this.aeronaveSugestoesModal = [];
      }
    } catch (err) {
      this.aeronaveSugestoesModal = [];
    } finally {
      this.aeronaveModalCarregando = false;
    }
  }

  selecionarAeronaveModal(a: any) {
    this.selecionarAeronaveAutocomplete(a);
    this.fecharBuscaAeronave();
  }

  _aeronaveAnteriorSelecionada: any = null;
  _aeronaveAnteriorBusca: string = '';

  onAeronaveFocus() {
    if (this.aeronaveSelecionada) {
      this._aeronaveAnteriorSelecionada = this.aeronaveSelecionada;
      this._aeronaveAnteriorBusca = this.aeronaveBusca;
      this.aeronaveSelecionada = '';
      this.aeronaveBusca = '';
    }

    if (this.clienteSelecionado && this.aeronaveOpcoes && this.aeronaveOpcoes.length > 0 && !this.aeronaveBusca) {
      this.aeronaveSugestoes = [...this.aeronaveOpcoes];
      this.mostrarDropdownAeronave = true;
    } else if (this.aeronaveBusca.trim().length >= 2) {
      this.mostrarDropdownAeronave = true;
    }
  }

  onAeronaveBlur() {
    setTimeout(() => {
      this.mostrarDropdownAeronave = false;
      if (!this.aeronaveSelecionada) {
         if (this.aeronaveBusca.trim() === '' && this._aeronaveAnteriorSelecionada) {
           this.aeronaveSelecionada = this._aeronaveAnteriorSelecionada;
           this.aeronaveBusca = this._aeronaveAnteriorBusca;
           this._aeronaveAnteriorSelecionada = null;
           this._aeronaveAnteriorBusca = '';
         } else {
           this.aeronaveBusca = '';
         }
      } else {
         const aero = this.aeronaveOpcoes.find(op => String(op.codaero) === String(this.aeronaveSelecionada));
         if (aero) this.aeronaveBusca = aero.prefixo;
      }
    }, 200);
  }

  removerAeronave() {
    this.aeronaveSelecionada = '';
    this.aeronaveBusca = '';
    this.aeronaveSugestoes = [];
    this.mostrarDropdownAeronave = false;
    this.aeronaveNaoVinculadaAoCliente = false;
    // Sem isso, um foco/blur no campo (sem selecionar outra aeronave) depois
    // do "✕" restaurava a aeronave removida — onAeronaveBlur() usa esse
    // valor pra "desfazer" quando o campo fica vazio, mas aqui a remoção foi
    // intencional, não um blur acidental.
    this._aeronaveAnteriorSelecionada = null;
    this._aeronaveAnteriorBusca = '';
  }

  // ── Endereços ──────────────────────────────────────────────
  enderecoCarregando = false;
  endFaturamento: Endereco = this._enderecoVazio();
  endEntrega: Endereco = this._enderecoVazio();
  endEntregaIgualFaturamento = true;
  mostrarEnderecos = false;
  abaEnderecoAtiva: 'faturamento' | 'entrega' = 'faturamento';
  private _abaPrincipalAtiva: 'dados' | 'enderecos' | 'itens' | 'itensDesconto' | 'comissoes' | 'observacoes' = 'dados';
  get abaPrincipalAtiva(): 'dados' | 'enderecos' | 'itens' | 'itensDesconto' | 'comissoes' | 'observacoes' { return this._abaPrincipalAtiva; }
  set abaPrincipalAtiva(aba: 'dados' | 'enderecos' | 'itens' | 'itensDesconto' | 'comissoes' | 'observacoes') {
    this._abaPrincipalAtiva = aba;
    this.abaSelecionada.emit(aba);
  }

  // Lista de endereços do mesmo CNPJ/CPF (um por CODPARC) — o Sankhya
  // permite mais de um cadastro de parceiro com o mesmo documento, cada
  // um com seu próprio endereço. Faturamento e Entrega podem escolher,
  // cada um independentemente, qual desses endereços usar.
  enderecosDisponiveis: EnderecoDisponivel[] = [];
  enderecosEntregaDisponiveis: EnderecoDisponivel[] = [];  // endereços da Pessoa de Entrega
  codparcFaturamentoSelecionado: string | number = '';
  codparcEntregaSelecionado: string | number = '';

  // ── Pessoa de Entrega ──────────────────────────────────────
  pessoaEntregaBusca = '';
  pessoaEntregaSelecionada: ClienteSugestao | null = null;
  pessoaEntregaSugestoes: ClienteSugestao[] = [];
  pessoaEntregaCarregando = false;
  mostrarDropdownPessoaEntrega = false;
  titulosPessoaEntregaPosicionados: TituloClientePosicionado[] = [];
  private _pessoaEntregaTimer: any = null;
  private _pessoaEntregaAnterior: ClienteSugestao | null = null;
  private _pessoaEntregaCanvasCtx: CanvasRenderingContext2D | null = null;

  // ── Status Financeiro do Cliente ───────────────────────────
  creditoInfo: {
    limiteCred: number;
    creditoDisp: number;
    pendente: number;
    atrasado: number;
    conceito: string;
  } | null = null;
  creditoCarregando = false;

  get creditoDisponivel(): boolean {
    return (this.creditoInfo?.creditoDisp ?? 0) > 0;
  }


  // ── Empresa (TSIEMP — via EmpresaStateService compartilhado com o menu) ──
  get empresasOpcoes()       { return this.empresaState.opcoes; }
  get empresaSelecionada()   { return this.empresaState.selecionada; }
  set empresaSelecionada(v: string) { this.empresaState.selecionada = v; }
  get empresasCarregando()   { return this.empresaState.carregando; }

  /** Empresa que estava selecionada no seletor GLOBAL antes de entrar na
   *  edição deste pedido — null enquanto não foi capturada ainda. Ver uso e
   *  motivo em carregarPedidoParaEdicao() / ngOnDestroy(). */
  private _empresaSelecionadaAntesDaEdicao: string | null = null;
  get corEmpresaSelecionada(){ return this.empresaState.cor; }

  /** Background do page-header: gradiente padrão para empresa 1, cor clara da empresa para as demais. */
  get pageHeaderBackground(): string {
    return this.empresaState.selecionada === '1'
      ? 'var(--primary-gradient)'
      : this.empresaState.corClara(0.55);
  }

  /** Cor de fundo clara para uma linha do painel de estoque (baseada no CODEMP). */
  corLinhaEstoque(codemp: number): string {
    const key = String(codemp ?? '');
    const hex = this.empresaState.CORES[key];
    if (!hex) return '';
    // mistura com branco em 75% para ficar bem claro (legível)
    const c = hex.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    const f = 0.75;
    const rr = Math.round(r + (255 - r) * f).toString(16).padStart(2, '0');
    const gg = Math.round(g + (255 - g) * f).toString(16).padStart(2, '0');
    const bb = Math.round(b + (255 - b) * f).toString(16).padStart(2, '0');
    return `#${rr}${gg}${bb}`;
  }

  /** Cor do texto do page-header: preto para fundos claros, branco para escuros. */
  get pageHeaderTextColor(): string {
    if (this.empresaState.selecionada === '1') return '#ffffff';
    return this._corTextoContraste(this.empresaState.cor);
  }

  /** Retorna '#000000' ou '#ffffff' conforme a luminância da cor hex. */
  private _corTextoContraste(hex: string): string {
    const c = hex.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    // Fórmula de luminância relativa (WCAG)
    const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminancia > 0.55 ? '#1a1a1a' : '#ffffff';
  }

  // ── Itens ──────────────────────────────────────────────────
  itens: ItemPedido[] = [{ id: 1, codprod: '', descricao: '', unidade: 'UN', quantidade: 1, precoUsd: 0, precoUnitario: 0, desconto: 0, vlrDesc: 0, vlrAcrescDesc: 0, total: 0, totalUsd: 0, controlaCore: false, vlrCore: 0, coreUnitBrl: 0, totalCoreUsd: 0, totalCoreBrl: 0, estoque: 0 }];
  private _proximoId = 2;

  // ── Modal de Importação de Excel ───────────────────────────
  excelImportAberto = false;
  excelImportLinhas: ExcelImportRow[] = [];
  excelImportValidando = false;
  excelImportando = false;              // true enquanto os preços/estoque estão sendo carregados
  excelImportNomeArquivo = '';
  excelImportOrigemOS = false;          // true quando as linhas vieram de uma O.S (não de um arquivo Excel)
  // true enquanto o pedido gerado pela O.S está sendo gravado — mantém o
  // overlay do modal cobrindo a tela inteira, para o vendedor nunca ver o
  // formulário de edição "por trás" durante a gravação automática.
  excelImportGravando = false;
  excelAproximadosLinha: ExcelImportRow | null = null; // linha cujo painel de similares está aberto
  excelAvisoNaoEncontrado = false;      // true quando há itens não encontrados e usuário pediu confirmação
  // Mapeamento manual de colunas (quando auto-detecção falha)
  excelMapeamentoAberto = false;
  excelColunas: string[] = [];
  excelColunaPn: number | null = null;
  excelColunaQty: number | null = null;
  excelRowsRaw: any[][] = [];
  excelPreviewLinhas: any[][] = [];

  // ── Estado geral ───────────────────────────────────────────
  salvando = signal(false);
  alerta: { mensagem: string; tipo: 'sucesso' | 'erro' | 'aviso' } | null = null;

  // Lista carregada dinamicamente do Sankhya (TGFTOP) em ngOnInit.
  // Mantém um fallback fixo para o caso do serviço falhar, evitando tela vazia.
  tiposOperacao: { codigo: string; descricao: string }[] = [
    { codigo: '100', descricao: 'ORÇAMENTO' },
    { codigo: '500', descricao: 'VENDA' },
    { codigo: '501', descricao: 'VENDA FORA DO ESTADO' },
    { codigo: '502', descricao: 'VENDA EXPORTAÇÃO' },
  ];
  tiposOperacaoCarregando = false;

  constructor(
    private readonly sankhyaGateway: SankhyaGatewayService,
    readonly empresaState: EmpresaStateService,
    private readonly produtoService: ProdutoService,
    private readonly serialService: SerialService,
    private readonly permissaoAcesso: PermissaoAcessoService,
  ) {}

  // Permissões especiais do resource GPL_vendas (ControleAcessoSP).
  // Default true para não travar a tela antes da resposta chegar; assim que
  // a permissão é consultada, o valor real substitui o default.
  podeEditarPreco = true;
  podeEditarComissao = true;

  // Cotação (câmbio) — ao contrário de EDTPRE/PERCOM acima, default É false
  // (o campo já nasce travado no HTML há tempos; só destrava depois que a
  // permissão real confirmar, evitando destravar por 1 frame pra quem não
  // deveria poder mexer no câmbio de todo o pedido).
  /** EDTCOT — pode trocar a cotação livremente (subir ou descer). */
  podeEditarCotacao = false;
  /** EDTMAI — pode trocar a cotação SOMENTE para um valor maior que o atual. */
  podeEditarCotacaoSomenteParaCima = false;
  /** true = tem pelo menos uma das duas permissões (campo destravado). */
  get cotacaoEditavel(): boolean {
    return this.podeEditarCotacao || this.podeEditarCotacaoSomenteParaCima;
  }

  private _carregarPermissoesEspeciais(): void {
    this.permissaoAcesso.podeEditarPreco().then(valor => this.podeEditarPreco = valor);
    this.permissaoAcesso.podeEditarComissao().then(valor => this.podeEditarComissao = valor);
    this.permissaoAcesso.podeEditarCotacao().then(valor => this.podeEditarCotacao = valor);
    this.permissaoAcesso.podeEditarCotacaoSomenteParaCima().then(valor => this.podeEditarCotacaoSomenteParaCima = valor);
  }

  codVendLogado: string | number | null = null;

  // Busca de Vendedor (modal "Procurando por Vendedor", igual ao Sankhya/Duplicar Produto)
  vendedores: VendedorOpcao[] = [];
  vendedorModalAberta = false;
  filtroVendedor = '';

  get vendedoresFiltrados(): VendedorOpcao[] {
    const filtro = this.filtroVendedor.trim().toUpperCase();
    if (!filtro) {
      return this.vendedores;
    }
    return this.vendedores.filter(v => (v.apelido || '').toUpperCase().includes(filtro));
  }

  /** Retorna o apelido de um vendedor (CODVEND) pelo código. */
  descricaoVendedor(codigo: string | number | null): string {
    const codigoAtual = String(codigo ?? '').trim();
    const opcao = this.vendedores.find(v => String(v.codVend) === codigoAtual);
    return opcao ? opcao.apelido : '';
  }

  /** Valor exibido no input do Vendedor: "CÓDIGO - Apelido", igual à Marca/Tipo Negociação. */
  valorExibidoVendedor(codigo: string | number | null): string {
    const codigoAtual = String(codigo ?? '').trim();
    const descricao = this.descricaoVendedor(codigoAtual);
    return descricao ? `${codigoAtual} - ${descricao}` : codigoAtual;
  }

  /** Valor selecionado antes do usuário clicar no campo (pra reverter se
   *  clicar fora sem digitar nada) e flag indicando se já digitou algo
   *  desde o foco — usados por onFocus/onInput/onBlur de Vendedor. */
  private _vendedorFocoValor: string | number | null = null;
  private _vendedorTeveInput = false;

  /** Limpa o campo ao ganhar foco/clique, guardando o valor atual pra
   *  poder voltar caso o usuário clique fora sem digitar nada. */
  onFocusVendedor(event: Event): void {
    const input = event.target as HTMLInputElement;
    this._vendedorFocoValor = this.codVendLogado;
    this._vendedorTeveInput = false;
    input.value = '';
  }

  /** Disparado a cada tecla digitada — considera código só o trecho antes
   *  do primeiro " - ". Só aceita a tecla se o código resultante ainda for
   *  prefixo de algum código válido da lista -- impede digitar um valor
   *  que não existe. */
  onInputVendedor(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorDigitado = input.value;
    const cursorPos = input.selectionStart ?? valorDigitado.length;

    const idx = valorDigitado.indexOf(' - ');
    let novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

    this._vendedorTeveInput = true;

    const valido = novoCodigo === '' ||
      this.vendedores.some(v => String(v.codVend).startsWith(novoCodigo));
    if (!valido) {
      // Código digitado não é prefixo de nenhum válido -- rejeita a tecla.
      novoCodigo = String(this.codVendLogado ?? '');
    }

    this.codVendLogado = novoCodigo;

    const novoValor = this.valorExibidoVendedor(novoCodigo);
    setTimeout(() => {
      input.value = novoValor;
      const novaPos = Math.min(cursorPos, novoCodigo.length);
      input.setSelectionRange(novaPos, novaPos);
    });
  }

  /** Ao sair do campo: se não digitou nada, volta pro valor anterior; se
   *  digitou algo que não é um código válido da lista, também volta pro
   *  anterior. */
  onBlurVendedor(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!this._vendedorTeveInput) {
      this.codVendLogado = this._vendedorFocoValor;
    } else {
      const codigoAtual = String(this.codVendLogado ?? '').trim();
      const valido = codigoAtual !== '' &&
        this.vendedores.some(v => String(v.codVend) === codigoAtual);
      if (!valido) {
        this.codVendLogado = this._vendedorFocoValor;
      }
    }

    input.value = this.valorExibidoVendedor(this.codVendLogado);
  }

  // Busca de Cotação, mesmo padrão do campo Marca do Duplicar Produto:
  // busca-combo com lupa, abrindo modal "Cotações Disponíveis" — usa o
  // mesmo serviço do Demonstrativo de Vendas (CabecalhoDaNotaGlobalSP.doBuscarCotacoes),
  // fixo em CODMOEDA = 4 (Dólar).
  cotacoesDisponiveis: DemonstrativoCotacao[] = [];
  cotacaoModalAberta = false;
  cotacaoCarregando = false;

  // Texto do campo: somente leitura — só é preenchido escolhendo uma
  // cotação no modal (clique no input ou na lupa abre a busca).
  cotacaoTexto = '';

  /** Cotação completa selecionada — usada para extrair o valor numérico. */
  cotacaoSelecionada: DemonstrativoCotacao | null = null;

  /** Valor numérico da cotação selecionada (ex: 5.19). */
  get cotacaoValorNumerico(): number {
    const raw = this.cotacaoSelecionada?.valor ?? this.cotacaoTexto?.split('|')[0].trim();
    return parseFloat(String(raw ?? '').replace(',', '.')) || 0;
  }

  /** Data de uma cotação — o backend pode mandar em campos diferentes. */
  dataCotacao(c: DemonstrativoCotacao | null): string {
    if (!c) return '';
    return String(c.data ?? c.DATA_BR ?? c.DATA ?? c.DTMOV ?? '');
  }

  // Filtro do modal "Cotações Disponíveis" — busca por valor (cotação) ou
  // por data, tudo client-side já que a lista inteira é carregada de uma vez.
  filtroCotacao = '';

  get cotacoesFiltradas(): DemonstrativoCotacao[] {
    const termo = this.filtroCotacao.trim().toLowerCase();
    if (!termo) {
      return this.cotacoesDisponiveis;
    }
    return this.cotacoesDisponiveis.filter(c => {
      // Busca no MESMO texto que aparece na tela (valorCotacaoFormatado),
      // não no c.valor cru -- o cru pode vir com casas decimais/formato
      // diferente do que é exibido (ex: "5.1978" cru vs "5,20" exibido),
      // fazendo o usuário digitar exatamente o que vê e não achar nada.
      const valor = this.valorCotacaoFormatado(c).toLowerCase();
      const data = this.dataCotacao(c).toLowerCase();
      return valor.includes(termo) || data.includes(termo);
    });
  }

  /** Monta o texto exibido a partir de uma cotação: "5,19  |  08/06/2026". */
  // ── Formatadores de documento ─────────────────────────────────
  fmtDocumento(doc: string | null | undefined): string {
    const d = (doc ?? '').replace(/\D/g, '');
    if (d.length === 14) {
      return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    if (d.length === 11) {
      return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    return doc || '';
  }

  fmtIE(ie: string | null | undefined): string {
    const d = (ie ?? '').replace(/\D/g, '');
    if (d.length === 12) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3.$4');
    if (d.length === 10) return d.replace(/^(\d{3})(\d{5})(\d{2})$/, '$1.$2-$3');   // PR
    if (d.length === 9)  return d.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3');
    if (d.length === 8)  return d.replace(/^(\d{2})(\d{3})(\d{2})(\d{1})$/, '$1.$2.$3-$4');
    return ie || '';
  }

  /** Valor da cotação formatado com 2 casas decimais fixas (pt-BR) — sem
   *  isso, um valor "redondo" como 5.20 chegava do backend como número puro
   *  (5.2) e o JS/Angular imprimia sem o zero final ("5.2" em vez de
   *  "5,20"), fazendo parecer um valor diferente na lista de cotações. */
  valorCotacaoFormatado(c: DemonstrativoCotacao | null): string {
    if (!c) return '';
    const raw = parseFloat(String(c.valor ?? '').replace(',', '.')) || 0;
    return this.formatarDecimal(raw);
  }

  private _formatarCotacao(c: DemonstrativoCotacao): string {
    const data = this.dataCotacao(c);
    return `${this.valorCotacaoFormatado(c)}${data ? '  |  ' + data : ''}`;
  }

  async abrirBuscaCotacao(): Promise<void> {
    if (!this.cotacaoEditavel) return;
    this.filtroCotacao = '';
    this.cotacaoModalAberta = true;
    await this._carregarCotacoes();
  }

  fecharBuscaCotacao(): void {
    this.cotacaoModalAberta = false;
  }

  private async _carregarCotacoes(): Promise<void> {
    this.cotacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarCotacoesDemonstrativo()
      );
      const body = res?.responseBody ?? res;
      const cotacoes = body?.cotacoes ?? [];

      if (body?.sucesso !== false && Array.isArray(cotacoes)) {
        this.cotacoesDisponiveis = cotacoes;
        // A mais recente vem primeiro (ORDER BY DTMOV DESC no addon) — se o
        // campo ainda estiver vazio, já deixa pré-preenchido.
        if (!this.cotacaoTexto && cotacoes.length > 0) {
          this.cotacaoSelecionada = cotacoes[0];
          this.cotacaoTexto = this._formatarCotacao(cotacoes[0]);
        }
      } else {
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] cotações não retornadas. Resposta completa:', res);
      }
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar cotações:', err);
    } finally {
      this.cotacaoCarregando = false;
    }
  }

  /** @param ignorarRegraSoPraCima Pula a checagem EDTMAI "só pra cima" —
   *  usado só pelo fluxo de "Atualizar Cotação" (confirmarAtualizarCotacao),
   *  onde o usuário está explicitamente pedindo pra buscar a cotação mais
   *  recente CADASTRADA no Sankhya (não um valor arbitrário escolhido à
   *  mão), e o dólar pode ter caído desde que o pedido foi criado — nesse
   *  caso faz sentido deixar descer mesmo com só EDTMAI. A seleção manual
   *  pelo modal de busca continua respeitando a regra normalmente. */
  selecionarCotacao(c: DemonstrativoCotacao, ignorarRegraSoPraCima = false): void {
    if (!this.cotacaoEditavel) return;

    // EDTMAI (sem EDTCOT): só pode trocar para uma cotação MAIOR que a atual —
    // mesma regra da Tela Cotações (gpl-edicao-produtos), aqui aplicada à
    // cotação do pedido inteiro.
    if (!ignorarRegraSoPraCima && this.podeEditarCotacaoSomenteParaCima && !this.podeEditarCotacao) {
      const atual = this.cotacaoValorNumerico;
      const novo = parseFloat(String(c.valor ?? '').replace(',', '.')) || 0;
      if (atual > 0 && novo < atual) {
        this._abrirModalAviso(
          `Você só pode selecionar uma cotação maior que a atual. Cotação atual: ${atual.toFixed(4)}, ` +
          `cotação selecionada: ${novo.toFixed(4)}.`
        );
        return;
      }
    }

    this.cotacaoSelecionada = c;
    this.cotacaoTexto = this._formatarCotacao(c);
    this.cotacaoModalAberta = false;
    // Recalcula precoUnitario de todos os itens já adicionados
    this._recalcularPrecosTodosItens();
  }

  /** Confirmação Sim/Não antes de atualizar a cotação — pedido do usuário:
   *  clicar no pill "Dólar EUA" (cabeçalho) ou no botão novo do campo
   *  Cotação (US$) abre essa mesma pergunta antes de trocar o câmbio e
   *  recalcular tudo que depende dele. */
  confirmacaoAtualizarCotacaoAberta = false;

  solicitarAtualizarCotacao(): void {
    if (!this.cotacaoEditavel) return;
    this.confirmacaoAtualizarCotacaoAberta = true;
  }

  cancelarAtualizarCotacao(): void {
    this.confirmacaoAtualizarCotacaoAberta = false;
  }

  /** true enquanto confirmarAtualizarCotacao() está em andamento (entre o
   *  clique em "Sim" e o resultado final) — usado só pra _verificarAltcotEPerguntar()
   *  não abrir por cima no meio do caminho (ver comentário lá). */
  private _atualizandoCotacaoEmAndamento = false;

  /** @param aoFechar Roda quando o usuário fechar o aviso final (sucesso ou
   *  erro) — usado só pelo fluxo do ALTCOT (confirmarAtualizarPrecoVenda)
   *  pra encadear a checagem de "itens com preço desatualizado" (ALTPRECO)
   *  DEPOIS que esse aviso fechar. Sem isso, chamar as duas checagens em
   *  sequência não funcionava: a segunda usa o mesmo guard algumModalAberto()
   *  e via esse aviso ainda aberto na tela, então nunca chegava a perguntar
   *  (bug reportado: aparecia o aviso da cotação mas nunca o de preço, mesmo
   *  o pedido tendo item nacional com preço parado há mais tempo que o
   *  ALTPRECO configurado). */
  /** Texto do resultado da cotação (o que houve, ou não) — não mostra aviso
   *  próprio; alimenta o resumo final único junto com _resumoTextoPrecos
   *  (ver _mostrarResumoFinal). Guardado em vez de descartado porque o
   *  usuário pediu um resumo consolidado no final (cotação + preços dos
   *  itens), refletindo o que foi de fato respondido em cada pergunta —
   *  em vez de um aviso separado por etapa. */
  private _resumoTextoCotacao: string | null = null;

  /** true quando o usuário respondeu "Não" na pergunta de cotação — usado
   *  só pra decidir se o resumo final combinado vira "Nada foi atualizado."
   *  (ver _mostrarResumoFinal) quando cotação E preço foram ambos recusados. */
  private _resumoCotacaoRespondeuNao = false;

  async confirmarAtualizarCotacao(aoFechar?: () => void): Promise<void> {
    this.confirmacaoAtualizarCotacaoAberta = false;
    this._atualizandoCotacaoEmAndamento = true;
    this._resumoCotacaoRespondeuNao = false;
    try {
      if (!this.cotacaoEditavel) {
        this._resumoTextoCotacao = 'Você não tem permissão para editar a cotação deste pedido.';
        if (aoFechar) { aoFechar(); } else { this._mostrarResumoFinal(); }
        return;
      }

      const cotacaoAntes = this.cotacaoValorNumerico;

      // SEMPRE busca de novo no Sankhya (nunca reaproveita cotacoesDisponiveis
      // já carregado antes) — é justamente pra pegar uma cotação cadastrada
      // DEPOIS que a tela abriu que esse botão existe.
      await this._carregarCotacoes();

      if (this.cotacoesDisponiveis.length === 0) {
        this._resumoTextoCotacao = 'Nenhuma cotação disponível encontrada.';
        if (aoFechar) { aoFechar(); } else { this._mostrarResumoFinal(); }
        return;
      }

      // A mais recente é sempre a primeira (ORDER BY DTMOV DESC — ver
      // _carregarCotacoes). Reusa selecionarCotacao() pro recálculo dos
      // itens, mas ignorando a regra EDTMAI "só pra cima" — aqui é a
      // cotação oficial mais recente cadastrada, pode ter caído desde a
      // criação do pedido (pedido do usuário).
      const maisRecente = this.cotacoesDisponiveis[0];
      this.selecionarCotacao(maisRecente, true);

      const cotacaoDepois = this.cotacaoValorNumerico;
      const dataFmt = this.dataCotacao(maisRecente) || '—';
      // O "dias configurado" agora aparece na pergunta Sim/Não (modal "Pedido
      // antigo", ver diasConfiguradosAltcot no HTML) — não repete aqui no
      // resumo final, pra não mostrar a mesma informação duas vezes.
      if (Math.abs(cotacaoDepois - cotacaoAntes) < 0.0001) {
        this._resumoTextoCotacao =
          `A cotação mais recente cadastrada no Sankhya já é essa mesma (${cotacaoDepois.toFixed(4)}, ${dataFmt}).`;
      } else {
        this._resumoTextoCotacao =
          `Cotação atualizada: ${cotacaoAntes.toFixed(4)} → ${cotacaoDepois.toFixed(4)} (${dataFmt}).`;
      }
      // aoFechar encadeia a checagem de ALTPRECO (fluxo do ALTCOT — ver
      // confirmarAtualizarPrecoVenda); sem aoFechar (botão "Dólar EUA"
      // avulso), mostra o resumo (só com a parte da cotação) na hora.
      if (aoFechar) { aoFechar(); } else { this._mostrarResumoFinal(); }
    } finally {
      this._atualizandoCotacaoEmAndamento = false;
    }
  }

  // ── Parâmetros do Sistema (GPL_PARAMETRO) ──────────────────────────────
  // Tela genérica de parametrização criada a pedido do usuário — pra não
  // deixar mais regras "fixas no código". Usos hoje:
  //   ALTCOT = dias — se a Data de Emissão do pedido, ao ABRIR pra edição,
  //            estiver mais velha que isso, pergunta (Sim/Não) se atualiza
  //            o preço de venda de todos os itens.
  //   FABNAC = códigos de fabricante (CODMARCA), separados por vírgula,
  //            tratados como "nacional" no cálculo inverso R$→U$ (antes
  //            fixo em 70/Embraer — ver _buscarDadosProdutoCompleto).
  private _parametrosCache: Record<string, string> = {};

  /** Lê o valor "dias" já configurado de ALTCOT/ALTPRECO — usado só pra
   *  mostrar nas mensagens de resumo qual limite disparou a pergunta
   *  (pedido do usuário: "mostrar a quantidade de dias configurado"). */
  private _diasConfigurados(chave: 'ALTCOT' | 'ALTPRECO'): number | null {
    const bruto = (this._parametrosCache[chave] || '').trim();
    const dias = parseInt(bruto, 10);
    return (bruto && Number.isFinite(dias) && dias > 0) ? dias : null;
  }

  /** Getters públicos usados no HTML — mostram os dias configurados direto
   *  nas perguntas Sim/Não (ALTCOT e ALTPRECO), não só no resumo final. */
  get diasConfiguradosAltcot(): number | null {
    return this._diasConfigurados('ALTCOT');
  }
  get diasConfiguradosAltpreco(): number | null {
    return this._diasConfigurados('ALTPRECO');
  }

  private async _carregarParametros(): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarValoresParametros(['ALTCOT', 'FABNAC', 'ALTPRECO'])
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso) {
        this._parametrosCache = body.valores ?? {};
      }
    } catch (err) {
      console.error('[PedidoVenda] erro ao carregar parâmetros (ALTCOT/FABNAC/ALTPRECO):', err);
    }
  }

  /** Lista de CODMARCA tratados como "nacional" (cálculo inverso R$→U$).
   *  Sem o parâmetro FABNAC cadastrado (ou tabela ainda vazia), mantém o
   *  comportamento histórico — só o 70 (Embraer) — pra não mudar nada em
   *  produção até o usuário configurar isso na tela de Parâmetros. */
  private _fabricantesNacionaisConfigurados(): number[] {
    const bruto = (this._parametrosCache['FABNAC'] || '').trim();
    if (!bruto) return [70];
    const lista = bruto.split(',')
      .map(s => parseInt(s.trim(), 10))
      .filter(n => Number.isFinite(n));
    return lista.length > 0 ? lista : [70];
  }

  // ── Confirmação "atualizar preço de venda" (ALTCOT) ────────────────────
  confirmacaoAtualizarPrecoAberta = false;

  /** Chamado ao final do carregamento de um pedido pra edição — verifica se
   *  a Data de Emissão já passou do limite (dias) configurado em ALTCOT e,
   *  se sim, abre a pergunta Sim/Não. Não interrompe nada se ALTCOT não
   *  estiver configurado, se o pedido for novo, ou se estiver em modo
   *  somente leitura (não faz sentido oferecer atualizar preço ali). */
  private _verificarAltcotEPerguntar(): void {
    if (this.modoSomenteLeitura) return;
    // Nunca abre por cima de outro modal (ex.: o de "Atualizar Cotação" que
    // o usuário pode ter clicado enquanto o pedido ainda carregava em
    // segundo plano) — os dois usam o mesmo modal de aviso compartilhado
    // (_abrirModalAviso) pra reportar erro/sucesso, e se ambos dispararem
    // quase juntos a segunda mensagem sobrescreve a primeira, fazendo
    // parecer que "atualizar cotação" virou "atualizar preço" (bug
    // reportado: aparecia o aviso de preço, cotação não mudava, mensagem
    // real de erro da cotação — ex. bloqueio EDTMAI "só pra cima" —
    // desaparecia sem o usuário ver). Se cair aqui bloqueado, a checagem
    // simplesmente não roda desta vez; não é crítico perder uma pergunta.
    if (this.algumModalAberto() || this._atualizandoCotacaoEmAndamento) return;
    const diasLimiteStr = (this._parametrosCache['ALTCOT'] || '').trim();
    const diasLimite = parseInt(diasLimiteStr, 10);
    if (!diasLimiteStr || !Number.isFinite(diasLimite) || diasLimite <= 0) return;
    if (!this.dataEmissao) return;

    const emissao = new Date(this.dataEmissao + 'T00:00:00');
    if (isNaN(emissao.getTime())) return;
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const diffDias = Math.floor((hoje.getTime() - emissao.getTime()) / 86400000);

    if (diffDias > diasLimite) {
      this.confirmacaoAtualizarPrecoAberta = true;
    }
  }

  // ── Confirmação "itens com preço desatualizado" (ALTPRECO) ─────────────
  // Diferente do ALTCOT acima (que é sobre a Data de Emissão do PEDIDO em
  // si), esse é por ITEM: cada item carrega item.dataUltAtualPreco (TGFEXC.
  // DHALTREG do registro de preço mais recente daquele produto — só vem
  // preenchido quando existe mesmo um preço cadastrado na TGFEXC, ver
  // _buscarPrecoExcItem). Se fizer mais de ALTPRECO dias que esse registro
  // não é tocado, oferece atualizar o preço negociado do item pro valor
  // atual do catálogo. Pedido do usuário: uma pergunta só cobrindo todos os
  // itens qualificados, não uma por item.
  confirmacaoAtualizarPrecosDesatualizadosAberta = false;
  private _itensPrecoDesatualizadoParaAtualizar: ItemPedido[] = [];

  get qtdItensPrecoDesatualizado(): number {
    return this._itensPrecoDesatualizadoParaAtualizar.length;
  }

  /** Chamado ao final do carregamento de um pedido pra edição (depois de
   *  aguardar os fetches de preço de cada item — ver carregarPedidoParaEdicao).
   *  Roda DEPOIS do _verificarAltcotEPerguntar() — se o ALTCOT já abriu sua
   *  pergunta, algumModalAberto() bloqueia essa aqui pra não empilhar dois
   *  modais na cara do usuário ao mesmo tempo (mesma regra de convivência
   *  usada entre ALTCOT e Atualizar Cotação). */
  /** @returns true se abriu a pergunta (modal ficou visível), false se não
   *  havia nada a perguntar — usado pelos chamadores (cancelarAtualizarPrecoVenda
   *  / confirmarAtualizarPrecoVenda) pra saber se devem mostrar o resumo final
   *  combinado JÁ (nenhuma pergunta de preço vai aparecer) ou esperar a
   *  resposta dela (ver _mostrarResumoFinal). */
  private _verificarItensPrecoDesatualizadoEPerguntar(): boolean {
    if (this.modoSomenteLeitura) return false;
    if (this.algumModalAberto()) return false;
    const diasLimiteStr = (this._parametrosCache['ALTPRECO'] || '').trim();
    const diasLimite = parseInt(diasLimiteStr, 10);
    if (!diasLimiteStr || !Number.isFinite(diasLimite) || diasLimite <= 0) return false;

    // O "dias" do ALTPRECO é sobre a idade do PEDIDO (Data de Emissão) —
    // MESMA base do ALTCOT (ver _verificarAltcotEPerguntar), não sobre há
    // quanto tempo o registro de preço no catálogo foi tocado. Corrigido
    // depois do usuário esclarecer: "se a venda tem a emissão maior que 5
    // dias, tem que validar tanto a cotação quanto o preço desatualizado" —
    // as duas checagens compartilham o mesmo gatilho (pedido antigo), só a
    // ação de cada uma é diferente.
    if (!this.dataEmissao) return false;
    const emissao = new Date(this.dataEmissao + 'T00:00:00');
    if (isNaN(emissao.getTime())) return false;
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const diffDiasPedido = Math.floor((hoje.getTime() - emissao.getTime()) / 86400000);
    if (diffDiasPedido < diasLimite) return false;

    // Do item, só importa se o VALOR negociado realmente diverge do
    // catálogo agora — ver precoDivergenteCatalogo (não a data do registro
    // de preço, que não tem relação com a idade do pedido).
    const candidatos = this.itens.filter(item =>
      !!item.codprodInterno && item.codprodInterno > 0 && !!item.precoDivergenteCatalogo
    );

    if (candidatos.length === 0) return false;
    this._itensPrecoDesatualizadoParaAtualizar = candidatos;
    this.confirmacaoAtualizarPrecosDesatualizadosAberta = true;
    // Leva o usuário pra aba de Itens junto com a pergunta — pedido do
    // usuário, pra já ver na tela (atrás do modal) quais itens estão com
    // o preço destacado antes de decidir Sim/Não.
    this.abaPrincipalAtiva = 'itens';
    return true;
  }

  // ── Resumo final combinado (cotação + preços dos itens) ─────────────────
  // Pedido do usuário: em vez de um aviso separado pra cada pergunta (cotação
  // e itens desatualizados), mostrar UM aviso só no final do fluxo inteiro,
  // com o conteúdo variando conforme o que foi de fato respondido em cada
  // pergunta: Não+Não → "nada foi atualizado"; Sim+Não → só a parte da
  // cotação; Não+Sim → só a parte do preço; Sim+Sim → as duas partes juntas.
  // Os dois textos ficam null quando a pergunta correspondente nem chegou a
  // aparecer (ex.: só ALTCOT configurado, sem itens divergentes) — nesse
  // caso o resumo mostra só a parte que de fato rodou. _resumoTextoCotacao
  // é declarado lá em cima, junto de confirmarAtualizarCotacao().
  private _resumoTextoPrecos: string | null = null;
  private _resumoPrecoRespondeuNao = false;

  private _mostrarResumoFinal(): void {
    const textoCotacao = this._resumoTextoCotacao;
    const textoPrecos = this._resumoTextoPrecos;
    const ambosRecusados = this._resumoCotacaoRespondeuNao && this._resumoPrecoRespondeuNao;

    this._resumoTextoCotacao = null;
    this._resumoTextoPrecos = null;
    this._resumoCotacaoRespondeuNao = false;
    this._resumoPrecoRespondeuNao = false;

    if (!textoCotacao && !textoPrecos) return;

    const mensagem = (textoCotacao && textoPrecos && ambosRecusados)
      ? 'Nada foi atualizado.'
      : [textoCotacao, textoPrecos].filter((t): t is string => !!t).join('\n\n');

    this._abrirModalAviso(mensagem);
  }

  cancelarAtualizarPrecosDesatualizados(): void {
    this.confirmacaoAtualizarPrecosDesatualizadosAberta = false;
    // O "dias configurado" já apareceu na pergunta Sim/Não (modal "Itens com
    // preço desatualizado", ver diasConfiguradosAltpreco no HTML) — não
    // repete aqui no resumo final.
    this._itensPrecoDesatualizadoParaAtualizar = [];
    this._resumoTextoPrecos = 'Preço não foi atualizado.';
    this._resumoPrecoRespondeuNao = true;
    this._mostrarResumoFinal();
  }

  /** Máximo de PNs detalhados (com preço antes → depois) na mensagem de
   *  resumo — pedido do usuário, pra não deixar o aviso gigante quando o
   *  pedido tem muitos itens desatualizados de uma vez. Além desse limite,
   *  entra "... e mais N itens." */
  private static readonly MAX_PNS_NA_MENSAGEM = 7;

  async confirmarAtualizarPrecosDesatualizados(): Promise<void> {
    this.confirmacaoAtualizarPrecosDesatualizadosAberta = false;
    const itens = this._itensPrecoDesatualizadoParaAtualizar;
    this._itensPrecoDesatualizadoParaAtualizar = [];
    this._resumoPrecoRespondeuNao = false;
    if (itens.length > 0) {
      // Snapshot do preço ANTES de atualizar — pro item nacional (fabricante70)
      // o valor negociado mestre é o Vl. Unit. R$ (precoUnitario, cálculo
      // inverso), pros demais é o Vl. Unit. U$ (precoUsd) — ver
      // _buscarPrecoExcItem/_buscarDadosProdutoCompleto.
      const snapshot = itens.map(item => ({
        item,
        moeda: item.fabricante70 ? 'R$' : 'US$',
        valorAntes: item.fabricante70 ? item.precoUnitario : item.precoUsd,
      }));
      // PN = item.codprod (REFFORN digitado/preenchido ao buscar o produto —
      // ver interface ItemPedido).
      const pns = itens.map(i => i.codprod || `cód. ${i.codprodInterno}`).join(', ');
      try {
        // soEstoque=false — re-busca e APLICA o preço atual da TGFEXC (não só
        // metadados), igual ao fluxo antigo de "atualizar preço de venda".
        await Promise.all(itens.map(item => this._buscarPrecoExcItem(item, false, false)));

        const max = PedidoVendaComponent.MAX_PNS_NA_MENSAGEM;
        const linhas = snapshot.slice(0, max).map(({ item, moeda, valorAntes }) => {
          const valorDepois = item.fabricante70 ? item.precoUnitario : item.precoUsd;
          const pn = item.codprod || `cód. ${item.codprodInterno}`;
          return `PN ${pn}: ${moeda} ${this.formatarDecimal(valorAntes)} → ${moeda} ${this.formatarDecimal(valorDepois)}`;
        });
        if (itens.length > max) {
          const restantes = itens.length - max;
          linhas.push(`... e mais ${restantes} ${restantes === 1 ? 'item' : 'itens'}.`);
        }
        const titulo = itens.length === 1
          ? 'Preço atualizado para 1 item:'
          : `Preço atualizado para ${itens.length} itens:`;
        this._resumoTextoPrecos = [titulo, ...linhas].join('\n');
      } catch (err) {
        console.error('[PedidoVenda] erro ao atualizar itens com preço desatualizado:', err);
        this._resumoTextoPrecos = `Erro ao atualizar os preços (PN: ${pns}) — verifique os itens manualmente.`;
      }
    }
    this._mostrarResumoFinal();
  }

  cancelarAtualizarPrecoVenda(): void {
    this.confirmacaoAtualizarPrecoAberta = false;
    // O "dias configurado" já apareceu na pergunta Sim/Não (modal "Pedido
    // antigo", ver diasConfiguradosAltcot no HTML) — não repete aqui.
    this._resumoTextoCotacao = 'Cotação não foi atualizada.';
    this._resumoCotacaoRespondeuNao = true;
    // ALTCOT e ALTPRECO são independentes (pode ter só um dos dois, os dois,
    // ou nenhum) — dizer "Não" pra atualizar a cotação não deve impedir a
    // pergunta de itens com preço desatualizado de aparecer. Se essa segunda
    // pergunta não abrir (nada a perguntar), mostra o resumo já com só a
    // parte da cotação.
    const abriuPerguntaPreco = this._verificarItensPrecoDesatualizadoEPerguntar();
    if (!abriuPerguntaPreco) {
      this._mostrarResumoFinal();
    }
  }

  // Pedido antigo (ALTCOT) tem que fazer exatamente a mesma coisa que o
  // botão "Dólar EUA": atualizar a cotação e recalcular os valores
  // dependentes dela. Reaproveita confirmarAtualizarCotacao() em vez de
  // reimplementar (antes isso ficava re-buscando o preço de catálogo de
  // cada item via _buscarPrecoExcItem, o que é uma coisa completamente
  // diferente do que foi pedido).
  async confirmarAtualizarPrecoVenda(): Promise<void> {
    this.confirmacaoAtualizarPrecoAberta = false;
    // Encadeia a checagem de ALTPRECO pra depois que o resultado da cotação
    // já estiver definido (ver comentário no parâmetro aoFechar de
    // confirmarAtualizarCotacao); se não houver pergunta de preço a fazer,
    // mostra o resumo final já com só a parte da cotação.
    await this.confirmarAtualizarCotacao(() => {
      const abriuPerguntaPreco = this._verificarItensPrecoDesatualizadoEPerguntar();
      if (!abriuPerguntaPreco) {
        this._mostrarResumoFinal();
      }
    });
  }

  private _recalcularPrecosTodosItens(): void {
    const taxa = this.cotacaoValorNumerico;
    for (const item of this.itens) {
      // Fabricante 70: Vl. Unit. R$ é o campo mestre — ao trocar a cotação,
      // recalcula só o Vl. Unit. U$ (R$ ÷ nova cotação), nunca o contrário.
      if (item.fabricante70) {
        if (taxa > 0 && item.precoUnitario > 0) {
          item.precoUsd    = parseFloat((item.precoUnitario / taxa).toFixed(2));
          item.precoUsdStr = this.formatarDecimal(item.precoUsd);
        }
        this.calcularTotal(item);
        continue;
      }
      // coreUnitBrl só recalcula quando Core está ativo (vlrCore × nova taxa)
      if (item.controlaCore && item.vlrCore > 0 && taxa > 0) {
        const coreUnitBrlAnterior = item.coreUnitBrl ?? 0;
        const coreUnitBrlNovo    = parseFloat((item.vlrCore * taxa).toFixed(2));
        // Ajusta precoUnitario e precoUsd pela diferença do Core (nova taxa)
        item.coreUnitBrl   = coreUnitBrlNovo;
        item.precoUnitario = parseFloat(
          Math.max(0, item.precoUnitario - coreUnitBrlAnterior + coreUnitBrlNovo).toFixed(2)
        );
        // precoUsd já inclui vlrCore (fixo em USD) — apenas reconverte para BRL via nova taxa
        if (item.precoUsd > 0) {
          item.precoUnitario = parseFloat((item.precoUsd * taxa).toFixed(2));
        }
      } else {
        item.coreUnitBrl = 0;
        if (item.precoUsd > 0) {
          item.precoUnitario = parseFloat((item.precoUsd * taxa).toFixed(2));
        }
      }
      if (item.precoUsd > 0 || item.precoUnitario > 0) {
        this.calcularTotal(item);
      }
    }
  }

  ngOnInit(): void {
    // ── Detectar modo edição ANTES de qualquer inicialização ──────
    // @Input() é garantido definido antes de ngOnInit pelo Angular.
    if (this.nunotaEditar != null) {
      this.nunotaAtual = this.nunotaEditar as number;
      this.modoEdicao  = true;
    }

    if (this.somenteCabecalho) {
      this.abaPrincipalAtiva = 'dados';
    }

    // Intercepta o botão Voltar do navegador — o app não usa rotas reais
    // (troca de tela é só um signal no gateway), então sem isso o Voltar do
    // navegador não mostrava nenhum aviso antes de sair da tela de Venda.
    // Empurra uma entrada extra no histórico: ao apertar Voltar, o evento
    // popstate dispara e a gente reempurra a mesma entrada na hora (o usuário
    // nem chega a ver a tela mudar) enquanto mostra a MESMA confirmação do
    // botão Voltar/Fechar do cabeçalho.
    history.pushState({ pedidoVendaGuard: true }, '');

    // Intercepta troca de empresa pelo seletor do MENU enquanto esta tela
    // está aberta — ver _guardaTrocaEmpresa/confirmarTrocaEmpresa mais abaixo.
    this.empresaState.registrarGuardaTroca(this._guardaTrocaEmpresa);

    this._buscaPecasSubscription = this._buscaPecasSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(termo => {
        // Enter já executou esta mesma busca há instantes: não repete.
        if (termo.trim() === this._buscaPecasTermoExecutado && Date.now() - this._buscaPecasUltimaExecucao < 700) return;
        this._executarBuscaPecas(termo);
      });

    this._rascunhoSubscription = this._rascunhoSubject
      .pipe(debounceTime(1500))
      .subscribe(() => this._sincronizarRascunhoImpostos());

    this._carregarPermissoesEspeciais();
    // Fire-and-forget — ALTCOT/FABNAC (ver _fabricantesNacionaisConfigurados
    // e _verificarAltcotEPerguntar) usam _parametrosCache com fallback
    // seguro caso ainda não tenha chegado quando o primeiro item for
    // processado, então não precisa bloquear o resto do ngOnInit nisso.
    this._carregarParametros();

    // Datas padrão apenas para pedido novo
    // Usa métodos locais (não toISOString que é UTC) para evitar virar o dia
    // seguinte quando chamado após 21h no Brasil (UTC-3).
    if (!this.modoEdicao) {
      const hoje = new Date();
      const yyyy = hoje.getFullYear();
      const mm   = String(hoje.getMonth() + 1).padStart(2, '0');
      const dd   = String(hoje.getDate()).padStart(2, '0');
      this.dataEmissao  = `${yyyy}-${mm}-${dd}`;
      this.dtNegociacao = this.dataEmissao;
    }

    // Guardamos a Promise (em vez de só disparar) porque o fluxo de "Gerar
    // Venda a Partir da O.S" precisa aguardar o Tipo de Operação padrão
    // carregar antes de gravar automaticamente — sem isso, formularioValido
    // ficaria intermitentemente falso dependendo da velocidade da rede.
    const tiposOperacaoPronto = this._carregarTiposOperacao();
    this._carregarVendedorLogado();
    this._carregarVendedores();
    this._carregarCotacoes();
    this._carregarTiposNegociacao();
    this._carregarCentrosResultado();
    this._carregarNaturezas();
    this.empresaState.carregar();

    // Opções de campos: carrega a lista de opções sempre, mas só aplica o
    // valor padrão em pedido NOVO — em edição o valor vem do backend.
    this._carregarOpcoesCampo('GPL_PRIORIDADE', (opcoes) => {
      this.prioridadeOpcoes = opcoes;
      if (!this.modoEdicao) {
        const normal = opcoes.find(o => o.valor === 'NORMAL');
        this.prioridade = normal ? normal.valor : (opcoes[0]?.valor ?? '');
      }
    });
    this._carregarOpcoesCampo('GPL_DESPACHAR', (opcoes) => {
      this.despacharOpcoes = opcoes;
      if (!this.modoEdicao) this.despachar = opcoes[0]?.valor ?? '';
    });
    this._carregarOpcoesCampo('GPL_FATIMEDIATO', (opcoes) => {
      this.fatImediatoOpcoes = opcoes;
      if (!this.modoEdicao) this.fatImediato = opcoes[0]?.valor ?? '';
    });
    this._carregarOpcoesCampo('GPL_TIPO', (opcoes) => {
      this.tipoGplOpcoes = opcoes;
      if (!this.modoEdicao) {
        const nacional = opcoes.find(o => o.valor === 'NACIONAL');
        this.tipoGpl = nacional ? nacional.valor : (opcoes[0]?.valor ?? '');
      }
    });
    this._carregarOpcoesCampo('AD_CATEGORIA', (opcoes) => {
      this.adCategoriaOpcoes = opcoes;
      if (!this.modoEdicao) {
        const receita = opcoes.find(o => o.valor.toUpperCase() === 'RECEITA');
        this.adCategoria = receita ? receita.valor : (opcoes[0]?.valor ?? '');
      }
    });
    this._carregarOpcoesCampo('GPL_STATUS', (opcoes) => {
      this.gplStatusOpcoes = opcoes;
      // Padrão "Aberto" — só aplica em novo pedido; em edição vem do backend
      if (!this.modoEdicao) {
        const aberto = opcoes.find(o => o.valor.toUpperCase() === 'ABERTO');
        this.gplStatus = aberto ? aberto.valor : (opcoes[0]?.valor ?? 'ABERTO');
      }
    });
    this._carregarOpcoesCampo('TIPFRETE', (opcoes) => {
      this.tipFreteOpcoes = opcoes;
      // Padrão vazio — campo opcional
    });
    this._carregarOpcoesCampo('CIF_FOB', (opcoes) => {
      this.cifFobOpcoes = opcoes;
      // Padrão vazio ("Selecione") — antes vinha pré-selecionado com a
      // primeira opção do combo nativo, escondendo do vendedor que o campo
      // nunca tinha sido escolhido de propósito.
    });
    this._carregarOpcoesCampo('GPL_FORMAENVIO', (opcoes) => {
      this.formaEnvioOpcoes = opcoes;
      if (!this.modoEdicao) this.formaEnvio = opcoes[0]?.valor ?? '';
    });

    // ── Disparar carga do pedido existente (modo edição) ──────────
    let pedidoCarregado: Promise<void> = Promise.resolve();
    if (this.modoEdicao && this.nunotaEditar != null) {
      pedidoCarregado = this.carregarPedidoParaEdicao(this.nunotaEditar as number);
    }

    // ── Ação de status "silenciosa" (Cancelar leve / Estornar) ────
    // Disparada pela Lista de Pedidos — carrega o pedido normalmente (acima),
    // troca só o(s) campo(s) de status e grava, tudo atrás de um overlay que
    // nunca deixa o formulário aparecer.
    if (this.acaoStatusPendente) {
      this.acaoStatusGravando = true;
      const acao = this.acaoStatusPendente;
      pedidoCarregado.then(() => this._executarAcaoStatusSilenciosa(acao));
    }

    // ── Importar itens vindos de uma O.S (Gerar Venda a Partir da O.S) ──
    // Reaproveita o mesmo mecanismo de revisão/validação da importação de Excel:
    // cada Part Number da O.S é consultado no sistema (mesma lógica de REFFORN),
    // e o usuário revisa encontrados/não-encontrados antes de confirmar.
    if (!this.modoEdicao && this.itensImportadosDeOS && this.itensImportadosDeOS.length > 0) {
      if (this.observacaoInicial) {
        // Referência de qual O.S. gerou o pedido vai na Observação Interna
        // (AD_OBSINT), não na Observação Venda (AD_OBS).
        this.observacaoInterna = this.observacaoInterna
          ? `${this.observacaoInterna}\n${this.observacaoInicial}`
          : this.observacaoInicial;
      }
      // Não aguardamos aqui — roda em paralelo com a validação dos PNs — mas
      // guardamos as Promises para esperar elas terminarem antes de decidir
      // se grava automaticamente. Isso é o que garante que a gravação
      // automática SEMPRE tenha Cliente + Tipo de Operação prontos (em vez de
      // depender da sorte de qual chamada de rede termina primeiro).
      const prontoParaGravar = Promise.all([
        this.origemOS ? this._autoPreencherClienteAeronaveDeOS(this.origemOS) : Promise.resolve(),
        tiposOperacaoPronto,
      ]);

      this.excelImportOrigemOS   = true;
      this.excelImportNomeArquivo = '';
      this.excelImportLinhas = this.itensImportadosDeOS.map(i => ({
        pn: i.pn,
        quantidade: i.quantidade > 0 ? i.quantidade : 1,
        status: 'pendente' as const,
        selecionado: true,
        vlrDescAcresc: i.vlrDescAcresc
      }));
      this.excelImportAberto    = true;
      this.excelImportValidando = true;
      this._validarPNsExcel().finally(async () => {
        this.excelImportValidando = false;
        await prontoParaGravar;
        await this._processarResultadoImportacaoOS();
      });
    }
  }

  /**
   * Decide o que fazer depois que os PNs da O.S foram validados:
   * - Se sobrou algum PN não encontrado, mantém a revisão manual (modal já
   *   está aberto) — não é seguro gravar automaticamente.
   * - Se só 1 item foi encontrado, confirma e grava direto, sem exigir clique.
   * - Se mais de 1 foi encontrado, deixa o modal aberto para o vendedor
   *   escolher quais confirmar (todos vêm pré-selecionados); ao confirmar,
   *   a própria confirmarImportacaoExcel() já grava direto.
   */
  private async _processarResultadoImportacaoOS(): Promise<void> {
    if (this.excelImportNaoEncontrados > 0 || this.excelImportEncontrados === 0) {
      return;
    }
    if (this.excelImportEncontrados === 1) {
      await this.confirmarImportacaoExcel();
    }
  }

  /**
   * Executa uma troca de status disparada pela Lista de Pedidos (Cancelar
   * leve, Estornar) ou pela Conferência (Finalizar). Faz um UPDATE isolado
   * só na coluna GPL_STATUS (atualizarGplStatusPedidoVenda) em vez de
   * reaproveitar o salvar() completo do formulário: o salvar() reenvia o
   * cabeçalho inteiro pro motor nativo do Sankhya, que revalida TODAS as
   * regras de negócio do pedido — inclusive coisas sem nenhuma relação com
   * o status, como a consistência moeda da Tabela de Preço x TOP
   * ("Configurações incoerentes"), que travava o Estornar em pedidos com
   * tabela de preço em moeda (ex.: Dólar) numa TOP não configurada pra
   * operações em moeda. GPL_STATUS é um campo nosso, sem significado nativo
   * pro Sankhya, então um UPDATE isolado é seguro e evita esse tipo de
   * revalidação indevida.
   */
  private async _executarAcaoStatusSilenciosa(
    acao: { nunota: number; novoGplStatus: string; novoCodTipOper?: number }
  ): Promise<void> {
    if (!this.modoEdicao || this.nunotaAtual !== acao.nunota) {
      // Segurança: se por algum motivo o pedido carregado não é o esperado,
      // não faz nada — evita gravar status errado em cima do pedido errado.
      this.acaoStatusGravando = false;
      this.acaoStatusConcluida.emit({
        nunota: acao.nunota,
        sucesso: false,
        mensagem: 'Não foi possível carregar o pedido para atualizar o status.'
      });
      return;
    }

    let sucesso = false;
    let mensagemErro: string | undefined;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.atualizarGplStatusPedidoVenda(acao.nunota, acao.novoGplStatus)
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        this.gplStatus = acao.novoGplStatus;
        sucesso = true;
      } else {
        mensagemErro = body?.erro ?? 'Erro ao atualizar status do pedido.';
      }
    } catch (err: any) {
      mensagemErro = err?.error?.erro ?? err?.message ?? 'Erro de comunicação.';
    }

    this.acaoStatusGravando = false;
    this.acaoStatusConcluida.emit({
      nunota: acao.nunota,
      sucesso,
      mensagem: mensagemErro
    });
  }

  /**
   * Ao gerar um Pedido de Venda a partir de uma O.S, tenta pré-selecionar o
   * mesmo Cliente e a mesma Aeronave da O.S automaticamente, para o vendedor
   * não precisar buscar de novo. Busca primeiro pela matrícula da aeronave
   * (que já retorna o cliente vinculado); se não achar, tenta pelo nome do
   * cliente. Se nada for encontrado, não bloqueia — o vendedor seleciona
   * manualmente, apenas com um aviso.
   */
  private async _autoPreencherClienteAeronaveDeOS(
    os: { numOs?: string | number; clienteNome?: string; aeronaveMatricula?: string }
  ): Promise<void> {
    const matricula = (os.aeronaveMatricula ?? '').trim();
    const clienteNome = (os.clienteNome ?? '').trim();

    if (matricula.length >= 2) {
      try {
        const res: any = await this.sankhyaGateway.buscarAeronavesEClientesGlobal(matricula).toPromise();
        const body = res?.responseBody ?? res;
        const prefixos: any[] = Array.isArray(body?.prefixos) ? body.prefixos : [];
        const match = prefixos.find(
          p => String(p.prefixo ?? '').trim().toUpperCase() === matricula.toUpperCase()
        ) ?? prefixos[0];

        if (match) {
          await this.selecionarAeronaveAutocomplete(match);
          return;
        }
      } catch {
        // segue para o fallback por nome do cliente
      }
    }

    if (clienteNome.length >= 2) {
      try {
        const res: any = await firstValueFrom(this.sankhyaGateway.buscarClientePedidoVenda(clienteNome));
        const lista = res?.responseBody?.lista ?? res?.lista ?? [];
        if (lista.length > 0) {
          await this.selecionarCliente(lista[0]);
          return;
        }
      } catch {
        // silencioso — cai no aviso abaixo
      }
    }

    this.abrirAlerta(
      `Não foi possível localizar automaticamente o cliente/aeronave da O.S. ${os.numOs ?? ''}. Selecione manualmente.`,
      'aviso'
    );
  }

  ngOnDestroy(): void {
    if (this._buscaPecasSubscription) {
      this._buscaPecasSubscription.unsubscribe();
    }
    if (this._rascunhoSubscription) {
      this._rascunhoSubscription.unsubscribe();
    }
    // Desregistra o guard de troca de empresa — sem isso, o singleton
    // EmpresaStateService continuaria chamando um callback de um componente
    // já destruído depois de sair da tela de Venda.
    this.empresaState.registrarGuardaTroca(null);
    this._descartarRascunhoAbandonado();
    // Devolve o seletor de empresa GLOBAL ao valor de antes de entrar na
    // edição (ver carregarPedidoParaEdicao) — sem isso, sair de um pedido de
    // empresa virtual (ex.: 10-Rio Verde), por Voltar, Cancelar ou depois de
    // Salvar, deixava a Lista de Pedidos e qualquer outra tela filtrando por
    // essa empresa até o usuário trocar manualmente de novo.
    if (this._empresaSelecionadaAntesDaEdicao !== null
        && this.empresaSelecionada !== this._empresaSelecionadaAntesDaEdicao) {
      this.empresaSelecionada = this._empresaSelecionadaAntesDaEdicao;
    }
  }

  /** Se o usuário sair da tela sem salvar de verdade, o rascunho criado só
   *  para calcular impostos em tempo real fica marcado CANCELADO (mesmo
   *  mecanismo do botão "Cancelar" leve — GPL_STATUS) para não deixar um
   *  pedido ABERTO órfão na Lista de Pedidos. Disparo silencioso, sem
   *  aguardar resposta (o componente já está sendo destruído). */
  private _descartarRascunhoAbandonado(): void {
    if (!this.nunotaRascunho || !this._ultimoPayloadRascunho) return;
    const nunota = this.nunotaRascunho;
    const payload = {
      ...this._ultimoPayloadRascunho,
      cabecalho: { ...this._ultimoPayloadRascunho.cabecalho, nunota, gplStatus: 'CANCELADO' },
    };
    this.sankhyaGateway.gravarPedidoVenda(payload).subscribe({
      error: (err) => console.warn('[PedidoVenda] Falha ao descartar rascunho NUNOTA=' + nunota, err),
    });
    this.nunotaRascunho = null;
    this._ultimoPayloadRascunho = null;
  }

  /**
   * Carrega as opções de um campo de lista do TGFCAB (TDDCAM/TDDOPC) via
   * CampoOpcoesComponentSP.doBuscarOpcoes — usado por Prioridade, Despachar,
   * Faturamento Imediato e Tipo, todos com o mesmo formato de retorno.
   */
  private async _carregarOpcoesCampo(
    nomeCampo: string,
    aplicar: (opcoes: OpcaoCampo[]) => void
  ): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarOpcoesCampoPedidoVenda('TGFCAB', nomeCampo)
      );

      // Retorno do addon CampoOpcoesComponentSP.doBuscarOpcoes:
      // { responseBody: { sucesso: boolean, opcoes: [{valor, opcao}] } }
      const body = res?.responseBody ?? res;
      const opcoes: OpcaoCampo[] = (body?.opcoes ?? []).map((o: any) =>
        typeof o === 'string' ? { valor: o, opcao: o } : { valor: o.valor ?? o, opcao: o.opcao ?? o.valor ?? o }
      );

      if (body?.sucesso && Array.isArray(opcoes) && opcoes.length > 0) {
        aplicar(opcoes);
      } else {
        // DEBUG temporário — remover após diagnosticar
        console.error(`[PedidoVenda] opções de ${nomeCampo} não retornadas. Resposta completa:`, res);
      }
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error(`[PedidoVenda] erro ao carregar opções de ${nomeCampo}:`, err);
    }
  }

  /** Tipo Negociação (Condição de Pagamento) — TipoNegociacaoComponentSP.doBuscarTiposVenda. */
  private async _carregarTiposNegociacao(): Promise<void> {
    this.tiposNegociacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarTiposNegociacaoPedidoVenda()
      );

      // Retorno do addon TipoNegociacaoComponentSP.doBuscarTiposVenda:
      // { responseBody: { sucesso: boolean, tiposVenda: [{ codTipVenda, descricao }] } }
      const body = res?.responseBody ?? res;
      const lista = body?.tiposVenda ?? [];

      if (body?.sucesso && Array.isArray(lista)) {
        // Descarta registros sem descrição (dado legado/zerado no TGFTPV) —
        // sem isso eles apareciam como linhas em branco na lista, dando a
        // impressão de que ela estava vazia. Descarta também o
        // "0 - <SEM TIPO DE VENDA>" (registro fictício do Sankhya) -- não
        // deve aparecer como opção selecionável.
        this.tiposNegociacaoOpcoes = lista
          .filter((t: any) => !!t?.descricao && String(t.descricao).trim().length > 0)
          .filter((t: any) => String(t?.codTipVenda ?? '').trim() !== '0')
          .sort((a: any, b: any) => String(a.descricao).localeCompare(String(b.descricao)));
      } else {
        // Mantém o fallback (código 1 = A VISTA DINHEIRO) em vez de zerar a
        // lista, para o campo não ficar sem nenhuma opção em caso de falha.
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] tipos de negociação não retornados. Resposta completa:', res);
      }
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar tipos de negociação:', err);
    } finally {
      this.tiposNegociacaoCarregando = false;
    }
  }

  /** Centro de Resultado — CentroResultadoComponentSP.doBuscarCentrosResultado. */
  private async _carregarCentrosResultado(): Promise<void> {
    this.centrosResultadoCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarCentrosResultadoPedidoVenda()
      );

      const body = res?.responseBody ?? res;
      const lista = body?.centros ?? [];

      if (body?.sucesso && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((c: any) => c != null)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));

        // Garante que o código 0 (padrão) esteja sempre na lista
        const temZero = itens.some((c: any) => String(c.codCen) === '0');
        if (!temZero) {
          itens.unshift({ codCen: '0', descricao: 'Nenhum' });
        }
        this.centrosResultadoOpcoes = itens;
      } else {
        console.error('[PedidoVenda] centros de resultado - erro do servidor:', body?.erro ?? body?.statusMessage ?? 'sem mensagem');
        console.error('[PedidoVenda] centros de resultado - resposta completa:', JSON.stringify(res));
      }
    } catch (err) {
      console.error('[PedidoVenda] erro ao carregar centros de resultado:', err);
    } finally {
      this.centrosResultadoCarregando = false;
    }
  }

  /** Natureza — NaturezaComponentSP.doBuscarNaturezas. */
  private async _carregarNaturezas(): Promise<void> {
    this.naturezasCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarNaturezasPedidoVenda()
      );

      const body = res?.responseBody ?? res;
      const lista = body?.naturezas ?? [];

      if (body?.sucesso && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((n: any) => n != null)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));

        // Garante que o código 0 (padrão) esteja sempre na lista
        const temZero = itens.some((n: any) => String(n.codNat) === '0');
        if (!temZero) {
          itens.unshift({ codNat: '0', descricao: 'Nenhuma' });
        }
        this.naturezasOpcoes = itens;
      } else {
        console.error('[PedidoVenda] naturezas não retornadas. Resposta completa:', res);
      }
    } catch (err) {
      console.error('[PedidoVenda] erro ao carregar naturezas:', err);
    } finally {
      this.naturezasCarregando = false;
    }
  }

  /** Status financeiro — ParceiroGlobalSP.doBuscarStatusFinanceiro (VW_DS_STATUSFINPARC). */
  private async _carregarStatusFinanceiro(codparc: string | number): Promise<void> {
    this.creditoCarregando = true;
    this.creditoInfo = null;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarStatusFinanceiroPedidoVenda(codparc)
      );
      const body = res?.responseBody ?? res;
      console.log('[PedidoVenda] status financeiro res:', res);
      console.log('[PedidoVenda] status financeiro body:', body);
      if (body?.sucesso) {
        this.creditoInfo = {
          limiteCred:  Number(body.limiteCred  ?? 0),
          creditoDisp: Number(body.creditoDisp ?? 0),
          pendente:    Number(body.pendente    ?? 0),
          atrasado:    Number(body.atrasado    ?? 0),
          conceito:    String(body.conceito    ?? ''),
        };
      }
    } catch (err) {
      console.error('[PedidoVenda] erro ao carregar status financeiro:', err);
    } finally {
      this.creditoCarregando = false;
    }
  }


  /**
   * Aeronave (AD_TCADAERO) vinculada ao cliente via AD_AEROPAR, filtrando
   * pelo CODPARC exato do cliente selecionado — AeronaveGlobalSP.doBuscarPrefixosPorCliente.
   * (Antes filtrava por CNPJ/CPF, mas isso trazia aeronaves de outros
   * cadastros de parceiro com o mesmo documento; filtrar por CODPARC
   * resolve.) Disparado ao selecionar/limpar o cliente.
   */
  private async _carregarAeronaves(codparc: string | number | null | undefined): Promise<void> {
    if (!codparc) {
      this.aeronaveOpcoes = [];
      this.aeronaveSelecionada = '';
      return;
    }

    this.aeronaveCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarAeronavesPedidoVenda(codparc)
      );

      // Retorno do addon AeronaveGlobalSP.doBuscarPrefixosPorCliente:
      // { responseBody: { sucesso: boolean, prefixos: [{ codaero, prefixo }] } }
      const body = res?.responseBody ?? res;
      const lista = body?.prefixos ?? [];

      if (body?.sucesso && Array.isArray(lista)) {
        this.aeronaveOpcoes = lista;
        this.aeronaveSelecionada = lista.length === 1 ? lista[0].codaero : '';
        if (this.aeronaveSelecionada && lista.length === 1) {
            this.aeronaveBusca = lista[0].prefixo;
        } else {
            this.aeronaveBusca = '';
        }
      } else {
        this.aeronaveOpcoes = [];
        this.aeronaveSelecionada = '';
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] aeronaves não retornadas. Resposta completa:', res);
      }
    } catch (err) {
      this.aeronaveOpcoes = [];
      this.aeronaveSelecionada = '';
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar aeronaves:', err);
    } finally {
      this.aeronaveCarregando = false;
    }
  }

  private async _carregarVendedores(): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarVendedoresPedidoVenda()
      );

      // Retorno do addon GrupoProdutosGlobalSP.doBuscarVendedores:
      // { responseBody: { sucesso: boolean, vendedores: [{ codVend, apelido }] } }
      const body = res?.responseBody ?? res;
      const lista = body?.vendedores ?? [];

      if (body?.sucesso && Array.isArray(lista)) {
        // Descarta o "0 - <SEM VENDEDOR>" (registro fictício do Sankhya pra
        // pedido sem vendedor definido) -- não deve aparecer como opção
        // selecionável, o pedido tem que sempre ter um vendedor válido.
        this.vendedores = lista.filter((v: any) => String(v?.codVend ?? '').trim() !== '0');
        this._aplicarVendedorPadraoPorNome();
      } else {
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] vendedores não retornados. Resposta completa:', res);
      }
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar vendedores:', err);
    }
  }

  /** Sem vendedor ligado ao usuário no Sankhya (codVend 0): escolhe o vendedor pelo nome do login (igual ao Pedido de Compra). */
  private _aplicarVendedorPadraoPorNome(): void {
    if (this.modoEdicao || String(this.codVendLogado ?? '').trim() !== '') return;
    const cod = codVendCompradorDoUsuario(this.vendedores);
    if (cod != null) this.codVendLogado = cod;
  }

  abrirBuscaVendedor(): void {
    this.filtroVendedor = '';
    this.vendedorModalAberta = true;
  }

  fecharBuscaVendedor(): void {
    this.vendedorModalAberta = false;
  }

  selecionarVendedor(v: VendedorOpcao): void {
    this.codVendLogado = v.codVend;
    this.vendedorModalAberta = false;
  }

  limparVendedor(): void {
    this.codVendLogado = null;
  }

  private async _carregarVendedorLogado(): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarVendedorLogadoPedidoVenda()
      );

      // Retorno do addon ParceiroGlobalSP.doBuscarVendedorLogado:
      // { responseBody: { sucesso: boolean, vendedor: { codVend, apelido } } }
      const body = res?.responseBody ?? res;
      const vend = body?.vendedor ?? {};

      // "0 - <SEM VENDEDOR>" é registro fictício do Sankhya -- não conta
      // como vendedor logado válido, o campo tem que ficar vazio (obrigando
      // o usuário a escolher um vendedor de verdade).
      const codVendLogadoValido = String(vend?.codVend ?? '').trim() !== '0';

      if (body?.sucesso && vend?.apelido) {
        // Em modo edição o vendedor vem do backend — não sobrescrever
        if (!this.modoEdicao) {
          this.codVendLogado = codVendLogadoValido ? (vend.codVend ?? null) : null;
        }
        // Garante que o apelido apareça no input mesmo sem a lista completa
        if (codVendLogadoValido && vend.codVend && !this.vendedores.some(v => String(v.codVend) === String(vend.codVend))) {
          this.vendedores = [...this.vendedores, { codVend: vend.codVend, apelido: vend.apelido }];
        }
        this._aplicarVendedorPadraoPorNome();
      } else {
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] vendedor logado não retornado. Resposta completa:', res);
      }
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar vendedor logado:', err);
    }
  }

  private async _carregarTiposOperacao(): Promise<void> {
    this.tiposOperacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarTiposOperacaoPedidoVenda()
      );

      // Retorno do addon TipoOperacaoComponentSP.doBuscarTiposOperacao:
      // { responseBody: { sucesso: boolean, tipos: [{ codigo, descricao }] } }
      const body = res?.responseBody ?? res;
      const tipos = body?.tipos ?? [];

      if (body?.sucesso && Array.isArray(tipos) && tipos.length > 0) {
        this.tiposOperacao = tipos;

        // Padrão: código 1000. Fallback: descrição "PEDIDO DE VENDA".
        const por1000 = tipos.find((t: { codigo: string | number }) => String(t.codigo) === '1000');
        const porDesc = tipos.find((t: { descricao: string }) =>
          (t.descricao || '').trim().toUpperCase() === 'PEDIDO DE VENDA'
        );
        const padrao = por1000 ?? porDesc;
        if (padrao) {
          this.tipoOperacao = padrao.codigo;
        }
      } else {
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] tipos de operação não retornados. Resposta completa:', res);
      }
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar tipos de operação:', err);
    } finally {
      this.tiposOperacaoCarregando = false;
    }
  }

  /** Ao trocar a Categoria (AD_CATEGORIA) pra Transferência, troca automaticamente
   *  o Tipo de Operação pra TOP 1152 — a venda de transferência nasce direto
   *  nessa TOP (nunca passa por Orçamento/1000), mas segue o mesmo fluxo de
   *  Autorização/Separação/Conferência de um Pedido de Venda normal (ver
   *  autorizarPedido no GPL/model: não tenta converter a TOP quando ela já é
   *  1152, só quando é 1000/Orçamento). Voltando pra Receita, restaura a TOP
   *  padrão (1000) — só se ainda estiver em 1152 (nunca mexe numa TOP que o
   *  usuário/backend tenha definido por outro motivo). */
  onAdCategoriaChange(): void {
    const categoria = (this.adCategoria || '').toUpperCase();
    if (categoria === 'TRANSFERENCIA') {
      const top1152 = this.tiposOperacao.find(t => String(t.codigo) === '1152');
      if (top1152) this.tipoOperacao = top1152.codigo;
    } else if (String(this.tipoOperacao) === '1152') {
      const top1000 = this.tiposOperacao.find(t => String(t.codigo) === '1000');
      if (top1000) this.tipoOperacao = top1000.codigo;
    }
  }

  /**
   * Retorna true se QUALQUER modal/overlay da tela estiver aberto. Usado
   * pelo bloqueio de teclado abaixo (TAB/ENTER não podem "vazar" pra trás
   * do modal). Lista precisa cobrir todos os *ngIf="...Aberta/Aberto" de
   * modal-overlay/excel-confirm-overlay do template.
   */
  private algumModalAberto(): boolean {
    return !!(
      this.confirmacaoSairAberta ||
      this.confirmacaoTrocaEmpresaAberta ||
      this.vendedorModalAberta ||
      this.cotacaoModalAberta ||
      this.tipoNegociacaoModalAberta ||
      this.centroResultadoModalAberta ||
      this.naturezaModalAberta ||
      this.aeronaveModalAberta ||
      this.clienteModalAberta ||
      this.produtoModalAberta ||
      this.buscaPecasAberta ||
      this.imagemPreviewAberta ||
      this.confirmacaoEstoqueAberta ||
      this.confirmarRemocaoAberta ||
      this.modalAvisoAberto ||
      this.modalConflitoAberto ||
      this.excelImportAberto ||
      this.confirmacaoAtualizarCotacaoAberta ||
      this.confirmacaoAtualizarPrecoAberta ||
      this.confirmacaoAtualizarPrecosDesatualizadosAberta
    );
  }

  /**
   * Bloqueia TAB e ENTER em qualquer elemento que esteja FORA do modal
   * aberto no momento — o overlay visual já impede clique, mas o teclado
   * (Tab pra navegar entre campos, Enter pra "clicar" no campo focado)
   * ignora z-index/posição visual e continua alcançando os campos "por
   * trás" da tela. Pedido do usuário: com a mensagem/modal na tela, TAB e
   * ENTER continuavam funcionando no formulário de fundo.
   * Usa @HostListener (integrado à zone do Angular, gerenciado pelo próprio
   * framework) — não é o mesmo mecanismo do antigo addEventListener manual
   * removido nesta sessão (aquele era suspeito de travamento; este aqui é
   * um listener comum, leve, só ativo quando há modal aberto).
   */
  /** Botão Voltar do navegador — reaproveita a MESMA confirmação do botão
   *  Voltar/Fechar do cabeçalho (ver history.pushState no ngOnInit). Cada
   *  vez que o usuário aperta Voltar, reempurra a entrada de guarda na hora
   *  (o usuário não chega a ver nada mudar) e dispara onVoltarClick() —
   *  que já decide sozinho: some direto se for só-leitura, ou abre o modal
   *  "Deseja realmente sair da tela de VENDA?" se houver algo a confirmar. */
  @HostListener('window:popstate')
  onBrowserBackButton(): void {
    history.pushState({ pedidoVendaGuard: true }, '');
    this.onVoltarClick();
  }

  @HostListener('window:keydown', ['$event'])
  onKeydownBloqueioModal(ev: KeyboardEvent): void {
    if (ev.key !== 'Tab' && ev.key !== 'Enter') return;
    if (!this.algumModalAberto()) return;
    const target = ev.target as HTMLElement | null;
    if (target && target.closest('.modal-overlay, .excel-confirm-overlay')) return;
    ev.preventDefault();
    ev.stopPropagation();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    if (!target.closest('.cliente-autocomplete')) {
      this.mostrarDropdownCliente = false;
    }
    if (!target.closest('.local-picker')) {
      this.fecharSeletorLocal();
    }
    if (!target.closest('.gpl-copiar-wrap')) {
      this.gplCopiarMenuTipo = null;
    }
  }

  /** Fecha o modal de Busca de Peças ao pressionar ESC e retorna o foco ao campo PN de origem */
  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.buscaPecasAberta) {
      this.fecharBuscaPecas(true);
    }
  }

  /** Enter fecha o modal de aviso simples (ex.: "Atenção" de produto
   *  controlado) direto no OK, sem precisar tirar a mão do teclado pra
   *  clicar -- mesmo padrão do Escape acima pra Busca de Peças. Só age
   *  quando o modal está de fato aberto, então não interfere no Enter
   *  usado em qualquer outro campo/fluxo do resto da tela. */
  @HostListener('document:keydown.enter', ['$event'])
  onEnterKeyModalAviso(event: KeyboardEvent): void {
    if (this.modalAvisoAberto) {
      event.preventDefault();
      this.fecharModalAviso();
    }
  }

  /** Setas ←/→ navegam entre as imagens do produto quando o preview ampliado está aberto. */
  @HostListener('document:keydown.arrowleft')
  onArrowLeftImagemPreview(): void {
    if (this.imagemPreviewAberta) this.imagemPreviewNavegar(-1);
  }

  @HostListener('document:keydown.arrowright')
  onArrowRightImagemPreview(): void {
    if (this.imagemPreviewAberta) this.imagemPreviewNavegar(1);
  }

  // ── Busca de cliente ───────────────────────────────────────
  /**
   * Disparado a cada tecla digitada. Quando havia um cliente selecionado
   * (input mostrando "Nome | Doc | AD_COM | IE"), a primeira edição remove
   * automaticamente o trecho informativo (tudo a partir do primeiro " | "),
   * deixando só o nome para uma nova busca — ou seja, só o nome é editável;
   * o restante é informativo.
   */
  onClienteInput(): void {
    if (this.clienteSelecionado) {
      const idx = this.clienteBusca.indexOf('   |   ');
      if (idx >= 0) {
        this.clienteBusca = this.clienteBusca.substring(0, idx);
      }
    }

    this.clienteSelecionado = null;
    this.titulosClientePosicionados = [];
    this.mostrarEnderecos = false;
    clearTimeout(this._clienteTimer);
    const termo = this.clienteBusca.trim();
    if (termo.length < 2) {
      this.clienteSugestoes = [];
      this.mostrarDropdownCliente = false;
      return;
    }
    this._clienteTimer = setTimeout(() => this._buscarClientes(termo), 350);
  }

  /**
   * Disparado ao focar/clicar no campo. Se já havia um cliente selecionado,
   * limpa o campo na hora (igual ao comportamento original) para já deixar
   * pronto para uma nova busca, em vez de precisar apagar o texto manualmente.
   */
  onClienteFocus(): void {
    if (this.clienteSelecionado) {
      this._clienteAnterior = this.clienteSelecionado;
      // Salva snapshot completo do estado — permite restaurar sem re-carregar serviços
      this._snapshotCliente = {
        endFaturamento:               { ...this.endFaturamento },
        endEntrega:                   { ...this.endEntrega },
        endEntregaIgualFaturamento:   this.endEntregaIgualFaturamento,
        mostrarEnderecos:             this.mostrarEnderecos,
        aeronaveOpcoes:               [...this.aeronaveOpcoes],
        aeronaveSelecionada:          this.aeronaveSelecionada,
        aeronaveBusca:                this.aeronaveBusca,
        enderecosDisponiveis:          [...this.enderecosDisponiveis],
        enderecosEntregaDisponiveis:   [...this.enderecosEntregaDisponiveis],
        codparcFaturamentoSelecionado: this.codparcFaturamentoSelecionado,
        codparcEntregaSelecionado:    this.codparcEntregaSelecionado,
        pessoaEntregaSelecionada:         this.pessoaEntregaSelecionada ? { ...this.pessoaEntregaSelecionada } : null,
        pessoaEntregaBusca:               this.pessoaEntregaBusca,
        titulosPessoaEntregaPosicionados: [...this.titulosPessoaEntregaPosicionados],
        creditoInfo:                      this.creditoInfo ? { ...this.creditoInfo } : null,
        titulosClientePosicionados:   [...this.titulosClientePosicionados],
      };
      // Soft clear: limpa apenas o texto e a referência ao cliente - não toca no
      // restante (endereços, crédito) para evitar flicker na restauração
      this.clienteSelecionado = null;
      this.clienteBusca = '';
      this.aeronaveBusca = '';
      this.titulosClientePosicionados = [];
      this.clienteSugestoes = [];
      this.mostrarDropdownCliente = false;
      return;
    }
    const termo = this.clienteBusca.trim();
    if (termo.length >= 2) {
      this.mostrarDropdownCliente = true;
      if (this.clienteSugestoes.length === 0) {
        this._buscarClientes(termo);
      }
    }
  }

  // ── Busca de Cliente via modal (lupa) ───────────────────────
  abrirBuscaCliente(): void {
    this.filtroClienteModal = '';
    this.clienteSugestoesModal = [];
    this.clienteModalAberta = true;
  }

  fecharBuscaCliente(): void {
    this.clienteModalAberta = false;
  }

  onFiltroClienteModalChange(): void {
    clearTimeout(this._clienteModalTimer);
    const termo = this.filtroClienteModal.trim();
    if (termo.length < 2) {
      this.clienteSugestoesModal = [];
      this.clienteModalCarregando = false;
      return;
    }
    this.clienteModalCarregando = true;
    this._clienteModalTimer = setTimeout(() => this._buscarClientesModal(termo), 350);
  }

  private async _buscarClientesModal(termo: string): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarClientePedidoVenda(termo)
      );
      const lista = res?.responseBody?.lista ?? res?.lista ?? [];
      this.clienteSugestoesModal = lista.slice(0, 20);
    } catch {
      this.clienteSugestoesModal = [];
    } finally {
      this.clienteModalCarregando = false;
    }
  }

  async selecionarClienteModal(c: ClienteSugestao): Promise<void> {
    this.clienteModalAberta = false;
    await this.selecionarCliente(c);
  }

  /** Monta o texto exibido no input: "CODPARC - Nome | Doc | AD_COM | IE". */
  private _montarTextoCliente(c: ClienteSugestao): string {
    const nomeComCodigo = c.nomeparc || '';
    const partes = [
      c.docparc      ? this.fmtDocumento(c.docparc)      : null,
      c.adCom        ? c.adCom                            : null,
      c.inscEstadual ? this.fmtIE(c.inscEstadual)         : null,
    ].filter(p => !!p && String(p).trim().length > 0) as string[];
    return partes.length > 0 ? `${nomeComCodigo}   |   ${partes.join('   |   ')}` : nomeComCodigo;
  }

  // ── Dropdown "Copiar dados" (Cliente / Pessoa de Entrega / Transportadora /
  // Parceiro comissão / NCM) — REESCRITO DO ZERO (nomes/classes novos de
  // propósito, sem reaproveitar nada do código antigo) porque não foi
  // possível isolar com certeza a causa de um travamento de tela relatado
  // pelo usuário ao clicar nas opções antigas. Pedido do usuário: refazer
  // em vez de continuar tentando consertar às cegas em produção. ──
  gplCopiarMenuTipo: 'cliente' | 'pessoaEntrega' | 'transp' | 'comissao' | null = null;
  mensagemCentral: string | null = null;
  private _mensagemCentralTimeout: any = null;

  gplAbrirMenuCopiar(tipo: 'cliente' | 'pessoaEntrega' | 'transp' | 'comissao', event: Event): void {
    event.stopPropagation();
    this.gplCopiarMenuTipo = this.gplCopiarMenuTipo === tipo ? null : tipo;
  }

  /** Parceiro atualmente selecionado no campo correspondente ao tipo do menu. */
  private _gplParceiroParaCopiar(tipo: 'cliente' | 'pessoaEntrega' | 'transp' | 'comissao'): ClienteSugestao | null {
    switch (tipo) {
      case 'cliente':       return this.clienteSelecionado;
      case 'pessoaEntrega': return this.pessoaEntregaSelecionada;
      case 'transp':        return this.transpSelecionada;
      case 'comissao':      return this.comissaoUsuarioSelecionado;
    }
  }

  /** Monta a lista de campos copiáveis do parceiro selecionado — só entram os campos que existem. */
  gplItensCopiaveis(tipo: 'cliente' | 'pessoaEntrega' | 'transp' | 'comissao'): { label: string; valor: string }[] {
    const c = this._gplParceiroParaCopiar(tipo);
    if (!c) return [];
    const itens: { label: string; valor: string }[] = [];
    if (c.nomeparc && c.nomeparc.trim()) {
      itens.push({ label: 'Nome', valor: c.nomeparc.trim() });
    }
    if (c.docparc && String(c.docparc).trim()) {
      itens.push({ label: 'CNPJ/CPF', valor: this.fmtDocumento(c.docparc) });
    }
    if (c.adCom && String(c.adCom).trim()) {
      itens.push({ label: 'COM', valor: String(c.adCom).trim() });
    }
    if (c.inscEstadual && String(c.inscEstadual).trim()) {
      itens.push({ label: 'Insc. Estadual', valor: this.fmtIE(c.inscEstadual) });
    }
    return itens;
  }

  // ── NCM (colunas Alíq. IPI / Vlr. IPI / Vlr. ST) ──
  // Usa tooltip nativo do navegador (atributo title) em vez de popover
  // customizado: um popover position:fixed calculado via JS se mostrou
  // frágil aqui (ficava invisível mesmo com addon/integração atualizados —
  // provavelmente clipping/stacking-context em algum ancestor). O title
  // nativo nunca é cortado por overflow/z-index de nada. Clique copia o NCM
  // (ver gplCopiarCampo() logo abaixo).

  gplCopiarCampo(valor: string, label: string, mensagemCustom?: string): void {
    const msgSucesso = mensagemCustom ?? `${label} copiado!`;
    navigator.clipboard?.writeText?.(valor)?.catch(() => {});
    this._exibirMensagemCentral(msgSucesso);
    // Fecha o menu numa macrotask separada (setTimeout 0) em vez de na
    // hora — evita alterar, ainda dentro do handler síncrono do clique, o
    // estado que remove do DOM o próprio botão que originou o clique
    // (o *ngIf do menu fecha quando gplCopiarMenuTipo vira null).
    setTimeout(() => { this.gplCopiarMenuTipo = null; }, 0);
  }

  /** Mensagem central de feedback rápido — aparece por 2s no meio da tela e
   *  some sozinha. Estilo 100% inline no .html (não depende do .css
   *  externo do componente). */
  private _exibirMensagemCentral(msg: string): void {
    this.mensagemCentral = msg;
    if (this._mensagemCentralTimeout) clearTimeout(this._mensagemCentralTimeout);
    this._mensagemCentralTimeout = setTimeout(() => { this.mensagemCentral = null; }, 2000);
  }

  /**
   * Calcula a posição (em px) de cada título (CNPJ/CPF, COM, Insc. Estadual)
   * medindo a largura real do texto que vem antes dele dentro do input —
   * assim o título acompanha o campo mesmo quando o nome do cliente é maior
   * ou menor. Só entra na lista o título cujo campo o cliente tiver.
   */
  private _recalcularTitulosCliente(c: ClienteSugestao | null): void {
    if (!c) {
      this.titulosClientePosicionados = [];
      this.clienteInputStartX = this.CLIENTE_INPUT_TEXT_START_PX;
      return;
    }

    if (!this._clienteCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._clienteCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._clienteCanvasCtx;
    if (!ctx) {
      this.titulosClientePosicionados = [];
      return;
    }
    ctx.font = this.CLIENTE_INPUT_FONT;

    const campos: { label: string; valor?: string; display?: string }[] = [
      { label: 'CNPJ/CPF',      valor: c.docparc,      display: this.fmtDocumento(c.docparc) },
      { label: 'COM',            valor: c.adCom,         display: c.adCom },
      { label: 'Insc. Estadual', valor: c.inscEstadual,  display: this.fmtIE(c.inscEstadual) },
    ];

    const nomeComCodigo = c.nomeparc || '';
    const larguraNome = ctx.measureText(nomeComCodigo).width;
    this.clienteInputStartX = this._calcularStartXInput('Cliente', false, larguraNome);
    let offset = this.clienteInputStartX + larguraNome;
    const titulos: TituloClientePosicionado[] = [];

    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) {
        continue;
      }
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }

    this.titulosClientePosicionados = titulos;
  }

  private async _buscarClientes(termo: string): Promise<void> {
    this.clienteCarregando = true;
    this.mostrarDropdownCliente = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarClientePedidoVenda(termo)
      );
      const lista = res?.responseBody?.lista ?? res?.lista ?? [];
      this.clienteSugestoes = lista.slice(0, 20);
    } catch {
      this.clienteSugestoes = [];
    } finally {
      this.clienteCarregando = false;
    }
  }

  /**
   * Disparado ao sair do campo (blur). Se o usuário não digitou nada nem
   * escolheu um novo cliente, restaura o cliente que estava preenchido
   * antes do campo ser limpo (ver onClienteFocus). O pequeno delay dá tempo
   * para o clique em uma sugestão do dropdown (ou no modal) ser processado
   * primeiro, já que o blur dispara antes do click.
   */
  onClienteBlur(): void {
    setTimeout(() => {
      if (!this.clienteSelecionado) {
        if (this.clienteBusca.trim() !== '' && this.clienteSugestoes.length > 0) {
          // Auto-seleciona o primeiro resultado da lista quando o usuário
          // sai do campo sem clicar em nenhuma sugestão.
          this._clienteAnterior = null;
          this._snapshotCliente = null;
          this.selecionarCliente(this.clienteSugestoes[0]);
        } else if (this.clienteBusca.trim() === '' && this._clienteAnterior) {
          // Campo apagado sem nova seleção — restaura o cliente anterior
          // usando o snapshot para preservar aeronave, endereços, crédito, etc.
          const c = this._clienteAnterior;
          const snap = this._snapshotCliente;

          this.clienteSelecionado = c;
          this.clienteBusca = this._montarTextoCliente(c);

          if (snap) {
            this.titulosClientePosicionados   = snap.titulosClientePosicionados;
            this.endFaturamento               = snap.endFaturamento;
            this.endEntrega                   = snap.endEntrega;
            this.endEntregaIgualFaturamento   = snap.endEntregaIgualFaturamento;
            this.mostrarEnderecos             = snap.mostrarEnderecos;
            this.aeronaveOpcoes               = snap.aeronaveOpcoes;
            this.aeronaveSelecionada          = snap.aeronaveSelecionada;
            if (snap.aeronaveBusca !== undefined) this.aeronaveBusca = snap.aeronaveBusca;
            this.enderecosDisponiveis          = snap.enderecosDisponiveis;
            this.enderecosEntregaDisponiveis   = snap.enderecosEntregaDisponiveis;
            this.codparcFaturamentoSelecionado = snap.codparcFaturamentoSelecionado;
            this.codparcEntregaSelecionado    = snap.codparcEntregaSelecionado;
            this.pessoaEntregaSelecionada            = snap.pessoaEntregaSelecionada;
            this.pessoaEntregaBusca                  = snap.pessoaEntregaBusca;
            this.titulosPessoaEntregaPosicionados    = snap.titulosPessoaEntregaPosicionados;
            this.creditoInfo = this.creditoInfo ?? snap.creditoInfo;
            if (!this.creditoInfo) {
              this._carregarStatusFinanceiro(c.codparc);
            }
          } else {
            this._recalcularTitulosCliente(c);
          }

          this._clienteAnterior = null;
          this._snapshotCliente = null;
        }
      }
      this.mostrarDropdownCliente = false;
    }, 200);
  }

  /** Limpa o cliente por ação explícita do usuário (botão ✕) — não deve
   *  ser restaurado depois ao perder o foco. */
  removerCliente(): void {
    this._clienteAnterior = null;
    this._snapshotCliente = null;
    this.limparCliente();
  }

  async selecionarCliente(c: ClienteSugestao): Promise<void> {
    this._clienteAnterior = null;
    this._snapshotCliente = null;
    this.clienteSelecionado = c;
    this.clienteBusca = this._montarTextoCliente(c);
    this._recalcularTitulosCliente(c);
    // Revalida itens já lançados: o limite de produto controlado (CPF/CNPJ)
    // depende do cliente, então um item adicionado antes de escolher o
    // cliente (ou ao trocar de cliente) precisa ser checado agora.
    this.itens.forEach(i => this.validarQtdControlado(i));
    this.mostrarDropdownCliente = false;
    this.clienteSugestoes = [];
    this.aeronaveBusca = '';
    this.aeronaveSelecionada = '';
    // Pessoa de entrega começa igual ao cliente de faturamento
    this.pessoaEntregaSelecionada = c;
    this.pessoaEntregaBusca = this._montarTextoCliente(c);
    this._recalcularTitulosPessoaEntrega(c);
    await this._carregarEnderecos(c.codparc);
    await this._carregarAeronaves(c.codparc);
    await this._carregarEnderecosDisponiveis(c.docparc || '');
    // Pessoa de entrega começa igual ao cliente — espelha a lista de endereços
    this.enderecosEntregaDisponiveis = [...this.enderecosDisponiveis];
    this._carregarStatusFinanceiro(c.codparc);
    // Cliente definido: se já houver itens lançados, aproveita para calcular
    // IPI/ST reais em segundo plano (ver _agendarRascunhoImpostos).
    this._agendarRascunhoImpostos();
  }

  limparCliente(): void {
    this.clienteSelecionado = null;
    this.clienteBusca = '';
    this.titulosClientePosicionados = [];
    this.clienteSugestoes = [];
    this.mostrarDropdownCliente = false;
    this.mostrarEnderecos = false;
    this.endFaturamento = this._enderecoVazio();
    this.endEntrega = this._enderecoVazio();
    this.endEntregaIgualFaturamento = true;
    this.aeronaveOpcoes = [];
    this.aeronaveSelecionada = '';
    this.aeronaveBusca = '';
    this.enderecosDisponiveis = [];
    this.enderecosEntregaDisponiveis = [];
    this.codparcFaturamentoSelecionado = '';
    this.codparcEntregaSelecionado = '';
    this.pessoaEntregaSelecionada = null;
    this.pessoaEntregaBusca = '';
    this.titulosPessoaEntregaPosicionados = [];
    this._pessoaEntregaAnterior = null;
    this.creditoInfo = null;
  }

  // ── Endereços ──────────────────────────────────────────────
  private async _carregarEnderecos(codparc: string | number): Promise<void> {
    this.enderecoCarregando = true;
    this.mostrarEnderecos = false;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarEnderecoClientePedidoVenda(codparc)
      );

      // Retorno do addon ParceiroGlobalSP.doBuscarEnderecoCliente:
      // { responseBody: { sucesso: boolean, faturamento: { ENDERECO, NUMEND, COMPLEMENTO, BAIRRO, CEP, NOMECID, UF } } }
      const body = res?.responseBody ?? res;
      const fat = body?.faturamento ?? {};

      if (!body?.sucesso) {
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] endereco sucesso=false. Resposta completa:', res);
        this.endFaturamento = this._enderecoVazio();
        this.endEntrega = this._enderecoVazio();
        this.endEntregaIgualFaturamento = true;
        return;
      }

      this.endFaturamento = {
        logradouro:  fat.ENDERECO ?? '',
        numero:      fat.NUMEND ?? '',
        complemento: fat.COMPLEMENTO ?? '',
        bairro:      fat.BAIRRO ?? '',
        cep:         fat.CEP ?? '',
        cidade:      fat.NOMECID ?? '',
        uf:          fat.UF ?? '',
      };

      // Endereço de entrega ainda não tem fonte própria no Sankhya —
      // por padrão começa como cópia do faturamento (usuário pode editar
      // livremente ou usar o botão "copiar" para resincronizar).
      this.endEntrega = { ...this.endFaturamento };
      this.endEntregaIgualFaturamento = true;

      // Endereço default = o do CODPARC selecionado na tela.
      this.codparcFaturamentoSelecionado = codparc;
      this.codparcEntregaSelecionado = codparc;
    } catch (err) {
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar endereco:', err);
      // Falha na busca — campos em branco para preenchimento manual
      this.endFaturamento = this._enderecoVazio();
      this.endEntrega = this._enderecoVazio();
      this.endEntregaIgualFaturamento = true;
    } finally {
      this.enderecoCarregando = false;
      this.mostrarEnderecos = true;
    }
  }

  /**
   * Busca todos os endereços (um por CODPARC) vinculados ao mesmo
   * CNPJ/CPF do cliente selecionado — permite escolher, no Faturamento e
   * na Entrega (cada um independente), qual desses cadastros usar.
   */
  private async _carregarEnderecosDisponiveis(cnpj: string): Promise<void> {
    const digitos = (cnpj || '').replace(/\D/g, '');
    if (!digitos) {
      this.enderecosDisponiveis = [];
      return;
    }

    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarEnderecosPorCnpjPedidoVenda(digitos)
      );

      // Retorno do addon ParceiroGlobalSP.doBuscarEnderecosPorCnpj:
      // { responseBody: { sucesso: boolean, enderecos: [{ codparc, nomeparc, ENDERECO, NUMEND, ... }] } }
      const body = res?.responseBody ?? res;
      const lista = body?.enderecos ?? [];

      if (body?.sucesso && Array.isArray(lista)) {
        this.enderecosDisponiveis = lista;
      } else {
        this.enderecosDisponiveis = [];
        // DEBUG temporário — remover após diagnosticar
        console.error('[PedidoVenda] endereços por CNPJ não retornados. Resposta completa:', res);
      }
    } catch (err) {
      this.enderecosDisponiveis = [];
      // DEBUG temporário — remover após diagnosticar
      console.error('[PedidoVenda] erro ao carregar endereços por CNPJ:', err);
    }
  }

  private _converterEnderecoDisponivel(item: EnderecoDisponivel): Endereco {
    return {
      logradouro:  item.ENDERECO ?? '',
      numero:      item.NUMEND ?? '',
      complemento: item.COMPLEMENTO ?? '',
      bairro:      item.BAIRRO ?? '',
      cep:         item.CEP ?? '',
      cidade:      item.NOMECID ?? '',
      uf:          item.UF ?? '',
    };
  }

  /** Rótulo de uma opção no seletor de endereços: "CODPARC - Nome — Rua, Cidade/UF [ | IE: xxx]". */
  rotuloEnderecoDisponivel(item: EnderecoDisponivel): string {
    const nomeComCodigo = item.codparc ? `${item.codparc} - ${item.nomeparc}` : item.nomeparc;
    const partes = [item.ENDERECO, item.NOMECID && item.UF ? `${item.NOMECID}/${item.UF}` : item.NOMECID]
      .filter(p => !!p && String(p).trim().length > 0);
    const ie = item.inscEstadual && item.inscEstadual.trim() ? ` | IE: ${item.inscEstadual.trim()}` : '';
    return partes.length > 0 ? `${nomeComCodigo} — ${partes.join(', ')}${ie}` : nomeComCodigo;
  }

  /** Rótulo compacto para o seletor de logradouro: apenas "Rua[ | IE: xxx]". */
  rotuloLogradouro(item: EnderecoDisponivel): string {
    const endereco = item.ENDERECO?.trim() || 'Endereço sem logradouro';
    const ie = item.inscEstadual && item.inscEstadual.trim() ? ` | IE: ${item.inscEstadual.trim()}` : '';
    return `${endereco}${ie}`;
  }

  /** Rótulo simples para exibir APÓS a seleção: apenas o endereço, sem IE. */
  rotuloLogradouroSimples(codparc: any, lista: EnderecoDisponivel[]): string {
    const item = lista.find(e => String(e.codparc) === String(codparc));
    if (!item) return '';
    return item.ENDERECO?.trim() || 'Endereço sem logradouro';
  }

  /**
   * Disparado ao escolher um endereço diferente para o Faturamento. Como
   * cada endereço da lista pertence a um CODPARC diferente (mesmo CNPJ),
   * trocar o endereço de Faturamento também troca o cliente "oficial" do
   * pedido para esse CODPARC, e reaplica a Aeronave com o mesmo PREFIXO,
   * agora vinculada ao novo CODPARC (se existir esse vínculo).
   */
  async onSelecionarEnderecoFaturamento(): Promise<void> {
    const item = this.enderecosDisponiveis.find(
      e => String(e.codparc) === String(this.codparcFaturamentoSelecionado)
    );
    if (!item) {
      return;
    }
    this.endFaturamento = this._converterEnderecoDisponivel(item);
    this.endEntregaIgualFaturamento = false;

    await this._atualizarCodparcCliente(item.codparc, item.nomeparc);

    // Atualiza COM, IE e Cidade/UF no cabeçalho do cliente conforme o endereço
    // selecionado — cada endereço da lista pode ter cidade/UF diferentes (ex.:
    // filiais/CODPARCs distintos do mesmo CNPJ), então o cabeçalho precisa
    // refletir o endereço escolhido, não ficar preso ao do cliente original.
    if (this.clienteSelecionado) {
      this.clienteSelecionado = {
        ...this.clienteSelecionado,
        adCom:        item.adCom        != null ? item.adCom        : this.clienteSelecionado.adCom,
        inscEstadual: item.inscEstadual != null ? item.inscEstadual : this.clienteSelecionado.inscEstadual,
        cidade:       item.NOMECID      != null ? item.NOMECID      : this.clienteSelecionado.cidade,
        uf:           item.UF           != null ? item.UF           : this.clienteSelecionado.uf,
      };
      this.clienteBusca = this._montarTextoCliente(this.clienteSelecionado);
      this._recalcularTitulosCliente(this.clienteSelecionado);
    }
  }

  /**
   * Atualiza o CODPARC "oficial" do cliente no pedido (quando o usuário
   * escolhe, no Faturamento, um endereço de outro CODPARC do mesmo CNPJ) e
   * recarrega a Aeronave para esse novo CODPARC, tentando manter
   * selecionada a aeronave com o mesmo PREFIXO de antes (mesmo avião,
   * vínculo diferente).
   */
  private async _atualizarCodparcCliente(novoCodparc: string | number, novoNome: string): Promise<void> {
    if (!this.clienteSelecionado || String(this.clienteSelecionado.codparc) === String(novoCodparc)) {
      return;
    }

    const prefixoAtual = this.aeronaveOpcoes.find(
      a => String(a.codaero) === String(this.aeronaveSelecionada)
    )?.prefixo;

    this.clienteSelecionado = { ...this.clienteSelecionado, codparc: novoCodparc, nomeparc: novoNome };
    this.clienteBusca = this._montarTextoCliente(this.clienteSelecionado);
    this._recalcularTitulosCliente(this.clienteSelecionado);

    await this._carregarAeronaves(novoCodparc);

    if (prefixoAtual) {
      const mesmaAeronave = this.aeronaveOpcoes.find(a => a.prefixo === prefixoAtual);
      this.aeronaveSelecionada = mesmaAeronave ? mesmaAeronave.codaero : '';
      this.aeronaveBusca = mesmaAeronave ? mesmaAeronave.prefixo : '';
    }
  }

  /** Disparado ao escolher um endereço diferente para a Entrega. */
  onSelecionarEnderecoEntrega(): void {
    const item = this.enderecosEntregaDisponiveis.find(
      e => String(e.codparc) === String(this.codparcEntregaSelecionado)
    );
    if (!item) return;
    this.endEntrega = this._converterEnderecoDisponivel(item);
    this.endEntregaIgualFaturamento = false;

    // Atualiza COM e IE da Pessoa de Entrega conforme o endereço selecionado
    // (cada endereço pode ter CNPJ/IE/COM diferentes — mesmo padrão do Faturamento)
    if (this.pessoaEntregaSelecionada) {
      this.pessoaEntregaSelecionada = {
        ...this.pessoaEntregaSelecionada,
        codparc:      item.codparc      ?? this.pessoaEntregaSelecionada.codparc,
        nomeparc:     item.nomeparc     ?? this.pessoaEntregaSelecionada.nomeparc,
        adCom:        item.adCom        != null ? item.adCom        : this.pessoaEntregaSelecionada.adCom,
        inscEstadual: item.inscEstadual != null ? item.inscEstadual : this.pessoaEntregaSelecionada.inscEstadual,
      };
      this.pessoaEntregaBusca = this._montarTextoCliente(this.pessoaEntregaSelecionada);
      this._recalcularTitulosPessoaEntrega(this.pessoaEntregaSelecionada);
    }
  }

  copiarFaturamentoParaEntrega(): void {
    this.endEntrega = { ...this.endFaturamento };
    this.endEntregaIgualFaturamento = true;
    this.codparcEntregaSelecionado = this.codparcFaturamentoSelecionado;
    this.enderecosEntregaDisponiveis = [...this.enderecosDisponiveis];
    if (this.clienteSelecionado) {
      this.pessoaEntregaSelecionada = { ...this.clienteSelecionado };
      this.pessoaEntregaBusca = this._montarTextoCliente(this.clienteSelecionado);
      this._recalcularTitulosPessoaEntrega(this.clienteSelecionado);
    }
  }

  // ── Pessoa de Entrega ──────────────────────────────────────
  private _recalcularTitulosPessoaEntrega(p: ClienteSugestao | null): void {
    if (!p) {
      this.titulosPessoaEntregaPosicionados = [];
      this.pessoaEntregaInputStartX = this.CLIENTE_INPUT_TEXT_START_PX;
      return;
    }
    if (!this._pessoaEntregaCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._pessoaEntregaCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._pessoaEntregaCanvasCtx;
    if (!ctx) { this.titulosPessoaEntregaPosicionados = []; return; }
    ctx.font = this.CLIENTE_INPUT_FONT;
    // Campos e ordem TÊM que bater exatamente com _montarTextoCliente() --
    // é essa função que monta o texto real exibido em pessoaEntregaBusca
    // ("Nome   |   Doc   |   COM   |   IE", sem prefixo de codparc).
    const campos = [
      { label: 'CNPJ/CPF',      valor: p.docparc,      display: this.fmtDocumento(p.docparc) },
      { label: 'COM',            valor: p.adCom,         display: p.adCom },
      { label: 'Insc. Estadual', valor: p.inscEstadual,  display: this.fmtIE(p.inscEstadual) },
    ];
    const nomeBase = p.nomeparc || '';
    const larguraNome = ctx.measureText(nomeBase).width;
    this.pessoaEntregaInputStartX = this._calcularStartXInput('Pessoa de Entrega', true, larguraNome);
    let offset = this.pessoaEntregaInputStartX + larguraNome;
    const titulos: TituloClientePosicionado[] = [];
    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }
    this.titulosPessoaEntregaPosicionados = titulos;
  }

  onPessoaEntregaInput(): void {
    if (this.pessoaEntregaSelecionada) {
      this.pessoaEntregaSelecionada = null;
      this.titulosPessoaEntregaPosicionados = [];
    }
    clearTimeout(this._pessoaEntregaTimer);
    const termo = this.pessoaEntregaBusca.trim();
    if (termo.length < 2) { this.pessoaEntregaSugestoes = []; this.mostrarDropdownPessoaEntrega = false; return; }
    this.mostrarDropdownPessoaEntrega = true;
    this._pessoaEntregaTimer = setTimeout(() => this._buscarPessoaEntrega(termo), 350);
  }

  onPessoaEntregaFocus(): void {
    if (this.pessoaEntregaSelecionada) {
      // Soft clear — salva anterior para restaurar no blur se nada for selecionado
      this._pessoaEntregaAnterior = this.pessoaEntregaSelecionada;
      this.pessoaEntregaSelecionada = null;
      this.pessoaEntregaBusca = '';
      this.titulosPessoaEntregaPosicionados = [];
      this.pessoaEntregaSugestoes = [];
      this.mostrarDropdownPessoaEntrega = false;
      return;
    }
    const termo = this.pessoaEntregaBusca.trim();
    if (termo.length >= 2) {
      this.mostrarDropdownPessoaEntrega = true;
      if (this.pessoaEntregaSugestoes.length === 0) this._buscarPessoaEntrega(termo);
    }
  }

  onPessoaEntregaBlur(): void {
    setTimeout(() => {
      this.mostrarDropdownPessoaEntrega = false;
      if (!this.pessoaEntregaSelecionada) {
        if (this.pessoaEntregaBusca.trim() !== '' && this.pessoaEntregaSugestoes.length > 0) {
          // Auto-seleciona o primeiro resultado ao sair do campo sem clicar
          this._pessoaEntregaAnterior = null;
          this.selecionarPessoaEntrega(this.pessoaEntregaSugestoes[0]);
        } else if (this.pessoaEntregaBusca.trim() === '' && this._pessoaEntregaAnterior) {
          // Campo apagado sem nova seleção — restaura anterior
          this.pessoaEntregaSelecionada = this._pessoaEntregaAnterior;
          this.pessoaEntregaBusca = this._montarTextoCliente(this._pessoaEntregaAnterior);
          this._recalcularTitulosPessoaEntrega(this._pessoaEntregaAnterior);
        }
      }
      this._pessoaEntregaAnterior = null;
    }, 200);
  }

  private async _buscarPessoaEntrega(termo: string): Promise<void> {
    this.pessoaEntregaCarregando = true;
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarClientePedidoVenda(termo));
      const body = res?.responseBody ?? res;
      const lista = body?.lista ?? [];
      this.pessoaEntregaSugestoes = lista.slice(0, 20);
    } catch { this.pessoaEntregaSugestoes = []; }
    finally { this.pessoaEntregaCarregando = false; }
  }

  async selecionarPessoaEntrega(p: ClienteSugestao): Promise<void> {
    this._pessoaEntregaAnterior = null;
    this.pessoaEntregaSelecionada = p;
    this.pessoaEntregaBusca = this._montarTextoCliente(p);
    this._recalcularTitulosPessoaEntrega(p);
    this.mostrarDropdownPessoaEntrega = false;
    this.pessoaEntregaSugestoes = [];
    this.codparcEntregaSelecionado = p.codparc;
    // Carregar todos os endereços da pessoa de entrega (pode ter mais de um)
    try {
      const resList: any = await firstValueFrom(
        this.sankhyaGateway.buscarEnderecosPorCnpjPedidoVenda((p.docparc || '').replace(/\D/g, ''))
      );
      const bodyList = resList?.responseBody ?? resList;
      const lista: EnderecoDisponivel[] = bodyList?.enderecos ?? [];
      this.enderecosEntregaDisponiveis = bodyList?.sucesso && lista.length > 0 ? lista : [];
    } catch { this.enderecosEntregaDisponiveis = []; }

    // Se não encontrou lista de endereços, carrega o endereço principal direto
    if (this.enderecosEntregaDisponiveis.length === 0) {
      try {
        const res: any = await firstValueFrom(
          this.sankhyaGateway.buscarEnderecoClientePedidoVenda(p.codparc)
        );
        const body = res?.responseBody ?? res;
        const fat = body?.faturamento ?? {};
        if (body?.sucesso) {
          this.endEntrega = {
            logradouro:  fat.ENDERECO ?? '',
            numero:      fat.NUMEND ?? '',
            complemento: fat.COMPLEMENTO ?? '',
            bairro:      fat.BAIRRO ?? '',
            cep:         fat.CEP ?? '',
            cidade:      fat.NOMECID ?? '',
            uf:          fat.UF ?? '',
          };
          this.endEntregaIgualFaturamento = false;
        }
      } catch { /* mantém endereço atual */ }
    } else {
      // Seleciona o endereço correspondente ao codparc escolhido na lista
      const itemEnd = this.enderecosEntregaDisponiveis.find(
        e => String(e.codparc) === String(p.codparc)
      ) ?? this.enderecosEntregaDisponiveis[0];
      if (itemEnd) {
        this.codparcEntregaSelecionado = itemEnd.codparc;
        this.endEntrega = this._converterEnderecoDisponivel(itemEnd);
        this.endEntregaIgualFaturamento = false;
      }
    }
  }

  removerPessoaEntrega(): void {
    this._pessoaEntregaAnterior = null;
    this.pessoaEntregaSelecionada = null;
    this.pessoaEntregaBusca = '';
    this.pessoaEntregaSugestoes = [];
    this.titulosPessoaEntregaPosicionados = [];
    this.codparcEntregaSelecionado = '';
  }

  onTranspInput(): void {
    if (this.transpSelecionada) {
      this.transpSelecionada = null;
      this.codParcTransp = null;
      this.titulosTranspPosicionados = [];
    }
    this._transpAnterior = null;
    clearTimeout(this._transpTimer);
    const termo = this.transpBusca.trim();
    if (termo.length < 2) { this.transpSugestoes = []; this.mostrarDropdownTransp = false; return; }
    this.mostrarDropdownTransp = true;
    this._transpTimer = setTimeout(() => this._buscarTransp(termo), 350);
  }

  onTranspFocus(): void {
    if (this.transpSelecionada) {
      this._transpAnterior = this.transpSelecionada;
      this.transpSelecionada = null;
      this.codParcTransp = null;
      this.transpBusca = '';
      this.titulosTranspPosicionados = [];
      this.transpSugestoes = [];
      this.mostrarDropdownTransp = false;
      return;
    }
    const termo = this.transpBusca.trim();
    if (termo.length >= 2) {
      this.mostrarDropdownTransp = true;
      if (this.transpSugestoes.length === 0) this._buscarTransp(termo);
    }
  }

  onTranspBlur(): void {
    setTimeout(() => {
      this.mostrarDropdownTransp = false;
      if (!this.transpSelecionada && this.transpBusca.trim() === '' && this._transpAnterior) {
        this.selecionarTransp(this._transpAnterior);
      }
      this._transpAnterior = null;
    }, 200);
  }

  private async _buscarTransp(termo: string): Promise<void> {
    this.transpCarregando = true;
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarTransportadoraPedidoVenda(termo));
      const body = res?.responseBody ?? res;
      const lista = body?.lista ?? [];
      this.transpSugestoes = lista.slice(0, 20);
    } catch { this.transpSugestoes = []; }
    finally { this.transpCarregando = false; }
  }

  selecionarTransp(t: ClienteSugestao): void {
    this.transpSelecionada = t;
    this.codParcTransp = Number(t.codparc);
    const partes = [
      t.docparc      ? this.fmtDocumento(t.docparc)     : null,
      t.inscEstadual ? this.fmtIE(t.inscEstadual)        : null,
    ].filter(p => !!p && String(p).trim().length > 0) as string[];
    const nomeBase = t.nomeparc || '';
    this.transpBusca = partes.length > 0 ? `${nomeBase}   |   ${partes.join('   |   ')}` : nomeBase;
    this.transpSugestoes = [];
    this.mostrarDropdownTransp = false;
    this._recalcularTitulosTransp(t);
  }

  private _recalcularTitulosTransp(t: ClienteSugestao | null): void {
    if (!t) {
      this.titulosTranspPosicionados = [];
      this.transpInputStartX = this.CLIENTE_INPUT_TEXT_START_PX;
      return;
    }
    if (!this._transpCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._transpCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._transpCanvasCtx;
    if (!ctx) { this.titulosTranspPosicionados = []; return; }
    ctx.font = this.CLIENTE_INPUT_FONT;
    const campos = [
      { label: 'CNPJ/CPF',      valor: t.docparc,      display: this.fmtDocumento(t.docparc) },
      { label: 'Insc. Estadual', valor: t.inscEstadual,  display: this.fmtIE(t.inscEstadual) },
    ];
    const nomeBase = t.nomeparc || '';
    const larguraNome = ctx.measureText(nomeBase).width;
    this.transpInputStartX = this._calcularStartXInput('Transportadora', false, larguraNome);
    let offset = this.transpInputStartX + larguraNome;
    const titulos: TituloClientePosicionado[] = [];
    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }
    this.titulosTranspPosicionados = titulos;
  }

  private async _buscarTranspPorCodigo(codparc: number): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarClientePedidoVenda(String(codparc)));
      const body = res?.responseBody ?? res;
      const lista: ClienteSugestao[] = body?.lista ?? [];
      const encontrado = lista.find((c: any) => String(c.codparc) === String(codparc));
      if (encontrado) this.selecionarTransp(encontrado);
    } catch {}
  }

  removerTransp(): void {
    this.transpSelecionada = null;
    this.codParcTransp = null;
    this.transpBusca = '';
    this.transpSugestoes = [];
    this.mostrarDropdownTransp = false;
    this.titulosTranspPosicionados = [];
  }

  onEndFaturamentoChange(): void {
    this.endEntregaIgualFaturamento = false;
  }

  private _enderecoVazio(): Endereco {
    return { logradouro: '', numero: '', complemento: '', bairro: '', cep: '', cidade: '', uf: '' };
  }

  private _enderecoIgual(a: Endereco, b: Endereco): boolean {
    return a.logradouro === b.logradouro && a.numero === b.numero &&
           a.bairro === b.bairro && a.cep === b.cep && a.cidade === b.cidade && a.uf === b.uf;
  }

  private _novoItem(): ItemPedido {
    return { id: this._proximoId++, codprod: '', descricao: '', unidade: 'UN', quantidade: 1, precoUsd: 0, precoUnitario: 0, desconto: 0, vlrDesc: 0, vlrAcrescDesc: 0, total: 0, totalUsd: 0, controlaCore: false, vlrCore: 0, coreUnitBrl: 0, totalCoreUsd: 0, totalCoreBrl: 0, estoque: 0 };
  }

  /** Reseta a linha do item para o estado "em branco" (mantém o id/posição
   *  na grade) — usado quando o usuário apaga o PN de um item já carregado
   *  e dá Enter, para não deixar a linha com dados "presos" de um produto
   *  que não está mais ali. */
  private _limparLinhaItem(item: ItemPedido): void {
    const id = item.id;
    // Object.assign(item, novo) só SOBRESCREVE as chaves do objeto novo — não
    // apaga campos que a linha antiga tinha e o objeto "novo" não define
    // (ex.: aliqIpi, vlrIpi, vlrBaseIpi, codlocalpadrao, descrLocal,
    // codprodInterno, adCondicao...), deixando resíduo do produto anterior
    // na linha mesmo com o PN em branco. Por isso apaga TODAS as chaves
    // antes de reatribuir os valores em branco.
    for (const key of Object.keys(item)) {
      delete (item as any)[key];
    }
    Object.assign(item, this._novoItem());
    item.id = id;
  }

  /** true quando a linha ainda não tem nenhum dado de produto/preço digitado
   *  — usado para decidir, no Enter com PN vazio, entre limpar a linha
   *  (já tinha dados) ou abrir a busca em branco (linha realmente nova). */
  private _linhaItemVazia(item: ItemPedido): boolean {
    return !item.codprodInterno && !item.descricao && !item.codprodOriginal
      && !(item.precoUnitario > 0) && !(item.total !== 0) && !(item.vlrDesc);
  }

  adicionarItem(): void {
    this.itens.push(this._novoItem());
    setTimeout(() => this._focarUltimoPN(), 50);
  }

  // ── Importação de Excel ────────────────────────────────────

  /** Abre o seletor de arquivo ao clicar no botão. */
  abrirSeletorExcel(): void {
    const input = document.getElementById('excel-import-input') as HTMLInputElement;
    if (input) { input.value = ''; input.click(); }
  }

  // ── Exportação de Excel ────────────────────────────────────

  /** Exporta os itens da venda atual pra uma planilha .xlsx — usa os mesmos
   *  nomes de coluna ("PN", "Quantidade") reconhecidos automaticamente pelo
   *  Importar Itens (ver _detectarColunas), então o arquivo exportado pode
   *  ser reimportado depois sem precisar de mapeamento manual. */
  exportarItensExcel(): void {
    const itensValidos = this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
    if (itensValidos.length === 0) {
      this.abrirAlerta('Não há itens na venda para exportar.', 'aviso');
      return;
    }

    const linhas = itensValidos.map(i => ({
      'PN':            i.codprod,
      'Descrição':     i.descricao,
      'UN':            i.unidade,
      'Quantidade':    i.quantidade,
      'Vl. Unit. U$':  i.precoUsd,
      'Vl. Unit. R$':  i.precoUnitario,
      'Desc. %':       i.desconto,
      'Total R$':      i.total,
    }));

    const ws = XLSX.utils.json_to_sheet(linhas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Itens');
    const sufixo = this.nunotaAtual ? `_${this.nunotaAtual}` : '';
    XLSX.writeFile(wb, `Itens_Pedido${sufixo}.xlsx`);
  }

  /** Detecta automaticamente as colunas de PN e Quantidade pela linha de cabeçalho.
   *  Retorna { colPn, colQty } com -1 quando não encontrado. */
  private _detectarColunas(headerRow: any[]): { colPn: number; colQty: number } {
    const norm = (s: any) => String(s ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const aliasesPn  = new Set(['PN','PART','PARTNUMBER','PARTNUMBERS','PARTNO','PN',
      'CODIGO','CÓDIGO','COD','REF','REFERENCIA','REFERÊNCIA','REFFORN','ITEM',
      'NUMEROPECA','NUMERODEPEÇA','CODPROD','PRODUTO']);
    const aliasesQty = new Set(['QUANTIDADE','QUANT','QTD','QTY','QTDE','QNT',
      'QUANTITY','QT','QDE','QTDE.','QUANT.']);
    let colPn = -1, colQty = -1;
    for (let i = 0; i < headerRow.length; i++) {
      const n = norm(headerRow[i]);
      if (colPn  === -1 && aliasesPn.has(n))  colPn  = i;
      if (colQty === -1 && aliasesQty.has(n)) colQty = i;
    }
    return { colPn, colQty };
  }

  /** Transforma linhas brutas do Excel em ExcelImportRow[] usando os índices de coluna fornecidos. */
  private _parsearLinhasExcel(rows: any[][], colPn: number, colQty: number, startRow: number): ExcelImportRow[] {
    const linhas: ExcelImportRow[] = [];
    for (let i = startRow; i < rows.length; i++) {
      const row = rows[i];
      const pnRaw = String(row[colPn] ?? '').trim();
      if (!pnRaw) continue;
      const qty = Number(row[colQty]);
      linhas.push({ pn: pnRaw, quantidade: isNaN(qty) || qty <= 0 ? 1 : qty, status: 'pendente' });
    }
    return linhas;
  }

  /** Lê o arquivo Excel selecionado, tenta auto-detectar colunas e abre o modal de preview.
   *  Se as colunas não forem reconhecidas, abre a UI de mapeamento manual. */
  async onExcelSelecionado(event: Event): Promise<void> {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    this.excelImportNomeArquivo = file.name;
    this.excelImportLinhas     = [];
    this.excelImportAberto     = true;
    this.excelImportValidando  = true;
    this.excelMapeamentoAberto = false;

    try {
      const data = await file.arrayBuffer();
      const wb   = XLSX.read(data, { type: 'array' });
      const ws   = wb.Sheets[wb.SheetNames[0]];
      const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

      if (rows.length === 0) return;

      // 1. Tentar auto-detecção pelo cabeçalho (linha 0)
      const { colPn, colQty } = this._detectarColunas(rows[0]);

      if (colPn !== -1 && colQty !== -1) {
        // Colunas reconhecidas → parsear e validar diretamente
        this.excelImportLinhas = this._parsearLinhasExcel(rows, colPn, colQty, 1);
        await this._validarPNsExcel();
      } else {
        // 2. Auto-detecção falhou → pedir mapeamento manual
        this.excelRowsRaw     = rows;
        this.excelColunas     = rows[0].map((c: any, i: number) => {
          const label = String(c ?? '').trim();
          return label || `Coluna ${i + 1}`;
        });
        this.excelPreviewLinhas = rows.slice(1, 6); // primeiras 5 linhas de dados como prévia
        this.excelColunaPn  = null;
        this.excelColunaQty = null;
        this.excelMapeamentoAberto = true;
      }
    } catch (e) {
      console.error('Erro ao ler Excel:', e);
      this.excelImportLinhas = [];
    } finally {
      this.excelImportValidando = false;
    }
  }

  /** Chamado quando o usuário confirma o mapeamento manual de colunas. */
  async confirmarMapeamento(): Promise<void> {
    if (this.excelColunaPn === null || this.excelColunaQty === null) return;
    this.excelMapeamentoAberto = false;
    this.excelImportValidando  = true;
    try {
      this.excelImportLinhas = this._parsearLinhasExcel(
        this.excelRowsRaw, this.excelColunaPn, this.excelColunaQty, 1
      );
      await this._validarPNsExcel();
    } catch (e) {
      this.excelImportLinhas = [];
    } finally {
      this.excelImportValidando = false;
    }
  }

  /** Consulta cada PN no sistema e marca como encontrado ou não.
   *  Somente marca como ENCONTRADO se houver match exato de REFFORN
   *  (normalizado: sem pontuação, maiúsculo).
   *  Resultados aproximados são salvos em proximosData para o usuário
   *  poder escolher um substituto via botão "Ver similares". */
  /** Quantas consultas de PN rodam em paralelo durante a validação (ver
   *  _validarPNsExcel). Limitado pra não disparar dezenas de requisições
   *  simultâneas no gateway/Sankhya de uma vez em importações grandes. */
  private static readonly VALIDACAO_PN_CONCORRENCIA = 6;

  private async _validarPNsExcel(): Promise<void> {
    const normalizar = (s: string) => (s ?? '').toUpperCase().replace(/[.\-\/\s]/g, '');

    // CODEMP da empresa selecionada — sem isso, a busca cai no caminho antigo
    // (sem filtro de empresa) e o CODLOCAL do item importado (Sistema Legado,
    // O.S. ou Excel) pode vir de uma empresa diferente da que está gravando a
    // venda, quebrando a Separação (mesma causa raiz corrigida no F3/F7).
    const codEmpNum = Number(this.empresaState.selecionada) || undefined;

    const validarLinha = async (linha: ExcelImportRow): Promise<void> => {
      try {
        let res: any = await firstValueFrom(
          this.sankhyaGateway.buscarProdutosEdicao({ REFFORN: linha.pn, CODEMP: codEmpNum })
        );
        let body = res?.responseBody ?? res;
        let lista: any[] = body?.lista ?? [];

        // Fallback: se não achou e tem caracteres de formatação (espaço, traço, ponto)
        const pnLimpo = linha.pn.replace(/[.\-\/\s]/g, '');
        if (lista.length === 0 && linha.pn !== pnLimpo && pnLimpo.length >= 2) {
          const resFallback: any = await firstValueFrom(
            this.sankhyaGateway.buscarProdutosEdicao({ REFFORN: pnLimpo, CODEMP: codEmpNum })
          );
          const bodyFallback = resFallback?.responseBody ?? resFallback;
          const listaFallback = bodyFallback?.lista ?? [];
          if (listaFallback.length > 0) {
            lista = listaFallback;
            linha.pn = pnLimpo;
          }
        }

        if (lista.length > 0) {
          const pnNorm = normalizar(linha.pn);
          // Procura match exato de REFFORN
          const exato = lista.find((p: any) => normalizar(p.refforn ?? '') === pnNorm);
          if (exato) {
            linha.status         = 'encontrado';
            linha.descricao      = exato.descricao ?? exato.descrprod ?? exato.DESCRPROD ?? '';
            linha.codprodInterno = Number(exato.codprod ?? exato.CODPROD ?? 0) || undefined;
            linha.codlocalpadrao = Number(exato.codlocalpadrao ?? exato.CODLOCALPADRAO ?? 0) || 0;
            linha.prodData       = exato;
          } else {
            // Sem match exato — marca como não encontrado, salva aproximados
            linha.status       = 'nao_encontrado';
            linha.proximosData = lista.slice(0, 8); // até 8 sugestões
          }
        } else {
          linha.status = 'nao_encontrado';
        }
      } catch {
        linha.status = 'nao_encontrado';
      }
    };

    // Antes: um PN por vez (await sequencial dentro do for) — em vendas/O.S
    // com muitos itens, isso significava dezenas de idas-e-voltas ao gateway
    // em série, deixando o carregamento bem lento. Agora processa em
    // paralelo com um pool de workers de tamanho fixo: cada worker pega o
    // próximo item da fila assim que termina o anterior, mantendo no máximo
    // VALIDACAO_PN_CONCORRENCIA requisições simultâneas.
    const fila = [...this.excelImportLinhas];
    const numWorkers = Math.min(
      PedidoVendaComponent.VALIDACAO_PN_CONCORRENCIA,
      fila.length
    );
    const workers = Array.from({ length: numWorkers }, async () => {
      let linha: ExcelImportRow | undefined;
      while ((linha = fila.shift())) {
        await validarLinha(linha);
      }
    });
    await Promise.all(workers);
  }

  /** Abre/fecha o painel de similares para uma linha. */
  toggleAproximados(linha: ExcelImportRow): void {
    this.excelAproximadosLinha = this.excelAproximadosLinha === linha ? null : linha;
  }

  /** Usuário escolhe um produto aproximado — converte a linha para verde
   *  e atualiza o PN para o REFFORN real do produto selecionado. */
  selecionarAproximado(linha: ExcelImportRow, prod: any): void {
    linha.pn             = prod.refforn ?? prod.REFFORN ?? linha.pn;
    linha.status         = 'encontrado';
    linha.descricao      = prod.descricao ?? prod.descrprod ?? prod.DESCRPROD ?? '';
    linha.codprodInterno = Number(prod.codprod ?? prod.CODPROD ?? 0) || undefined;
    linha.codlocalpadrao = Number(prod.codlocalpadrao ?? prod.CODLOCALPADRAO ?? 0) || 0;
    linha.prodData       = prod;
    linha.proximosData   = undefined;
    this.excelAproximadosLinha = null;
  }

  get excelImportEncontrados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'encontrado').length;
  }

  get excelImportNaoEncontrados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'nao_encontrado').length;
  }

  /** Só os encontrados que estão marcados para entrar na gravação (checkbox
   *  da revisão da O.S — linhas sem "selecionado" definido contam como marcadas). */
  get excelImportEncontradosSelecionados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'encontrado' && l.selecionado !== false).length;
  }

  /** Marca/desmarca todas as linhas encontradas de uma vez (checkbox "Selecionar todos"). */
  alternarTodosSelecionadosExcel(marcado: boolean): void {
    for (const linha of this.excelImportLinhas) {
      if (linha.status === 'encontrado') linha.selecionado = marcado;
    }
  }

  /** Confirma a importação: se houver itens não encontrados, exibe aviso
   *  primeiro e aguarda o usuário confirmar com "Sim". Caso contrário (ou
   *  após confirmação), importa só os encontrados (e marcados) e aguarda o
   *  carregamento completo (preço, estoque, core, IPI, cotação, totais) antes
   *  de fechar. Quando vier de uma O.S e todos os PNs tiverem sido
   *  encontrados, grava o pedido automaticamente em seguida — o vendedor não
   *  precisa abrir a tela de venda para salvar manualmente. */
  async confirmarImportacaoExcel(): Promise<void> {
    // 1ª chamada: há não-encontrados → apenas exibe o aviso e aguarda o "Sim"
    if (this.excelImportNaoEncontrados > 0 && !this.excelAvisoNaoEncontrado) {
      this.excelAvisoNaoEncontrado = true;
      return;
    }
    // 2ª chamada (após "Sim") ou sem não-encontrados: prossegue com o import
    const todosEncontrados = this.excelImportNaoEncontrados === 0;
    let itensImportadosNestaChamada = 0;
    this.excelAvisoNaoEncontrado = false;
    this.excelImportando = true;
    try {
      const naoEncontrados = this.excelImportLinhas.filter(l => l.status === 'nao_encontrado');
      // Registra os PNs não encontrados na Observação Venda
      if (naoEncontrados.length > 0) {
        const linhas = naoEncontrados
          .map(l => `${l.pn} - Qtd: ${l.quantidade}`)
          .join('\n');
        const bloco = `PNs não encontrados:\n${linhas}`;
        this.adObs = this.adObs
          ? `${this.adObs}\n${bloco}`
          : bloco;
      }
      const encontrados = this.excelImportLinhas.filter(l => l.status === 'encontrado' && l.selecionado !== false);
      itensImportadosNestaChamada = encontrados.length;
      // Remove todas as linhas sem produto (em branco) antes de adicionar os itens importados,
      // independente de onde estejam na lista.
      this.itens = this.itens.filter(i => !!(i.codprod || i.descricao || i.codprodInterno));
      // Cria TODAS as linhas de uma vez (aparecem na tela imediatamente,
      // ainda vazias) — só o preenchimento dos dados (produto completo +
      // preço, 2 chamadas por item) roda com concorrência limitada, senão
      // uma venda com muitos itens dispara dezenas de requisições ao addon
      // ao mesmo tempo e trava/deixa tudo lento.
      const pendentes: { item: ItemPedido; linha: ExcelImportRow }[] = [];
      // Soma os acréscimos (vlrDescAcresc negativo, na nossa convenção) dos itens
      // importados do Sistema Legado/Aerosys em "Outros" (VLROUTROS) — mesmo
      // cálculo que o backend fazia antes (soma do VLRACRESCDESC dos itens),
      // agora refletido no campo editável da tela em vez de calculado às cegas
      // no addon. Excel/O.S. não têm vlrDescAcresc, então não somam nada aqui.
      let outrosAcumulado = 0;
      for (const linha of encontrados) {
        const novo = this._novoItem();
        novo.codprod    = linha.pn;
        novo.quantidade = linha.quantidade;
        // Desconto/acréscimo vindo da Venda do Sistema Legado (Aerosys), já com
        // o sinal invertido pra nossa convenção — ver itensImportadosDeOS.
        // precoUnitario ainda é 0 aqui (só chega depois de _preencherItemComProduto),
        // então só dá pra gravar o valor R$ agora; o Desconto % correspondente é
        // calculado depois que o preço carrega (ver loop logo abaixo).
        if (linha.vlrDescAcresc) {
          novo.vlrDesc       = linha.vlrDescAcresc;
          novo.vlrAcrescDesc = 0; // consolida acréscimo em vlrDesc negativo (mesma regra do onDescontoVlrChange)
          if (linha.vlrDescAcresc < 0) {
            outrosAcumulado += Math.abs(linha.vlrDescAcresc);
          }
        }
        this.itens.push(novo);
        if (linha.prodData) {
          pendentes.push({ item: novo, linha });
        }
      }
      if (outrosAcumulado > 0) {
        this.vlrOutros = (this.vlrOutros || 0) + outrosAcumulado;
      }
      const fila = [...pendentes];
      const numWorkers = Math.min(PedidoVendaComponent.VALIDACAO_PN_CONCORRENCIA, fila.length);
      const workers = Array.from({ length: numWorkers }, async () => {
        let proximo: { item: ItemPedido; linha: ExcelImportRow } | undefined;
        while ((proximo = fila.shift())) {
          await this._preencherItemComProduto(proximo.item, proximo.linha.prodData, false);
          // Preço já carregado — agora dá pra derivar o Desconto % a partir do
          // vlrDesc importado (mesma fórmula do onDescontoVlrChange) e recalcular
          // o total do item com o valor certo.
          if (proximo.linha.vlrDescAcresc) {
            const base = proximo.item.quantidade * proximo.item.precoUnitario;
            // Trava de segurança: um desconto importado do Sistema Legado maior
            // que o próprio valor do item (base) deixaria o total do item — e a
            // base de cálculo do ICMS-ST — negativos, o que o Sankhya nativo
            // rejeita na hora de gravar ("Valor da substituição não pode ficar
            // negativo"), sem indicar qual item causou (só o CODPROD interno,
            // não o PN). Limitamos o desconto a 100% do valor do item (zera o
            // total, nunca negativa) — evita o erro de gravação silenciosamente
            // em vez de travar o vendedor sem explicação.
            if (base > 0 && proximo.item.vlrDesc > base) {
              proximo.item.vlrDesc = base;
            }
            if (base > 0) {
              proximo.item.desconto = parseFloat((proximo.item.vlrDesc / base * 100).toFixed(2));
            }
            this.calcularTotal(proximo.item, true);
            // Texto exibido no campo "Desc. Vlr" (mesma formatação do onDescontoVlrBlur).
            proximo.item.vlrDescStr = proximo.item.vlrDesc !== 0
              ? (proximo.item.vlrDesc < 0 ? '-' + this.formatarDecimal(Math.abs(proximo.item.vlrDesc)) : this.formatarDecimal(proximo.item.vlrDesc))
              : '';
          }
        }
      });
      await Promise.all(workers);
      // Mantém o espelho do Desconto Geral (cabeçalho) em dia com os descontos/
      // acréscimos por item que acabaram de ser importados (mesma chamada feita
      // manualmente em onDescontoVlrChange/onDescontoVlrBlur).
      this._atualizarEspelhoDescGeral();
    } finally {
      this.excelImportando = false;
      this.excelImportLinhas = [];
    }

    const vaiGravarDireto = this.excelImportOrigemOS && todosEncontrados && itensImportadosNestaChamada > 0;
    if (!vaiGravarDireto) {
      // Fluxo normal (Excel manual, ou O.S com item não encontrado) —
      // fecha o modal e deixa o vendedor revisar/completar na tela.
      this.excelImportAberto = false;
      return;
    }

    // Veio de uma O.S, todos os PNs foram encontrados e havia pelo menos um
    // item selecionado — grava direto, sem exigir clique em "Salvar". O
    // overlay continua cobrindo a tela durante toda a gravação, para o
    // vendedor nunca ver o formulário de edição "por trás".
    this.excelImportGravando = true;
    const gravouComSucesso = await this.salvar();

    if (gravouComSucesso && !this.confirmacaoEstoqueAberta) {
      // Sucesso: mantém o overlay até a navegação (daqui a pouco) desmontar
      // a tela inteira — nunca chega a expor o formulário já gravado.
      return;
    }

    // Faltou estoque (precisa de confirmação manual) ou deu erro ao gravar —
    // nesses casos o vendedor precisa ver o formulário para agir, então
    // libera o overlay.
    this.excelImportGravando = false;
    this.excelImportAberto   = false;
  }

  /** Cancela o aviso de itens não encontrados — volta para a lista sem importar. */
  cancelarAvisoExcel(): void {
    this.excelAvisoNaoEncontrado = false;
  }

  fecharImportacaoExcel(): void {
    // Enquanto está gravando automaticamente (O.S), não deixa fechar — evita
    // expor o formulário de edição no meio da gravação.
    if (this.excelImportGravando) return;
    this.excelImportAberto     = false;
    this.excelImportLinhas     = [];
    this.excelAvisoNaoEncontrado = false;
    this.excelMapeamentoAberto = false;
    this.excelRowsRaw          = [];
    this.excelColunas          = [];
    this.excelPreviewLinhas    = [];
    this.excelColunaPn         = null;
    this.excelColunaQty        = null;
  }

  /** Muda para a aba Itens e foca o campo PN da primeira linha. */
  irParaItens(): void {
    this.abaPrincipalAtiva = 'itens';
    setTimeout(() => this._focarUltimoPN(), 60);
  }

  private _focarUltimoPN(): void {
    const inputs = document.querySelectorAll<HTMLInputElement>('.itens-table tbody .cell-pn-input');
    const ultimo = inputs[inputs.length - 1];
    ultimo?.focus();
    ultimo?.select();
  }

  async buscarProdutoPorPN(item: ItemPedido, event: Event): Promise<void> {
    event.preventDefault();
    const pn = (item.codprod ?? '').trim();
    if (!pn) return;

    // Trava de reentrância: setar item.buscando=true desabilita o input do PN
    // ([disabled]="!!item.buscando"), e desabilitar um input COM FOCO dispara
    // um blur automático do navegador — o que chama onPnBlur(), que (produto
    // ainda não carregado) tentava disparar uma SEGUNDA busca concorrente pro
    // mesmo item (Enter -> busca #1 -> auto-blur -> busca #2). As duas corriam
    // em paralelo: uma geralmente preenchia a linha certinho e a outra falhava
    // (ou colidia) mostrando "Erro ao buscar produto." mesmo com o item já OK.
    if (item.buscando) return;

    item.buscando = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarProdutosEdicao({ REFFORN: pn })
      );
      const body = res?.responseBody ?? res;
      const lista: any[] = body?.lista ?? [];

      if (lista.length === 0) {
        // PN não encontrado → abre modal com o termo pré-preenchido e busca disparada
        this._buscaPecasItem              = item;
        this.buscaPecasTermo              = pn;
        this.buscaPecasResultados         = [];
        this.buscaPecasSemResultado       = false;
        this.buscaPecasProdutoSelecionado = null;
        this.buscaPecasProdutoExpandido   = null;
        this.buscaPecasLocais             = [];
        this.buscaPecasLocaisCarregando   = false;
        this.buscaPecasImagemUrl          = null;
        this.buscaPecasImagensExtras      = [];
        this.buscaPecasImagemIndexAtivo    = 0;
        this.buscaPecasAberta             = true;
        setTimeout(() => {
          document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
          this._executarBuscaPecas(pn);
        }, 60);
        return;
      }

      if (lista.length > 1) {
        // Mais de um produto — verifica se algum é match exato do PN digitado.
        const normalizar = (s: string) =>
          (s ?? '').toUpperCase().replace(/[.\-\/\s]/g, '');
        const pnNorm = normalizar(pn);
        const exatos = lista.filter((p: any) => normalizar(p.refforn ?? '') === pnNorm);
        if (exatos.length === 1) {
          // Apenas um exato → seleciona direto sem abrir modal.
          this._preencherItemComProduto(item, exatos[0]);
          return;
        }
        // Zero exatos (só similares) OU múltiplos com o mesmo PN → abre modal.
        // Exatos primeiro na lista para facilitar a escolha.
        lista.sort((a: any, b: any) => {
          const aExato = normalizar(a.refforn) === pnNorm ? 0 : 1;
          const bExato = normalizar(b.refforn) === pnNorm ? 0 : 1;
          return aExato - bExato;
        });
        this._abrirBuscaPecasComResultados(item, pn, lista);
        return;
      }

      this._preencherItemComProduto(item, lista[0]);
    } catch (err) {
      console.error('[PedidoVenda] erro ao buscar produto por PN:', err);
      this.abrirAlerta('Erro ao buscar produto.', 'erro');
    } finally {
      item.buscando = false;
    }
  }

  selecionarProdutoModal(prod: any): void {
    if (this._produtoModalItem) {
      this._preencherItemComProduto(this._produtoModalItem, prod);
      this._produtoModalItem = null;
    }
    this.produtoModalAberta = false;
    this.produtoModalLista = [];
  }

  fecharProdutoModal(): void {
    this.produtoModalAberta = false;
    this.produtoModalLista = [];
    this._produtoModalItem = null;
  }

  // ── Modal de busca avançada de peças ──────────────────────────

  abrirBuscaPecas(item: ItemPedido, event: Event): void {
    event.preventDefault();
    const pn    = item.codprod?.trim() ?? '';
    const isF3  = (event as KeyboardEvent).key === 'F3';

    // F3 → sempre abre busca de peças com o PN do campo pré-preenchido e busca disparada
    if (isF3) {
      this._buscaPecasItem              = item;
      this._buscaPecasPnInputOrigem     = (event.target as HTMLInputElement) ?? null;
      this.buscaPecasTermo              = pn;
      this.buscaPecasResultados         = [];
      this.buscaPecasSemResultado       = false;
      this.buscaPecasProdutoSelecionado = null;
      this.buscaPecasProdutoExpandido   = null;
      this.buscaPecasLocais             = [];
      this.buscaPecasLocaisCarregando   = false;
      this.buscaPecasImagemUrl          = null;
      this.buscaPecasImagensExtras      = [];
      this.buscaPecasImagemIndexAtivo    = 0;
      this.buscaPecasAberta             = true;

      // Executa apenas a busca com o que foi digitado se foi aberto via F3 mas não na mesma célula em branco
      setTimeout(() => {
        document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
        if (pn) this._executarBuscaPecas(pn);
      }, 60);
      return;
    }

    // Enter com produto já carregado → avança para o próximo campo
    // SOMENTE se o PN digitado é o mesmo que o produto já carregado.
    // Se o usuário digitou um PN diferente, trata como nova busca (sobrescreve o item).
    if (pn && item.codprodInterno) {
      const pnOriginal = (item.codprodOriginal ?? '').trim().toUpperCase();
      const pnDigitado = pn.toUpperCase();
      if (pnDigitado === pnOriginal) {
        this.focarCampoItem(event, item, 'precoUsd');
        return;
      }
      // PN diferente → limpa o item e faz nova busca
      item.codprodInterno = undefined;
      item.descricao      = '';
      item.unidade        = '';
      item.estoque        = 0;
      item.adCondicao     = undefined;
    }

    // Enter com PN preenchido mas sem produto carregado → faz busca direta
    if (pn) {
      this.buscarProdutoPorPN(item, event);
      return;
    }

    // Enter vazio: se a linha já tinha produto/dados carregados (usuário apagou
    // o PN para "esvaziar" o item), limpa a linha inteira em vez de abrir a
    // busca — evita ficar com resquício de qtd/preço/desconto/core de um
    // produto que não está mais ali. Só abre a busca em branco quando a
    // linha já era realmente nova/vazia.
    if (!this._linhaItemVazia(item)) {
      this._limparLinhaItem(item);
      return;
    }

    // Enter vazio → abre modal de busca em branco
    this._buscaPecasItem              = item;
    this._buscaPecasPnInputOrigem     = (event.target as HTMLInputElement) ?? null;
    this.buscaPecasTermo              = '';
    this.buscaPecasResultados         = [];
    this.buscaPecasSemResultado       = false;
    this.buscaPecasAberta             = true;

    // Configura debounce para digitação no modal (movido para ngOnInit)

    setTimeout(() => {
      document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
    }, 60);
  }

  onBuscaPecasInput(): void {
    this._buscaPecasSubject.next(this.buscaPecasTermo);
  }

  private async _executarBuscaPecas(termo: string): Promise<void> {
    const t = termo.trim();
    const token = ++this._buscaPecasToken;
    this._buscaPecasTermoExecutado = t;
    this._buscaPecasUltimaExecucao = Date.now();
    if (t.length < 2) {
      this.buscaPecasCarregando         = false;
      this.buscaPecasResultados         = [];
      this.buscaPecasSemResultado       = false;
      this.buscaPecasProdutoSelecionado = null;
      this.buscaPecasProdutoExpandido   = null;
      this.buscaPecasLocais             = [];
      this.buscaPecasImagemUrl          = null;
      this.buscaPecasImagensExtras      = [];
      this.buscaPecasImagemIndexAtivo    = 0;
      return;
    }
    this.buscaPecasCarregando         = true;
    this.buscaPecasSemResultado       = false;
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasProdutoExpandido   = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.filtrosBusca                 = {}; // nova busca zera filtros de coluna anteriores
    try {
      // 1ª tentativa: busca por REFFORN (PN)
      const codEmpNum = Number(this.empresaState.selecionada) || undefined;
      let resPN: any = await firstValueFrom(this.sankhyaGateway.buscarPecasModal({ REFFORN: t, CODEMP: codEmpNum }));
      if (token !== this._buscaPecasToken) return; // digitou mais: descarta esta resposta
      let bodyPN = resPN?.responseBody ?? resPN;
      let listaPN: any[] = bodyPN?.lista ?? [];

      // Se não encontrou por PN e o termo possui caracteres de formatação (espaço, traço, ponto),
      // tenta buscar pela versão "limpa" (somente letras e números).
      const tLimpo = t.replace(/[.\-\/\s]/g, '');
      if (listaPN.length === 0 && t !== tLimpo && tLimpo.length >= 2) {
        const resPNFallback: any = await firstValueFrom(this.sankhyaGateway.buscarPecasModal({ REFFORN: tLimpo, CODEMP: codEmpNum }));
        if (token !== this._buscaPecasToken) return;
        const bodyPNFallback = resPNFallback?.responseBody ?? resPNFallback;
        const listaPNFallback: any[] = bodyPNFallback?.lista ?? [];
        if (listaPNFallback.length > 0) {
          listaPN = listaPNFallback;
        }
      }

      if (listaPN.length > 0) {
        this.buscaPecasResultados   = listaPN;
        this.buscaPecasSemResultado = false;
        // Primeiro resultado já fica selecionado (Enter confirma; setas navegam).
        this._selecionarPrimeiroResultadoBusca();
        return;
      }

      // 2ª tentativa: busca por DESCRICAO
      const resDesc: any = await firstValueFrom(this.sankhyaGateway.buscarPecasModal({ DESCRICAO: t, CODEMP: codEmpNum }));
      if (token !== this._buscaPecasToken) return;
      const bodyDesc = resDesc?.responseBody ?? resDesc;
      const listaDesc: any[] = bodyDesc?.lista ?? [];

      this.buscaPecasResultados   = listaDesc;
      this.buscaPecasSemResultado = listaDesc.length === 0;
      this._selecionarPrimeiroResultadoBusca();
    } catch (err) {
      if (token !== this._buscaPecasToken) return;
      console.error('[BuscaPecas] erro:', err);
      this.buscaPecasSemResultado = true;
    } finally {
      if (token === this._buscaPecasToken) this.buscaPecasCarregando = false;
    }
  }

  private _selecionarPrimeiroResultadoBusca(): void {
    const lista = this.buscaPecasResultadosExibidos;
    if (lista.length > 0) void this.selecionarProdutoParaDetalhe(lista[0]);
  }

  /** Setas navegam pelos resultados; Enter confirma o selecionado (executa antes a busca se ainda estiver pendente). */
  async onBuscaPecasKeydown(ev: KeyboardEvent): Promise<void> {
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      const lista = this.buscaPecasResultadosExibidos;
      if (lista.length === 0) return;
      ev.preventDefault();
      let i = lista.indexOf(this.buscaPecasProdutoSelecionado);
      i = ev.key === 'ArrowDown' ? Math.min(lista.length - 1, i + 1) : Math.max(0, i - 1);
      void this.selecionarProdutoParaDetalhe(lista[i]);
      setTimeout(() => document.querySelector('.busca-pecas-linha-selecionada')?.scrollIntoView({ block: 'nearest' }), 0);
      return;
    }
    if (ev.key !== 'Enter') return;
    ev.preventDefault();
    const termo = (this.buscaPecasTermo ?? '').trim();
    if (termo.length >= 2 && (termo !== this._buscaPecasTermoExecutado || this.buscaPecasCarregando)) {
      await this._executarBuscaPecas(termo); // busca ainda pendente (digitou rápido): executa agora
    }
    const lista = this.buscaPecasResultadosExibidos;
    const escolhido = (lista.includes(this.buscaPecasProdutoSelecionado) ? this.buscaPecasProdutoSelecionado : null) ?? lista[0];
    if (escolhido) this.selecionarPecaModal(escolhido);
  }

  /** Destaca um produto na lista e carrega o estoque por local + alternativos abaixo */
  async selecionarProdutoParaDetalhe(prod: any): Promise<void> {
    // Guarda: um duplo-clique dispara click, click, dblclick em sequência no navegador.
    // Sem esta guarda, este método reseta e refaz o fetch duas vezes antes do dblclick
    // ser processado, causando a "tela tremendo" durante o duplo-clique.
    if (this.buscaPecasProdutoSelecionado === prod) return;

    this.buscaPecasProdutoSelecionado     = prod;
    // Fixa o produto principal expandido — a sub-lista de alternativos usa este
    // campo (não buscaPecasProdutoSelecionado) para permanecer visível mesmo
    // quando o usuário depois clica em um dos alternativos abaixo.
    this.buscaPecasProdutoExpandido       = prod;
    this.buscaPecasLocais                 = [];
    this.buscaPecasLocaisCarregando       = true;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = true;

    const codprod = Number(prod.codprod);

    // Imagem (fire-and-forget, painel lateral direito)
    this._carregarImagemProdutoDetalhe(codprod);

    if (!codprod) {
      this.buscaPecasLocaisCarregando       = false;
      this.buscaPecasAlternativosCarregando = false;
      return;
    }

    // Estoque por local (aguardado)
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarEstoquePorLocal(codprod));
      const body = res?.responseBody ?? res;
      const todos: any[] = body?.locais ?? [];
      this.buscaPecasLocais = this._agruparLocais(todos).filter(
        l => (l.qtdTotal ?? 0) !== 0 || (l.qtdReservada ?? 0) !== 0 || (l.disponivel ?? 0) !== 0
      );
    } catch (err) {
      console.error('[BuscaPecas] erro ao buscar estoque:', err);
    } finally {
      this.buscaPecasLocaisCarregando = false;
    }

    // Alternativos TGFPAL (fire-and-forget)
    const codEmpAlt = Number(this.empresaState.selecionada) || undefined;
    this.sankhyaGateway.buscarAlternativosProduto(codprod, codEmpAlt).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        this.buscaPecasAlternativos           = body?.lista ?? [];
        this.buscaPecasAlternativosCarregando = false;
      },
      error: () => { this.buscaPecasAlternativosCarregando = false; }
    });
  }

  /**
   * Busca todas as imagens do produto destacado no F3/F7 — a principal (TGFPRO.IMAGEM)
   * e o histórico (GPL_PRODUTOSIMG, até 5, mais recentes primeiro) — pro painel lateral
   * direito e sua faixa de miniaturas. Fire-and-forget (não bloqueia a seleção) com token
   * de invalidação — se o usuário clicar em outro item antes da resposta chegar, o
   * resultado obsoleto é descartado (senão a imagem do item anterior "pisca" por cima
   * do novo selecionado).
   */
  private _carregarImagemProdutoDetalhe(codprod: number): void {
    this.buscaPecasImagemUrl = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    if (!codprod) { this.buscaPecasImagemCarregando = false; return; }
    this.buscaPecasImagemCarregando = true;
    const token = ++this._buscaPecasImagemToken;
    this.sankhyaGateway.buscarImgProdutoEdicao({CODPROD: codprod}).subscribe({
      next: (res: any) => {
        if (token !== this._buscaPecasImagemToken) return;
        const body = res?.responseBody ?? res;
        const imagens: string[] = [];
        if (body?.principal) {
          imagens.push(`data:image/jpeg;base64,${body.principal}`);
        }
        for (const img of (body?.lista ?? [])) {
          if (img?.imagem) imagens.push(`data:image/jpeg;base64,${img.imagem}`);
        }
        this.buscaPecasImagensExtras   = imagens;
        this.buscaPecasImagemIndexAtivo = 0;
        this.buscaPecasImagemUrl       = imagens.length > 0 ? imagens[0] : null;
        this.buscaPecasImagemCarregando = false;
      },
      error: () => {
        if (token !== this._buscaPecasImagemToken) return;
        this.buscaPecasImagemUrl = null;
        this.buscaPecasImagensExtras      = [];
        this.buscaPecasImagemIndexAtivo    = 0;
        this.buscaPecasImagemCarregando = false;
      }
    });
  }

  /** Confirma a seleção do produto destacado e fecha o modal */
  confirmarSelecaoPeca(): void {
    const prod = this.buscaPecasProdutoSelecionado;
    if (!prod || !this._buscaPecasItem) return;
    this._buscaPecasItem.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
    this._preencherItemComProduto(this._buscaPecasItem, prod);
    this.fecharBuscaPecas();
  }

  buscaTotalLocais(campo: 'qtdTotal' | 'qtdReservada' | 'disponivel'): number {
    return this.buscaPecasLocais.reduce((acc, l) => acc + ((l[campo] as number) ?? 0), 0);
  }

  /** digitsInfo do pipe "number" para as colunas Total/Reservado/Disponível do
   *  painel "Estoque por Local" (F3). Produto em UN nunca tem fração (não dá
   *  pra vender "meia peça"), então mostra inteiro; outras unidades (KG, L,
   *  etc.) continuam com até 3 casas decimais. */
  casasDecimaisEstoqueLocal(valor?: number | null): string {
    return this.casasDecimaisQtd(this.buscaPecasProdutoSelecionado?.codvol, valor);
  }

  /** digitsInfo do pipe "number" para qualquer campo de quantidade/estoque com
   *  base na unidade do produto. UN nunca tem fração (não dá pra vender "meia
   *  peça"), então mostra inteiro; unidades fracionárias (M, KG, L, etc.)
   *  continuam mostrando até 3 casas decimais. Usado em Estoque (F3/F7),
   *  Estoque por Local e na confirmação de Estoque Insuficiente.
   *  "valor": quando informado e for um número inteiro (sem fração), força
   *  exibição sem casas decimais MESMO que a unidade cadastrada não seja UN —
   *  evita "20.000" aparecer no lugar de "20" (o pipe pt-BR usa "." como
   *  separador de milhar, então "20.000" é facilmente lido como "vinte mil"
   *  por engano) quando o valor real não tem fração nenhuma. */
  casasDecimaisQtd(unidade: string | null | undefined, valor?: number | string | null): string {
    // "valor" às vezes chega como string (ex.: BigDecimal serializado como "2.000"
    // pelo backend) em vez de number — Number.isInteger('2.000') sempre retorna
    // false para string, mesmo o valor sendo inteiro, então isso derrubava pro
    // fallback por unidade e voltava a mostrar ".000". Convertendo com Number(...)
    // e tolerando resíduo de ponto flutuante (ex.: 1.9999999999998 vindo de SUM()
    // no Oracle) cobre os dois casos.
    if (valor != null && valor !== '') {
      const num = typeof valor === 'string' ? Number(valor.replace(',', '.')) : valor;
      if (Number.isFinite(num) && Math.abs(num - Math.round(num)) < 1e-6) {
        return '1.0-0';
      }
    }
    const un = String(unidade ?? 'UN').trim().toUpperCase();
    return un === 'UN' ? '1.0-0' : '1.0-3';
  }

  /** Duplo-clique ou clique direto na linha para confirmar imediatamente */
  selecionarPecaModal(prod: any): void {
    if (this._buscaPecasItem) {
      this._buscaPecasItem.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
      this._preencherItemComProduto(this._buscaPecasItem, prod);
    }
    this.fecharBuscaPecas();
  }

  fecharBuscaPecas(retornarFocoOrigem = false): void {
    this.buscaPecasAberta                 = false;
    this._buscaPecasItem                  = null;
    this.buscaPecasResultados             = [];
    this.buscaPecasTermo                  = '';
    this.buscaPecasProdutoSelecionado     = null;
    this.buscaPecasProdutoExpandido       = null;
    this.buscaPecasLocais                 = [];
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = false;
    this.buscaPecasImagemUrl              = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.imagemPreviewAberta              = false;
    // Devolve o foco ao campo PN que acionou a abertura (somente via ESC)
    if (retornarFocoOrigem && this._buscaPecasPnInputOrigem) {
      const inputPn = this._buscaPecasPnInputOrigem;
      this._buscaPecasPnInputOrigem = null;
      setTimeout(() => inputPn.focus(), 50);
    } else {
      this._buscaPecasPnInputOrigem = null;
    }
  }

  /**
   * Abre a tela de Busca de Peças com resultados já carregados (evita
   * dupla requisição quando vindo de buscarProdutoPorPN com múltiplos).
   */
  private _abrirBuscaPecasComResultados(item: ItemPedido, pn: string, lista: any[]): void {
    this._buscaPecasItem              = item;
    this.buscaPecasTermo              = pn;
    this.buscaPecasResultados         = lista;
    this.buscaPecasSemResultado       = lista.length === 0;
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasProdutoExpandido   = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasLocaisCarregando   = false;
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.buscaPecasAberta             = true;
    setTimeout(() => {
      document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
    }, 60);
  }

  /**
   * Blur no campo PN:
   * - Campo com texto e produto não carregado → dispara busca automática
   * - Campo vazio com produto anteriormente carregado → alerta para redigitar
   */
  onPnBlur(item: ItemPedido, event: FocusEvent): void {
    // Se o foco foi para um elemento dentro da própria modal/botão de busca,
    // não disparar (evita conflito com click em elementos internos).
    const relatedTarget = event.relatedTarget as HTMLElement | null;
    if (relatedTarget?.closest?.('.busca-pecas-modal, .produto-modal, button[class*="pn"]')) return;

    const pn = (item.codprod ?? '').trim();

    if (!pn) {
      // Campo apagado — se tinha produto carregado, avisa
      if (item.codprodInterno || item.descricao) {
        this.abrirAlerta('O campo PN foi apagado. Digite um PN para buscar o produto.', 'aviso');
        item.codprodInterno = undefined;
        item.descricao      = '';
      }
      return;
    }

    // Produto já carregado + texto diferente do PN original → restaura PN (apagou parte)
    if (item.codprodInterno) {
      const original = item.codprodOriginal;
      if (original && pn !== original.trim()) {
        item.codprod = original;
      }
      return;
    }

    // Tem texto mas produto ainda não carregado → busca automática
    this.buscarProdutoPorPN(item, event as unknown as Event);
  }

  private async _preencherItemComProduto(item: ItemPedido, prod: any, focarQtd = true): Promise<void> {
    item.descricao        = prod.descricao     ?? '';
    
    // Atualiza o PN exibido com a formatação exata do banco (com traços e caracteres especiais)
    const pnExato = prod.refforn ?? prod.REFFORN ?? prod.referencia ?? String(prod.codprod ?? '');
    if (pnExato) {
      item.codprod = pnExato;
    }
    
    item.codprodOriginal  = item.codprod;       // salva o PN atual para restaurar se o usuário apagar parcialmente
    let cond = String(prod.adCondicao ?? prod.ad_condicao ?? prod.AD_CONDICAO ?? '').trim();
    if (cond.toLowerCase() === 'null' || cond.toLowerCase() === 'undefined') cond = '';
    item.adCondicao     = cond;
    item.unidade        = prod.codvol        ?? 'UN';
    item.codprodInterno = prod.codprod       ? Number(prod.codprod) : undefined;
    item.codlocalpadrao = prod.codlocalpadrao ? Number(prod.codlocalpadrao) : 0;
    item.codlocal        = item.codlocalpadrao;   // valor inicial — usuário pode trocar clicando na coluna "Local"
    item.descrLocal       = undefined;
    // TGFMAR.AD_ORIGEM (texto bruto) — só informativo, exibido como badge na descrição.
    item.origem          = prod.origem ?? '';

    // Alerta de preço desatualizado — só na adição individual (F3 / PN+Enter),
    // não na importação em massa (que chama este método com focarQtd=false),
    // para não interromper o fluxo com N modais durante um import de várias linhas.
    if (focarQtd && prod.precoDesatualizado === true) {
      this._abrirModalAviso('Produto/Peça com preço desatualizado!', () => this._focarQtdDoItem(item));
    }

    // Alíquota IPI já vem na busca de produtos (JOIN com TGFIPI no backend)
    const aliqIpiProd = parseFloat(String(prod.aliqIpi ?? prod.aliq_ipi ?? '0').replace(',', '.')) || 0;
    if (aliqIpiProd > 0) {
      item.aliqIpi = aliqIpiProd;
    }
    // CODMARCA (Fabricante 70) precisa estar resolvido ANTES de buscar/calcular
    // o preço — por isso aguarda aqui em vez de disparar em paralelo (senão o
    // cálculo de preço poderia rodar com fabricante70 ainda desconhecido).
    await this._buscarDadosProdutoCompleto(item);

    // Busca o preço na TGFEXC e calcula VLRUNIT — normal (USD × cotação) ou,
    // se Fabricante 70, invertido (ver dentro de _buscarPrecoExcItem).
    // Retorna a Promise para que importações em massa possam aguardar todos os carregamentos
    return this._buscarPrecoExcItem(item, focarQtd);
  }

  /**
   * Busca dados do produto (TGFPRO) direto pelo backend deste projeto (não
   * pelo addon do Sankhya) — usado para complementar AD_CONDICAO quando não
   * vem na busca de peças, e para identificar CODMARCA = 70 (Fabricante 70:
   * ver _buscarPrecoExcItem e onPrecoUnitarioChange para o cálculo invertido).
   */
  /** Converte valor numérico vindo do Sankhya, tolerando vírgula decimal
   *  (ex: "5,00") além do ponto padrão (ex: "5.00"). Retorna undefined se
   *  vazio/inválido. */
  private _parseNumBr(v: any): number | undefined {
    if (v == null) return undefined;
    const s = String(v).trim();
    if (!s) return undefined;
    let n = Number(s);
    if (!Number.isFinite(n)) {
      n = Number(s.replace(',', '.'));
    }
    return Number.isFinite(n) ? n : undefined;
  }

  private _buscarDadosProdutoCompleto(item: ItemPedido): Promise<void> {
    if (!item.codprodInterno) return Promise.resolve();
    return new Promise<void>(resolve => {
      this.produtoService.buscarProdutoCompleto(item.codprodInterno!).subscribe({
        next: res => {
          if (!item.adCondicao) {
            let val = String(res?.dados?.['AD_CONDICAO'] ?? '').trim();
            if (val.toLowerCase() === 'null' || val.toLowerCase() === 'undefined') val = '';
            item.adCondicao = val;
          }
          const codMarca = Number(res?.dados?.['CODMARCA']);
          // Fabricantes "nacionais" (cálculo inverso R$→U$) agora vêm do
          // parâmetro FABNAC (tela de Parâmetros do Sistema) — antes fixo
          // em 70 (Embraer). Sem FABNAC configurado, mantém só o 70.
          item.fabricante70 = this._fabricantesNacionaisConfigurados().includes(codMarca);
          // Modo edição: o item já chega com precoUnitario (TGFITE.VLRUNIT) —
          // só falta o texto do input. Na adição de item novo, precoUnitario
          // ainda é 0 aqui (esta chamada é aguardada antes de _buscarPrecoExcItem),
          // então essa condição não faz nada e o valor vem de lá.
          if (item.fabricante70 && item.precoUnitario > 0 && !item.precoUnitarioStr) {
            item.precoUnitarioStr = this.formatarDecimal(item.precoUnitario);
          }

          // Produto controlado (GPL_CONTROLADO) — limita a quantidade vendida
          // por mês conforme o documento do cliente (CPF/CNPJ). Ver
          // validarQtdControlado().
          item.controlado = String(res?.dados?.['GPL_CONTROLADO'] ?? '').trim().toUpperCase() === 'S';
          item.ctrlLimPf  = this._parseNumBr(res?.dados?.['GPL_CTRL_LIM_PF']);
          item.ctrlLimPj  = this._parseNumBr(res?.dados?.['GPL_CTRL_LIM_PJ']);
          this.validarQtdControlado(item);

          resolve();
        },
        error: () => resolve(),
      });
    });
  }

  // ── Utilitário: agrupa linhas de estoque por (codemp + descrLocal) ─────────

  /**
   * Agrupa as linhas de estoque pela chave empresa + local, somando qtdTotal,
   * qtdReservada e disponivel. Evita que o mesmo local apareça repetido quando
   * a API retorna múltiplas partições para o mesmo depósito.
   */
  private _agruparLocais(lista: any[]): any[] {
    // TODO: agrupamento comentado temporariamente a pedido do usuário, para
    // inspecionar as linhas de estoque por local SEM somar por empresa/local.
    // Reativar removendo o "return lista;" abaixo. (mesmo pedido feito no F7,
    // ver gateway.component.ts)
    return lista;

    /*
    const map = new Map<string, any>();
    for (const l of lista) {
      const key = `${l.codemp ?? l.CODEMP ?? 0}__${(l.descrLocal ?? l.DESCRLOCAL ?? '').trim()}`;
      if (map.has(key)) {
        const e = map.get(key)!;
        e.qtdTotal     = (e.qtdTotal     ?? 0) + (l.qtdTotal     ?? l.QTDTOTAL     ?? 0);
        e.qtdReservada = (e.qtdReservada ?? 0) + (l.qtdReservada ?? l.QTDRESERVADA ?? 0);
        e.disponivel   = (e.disponivel   ?? 0) + (l.disponivel   ?? l.DISPONIVEL   ?? 0);
      } else {
        map.set(key, { ...l });
      }
    }
    return Array.from(map.values());
    */
  }

  // ── Alternativos (TGFPAL) — usados no modal Busca de Peças ──────────────

  /**
   * Clique em uma linha de alternativo: atualiza o produto selecionado e
   * carrega o estoque por local para ele, SEM recarregar a lista de alternativos.
   */
  async selecionarAlternativoParaDetalhe(alt: any): Promise<void> {
    // Mesma guarda do produto principal: evita reset/refetch duplicado no duplo-clique.
    if (this.buscaPecasProdutoSelecionado === alt) return;

    this.buscaPecasProdutoSelecionado = alt;
    this.buscaPecasLocais             = [];
    this.buscaPecasLocaisCarregando   = true;
    const codprod = Number(alt.codprod);
    this._carregarImagemProdutoDetalhe(codprod);
    if (!codprod) { this.buscaPecasLocaisCarregando = false; return; }
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarEstoquePorLocal(codprod));
      const body = res?.responseBody ?? res;
      const todos: any[] = body?.locais ?? [];
      this.buscaPecasLocais = this._agruparLocais(todos).filter(
        l => (l.qtdTotal ?? 0) !== 0 || (l.qtdReservada ?? 0) !== 0 || (l.disponivel ?? 0) !== 0
      );
    } catch (err) {
      console.error('[BuscaPecas] erro ao buscar estoque do alternativo:', err);
    } finally {
      this.buscaPecasLocaisCarregando = false;
    }
  }

  /** Busca estoque disponível via buscarEstoquePorLocal (endpoint comprovado) e atualiza item.estoque */
  private async _atualizarEstoqueItem(item: ItemPedido): Promise<void> {
    if (!item.codprodInterno) return;
    // Empresa virtual selecionada (Curitiba/BH/Rio Verde etc.): filtra o estoque
    // pelo CODLOCAL fixo daquela filial, não pela "empresa real" inteira — senão
    // o total exibido somava estoque de TODAS as filiais virtuais misturado
    // (todas são CODEMP=1 por baixo dos panos), voltando a confundir onde o
    // produto realmente está disponível pra quem opera como Rio Verde/BH/etc.
    const opcao = this.empresaState.opcaoSelecionada;
    const codLocalVirtual = opcao?.virtual ? parseInt(opcao.codLocal ?? '0', 10) || 0 : 0;
    const codemp = parseInt(this.empresaState.codEmpReal || this.empresaSelecionada || '0', 10) || 0;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarEstoquePorLocal(item.codprodInterno)
      );
      const body = res?.responseBody ?? res;
      const lista: any[] = body?.locais ?? [];
      let total = 0;
      for (const loc of lista) {
        const emp = parseInt(String(loc.codemp ?? '0'), 10);
        if (codemp > 0 && emp !== codemp) continue; // filtra por empresa real se selecionada
        if (codLocalVirtual > 0) {
          const codLocalLinha = parseInt(String(loc.codLocal ?? loc.codlocal ?? '0'), 10);
          if (codLocalLinha !== codLocalVirtual) continue; // filtra pelo Local da filial virtual
        }
        const disp = parseFloat(String(loc.disponivel ?? '0').replace(',', '.')) || 0;
        total += disp;
      }
      item.estoque = parseFloat(total.toFixed(3));
    } catch (err) {
      console.error('[PedidoVenda] erro ao buscar estoque:', err);
    }
  }

  private async _buscarPrecoExcItem(item: ItemPedido, focarQtd = false, soEstoque = false): Promise<void> {
    if (!item.codprodInterno) return;
    // Preço (TGFEXC/TGFCUS) é por empresa REAL — não existe tabela de preço
    // própria por filial virtual, então sempre traduz pro CODEMP real aqui.
    const codemp = parseInt(this.empresaState.codEmpReal || this.empresaSelecionada || '0', 10) || 0;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarPrecoExc(item.codprodInterno, codemp)
      );
      const body = res?.responseBody ?? res;
      const info  = body?.info ?? body;

      const vlrVenda = parseFloat(String(info?.vlrVenda  ?? '0').replace(',', '.')) || 0;
      const vlrCore  = parseFloat(String(info?.vlrCore   ?? '0').replace(',', '.')) || 0;
      const core     = String(info?.controlaCore ?? 'N').toUpperCase() === 'S';
      const aliqIpi  = parseFloat(String(info?.aliqIpi   ?? '0').replace(',', '.')) || 0;

      // Data Ult. Atual. Preço / Limite p/ Atual. (Dias) / Preço Desatualizado —
      // atualiza sempre (inclusive em modo soEstoque, usado ao carregar pedido
      // para edição), para que o destaque na tabela de Itens do Pedido reflita
      // o estado atual do catálogo mesmo em itens já negociados.
      item.dataUltAtualPreco    = info?.dataUltAtualPreco ?? '';
      item.limitePrazoAtualDias = Number(info?.limitePrazoAtualDias) || 0;
      item.precoDesatualizado   = info?.precoDesatualizado === true;
      item.origem                = info?.origem ?? '';

      // Modo soEstoque: apenas atualiza disponibilidade — preserva preços negociados.
      // Mesmo assim, calcula precoDivergenteCatalogo (ver campo no ItemPedido) —
      // compara o VALOR atual do catálogo com o que está negociado no item,
      // independente de precoDesatualizado (que só olha a DATA do registro).
      // Sem isso, um catálogo atualizado agora mesmo (registro "novo", logo
      // precoDesatualizado=false) escondia o destaque mesmo o item continuando
      // com um valor negociado antigo, diferente do catálogo (bug reportado
      // com o produto MISCELANEOUS: catálogo US$65,28, item ainda em US$54,40,
      // sem nenhum aviso).
      if (soEstoque) {
        const taxaAtual = this.cotacaoValorNumerico;
        if (item.fabricante70) {
          const coreUnitBrlAtual = (core && vlrCore > 0 && taxaAtual > 0)
            ? parseFloat((vlrCore * taxaAtual).toFixed(2)) : 0;
          const precoCatalogoEquivalente = vlrVenda + (core ? coreUnitBrlAtual : 0);
          item.precoDivergenteCatalogo = Math.abs(precoCatalogoEquivalente - (item.precoUnitario || 0)) > 0.01;
        } else {
          const precoCatalogoEquivalente = vlrVenda + (core ? vlrCore : 0);
          item.precoDivergenteCatalogo = Math.abs(precoCatalogoEquivalente - (item.precoUsd || 0)) > 0.01;
        }
        await this._atualizarEstoqueItem(item);
        return;
      }

      item.vlrCore      = vlrCore;
      item.controlaCore = core;
      item.aliqIpi      = aliqIpi;
      // Estoque via endpoint dedicado (mesmo usado no modal — comprovado)
      this._atualizarEstoqueItem(item);

      const taxa = this.cotacaoValorNumerico;
      const coreUnitBrl = (core && vlrCore > 0 && taxa > 0)
        ? parseFloat((vlrCore * taxa).toFixed(2)) : 0;
      item.coreUnitBrl = coreUnitBrl;

      if (item.fabricante70) {
        // Fabricante 70: o valor que vem da TGFEXC (vlrVenda) já É o preço em
        // R$ — não multiplica pela cotação. O Vl. Unit. U$ é calculado de
        // forma inversa (R$ ÷ cotação do dia), ao contrário do fluxo normal.
        const precoUnitFinal = vlrVenda + (core ? coreUnitBrl : 0);
        item.precoUnitario    = parseFloat(precoUnitFinal.toFixed(2));
        item.precoUnitarioStr = item.precoUnitario > 0 ? this.formatarDecimal(item.precoUnitario) : '';
        item.precoUsd    = taxa > 0 ? parseFloat((item.precoUnitario / taxa).toFixed(2)) : 0;
        item.precoUsdStr = item.precoUsd > 0 ? this.formatarDecimal(item.precoUsd) : '';
      } else {
        // precoUsd e precoUnitario do catálogo NÃO incluem Core — soma quando Core ativo
        const precoUsdFinal = vlrVenda + (core ? vlrCore : 0);
        item.precoUsd    = parseFloat(precoUsdFinal.toFixed(2));
        item.precoUsdStr = item.precoUsd > 0 ? this.formatarDecimal(item.precoUsd) : '';

        if (taxa > 0) {
          item.precoUnitario = parseFloat((item.precoUsd * taxa).toFixed(2));
        }
      }
      // Preço acabou de ser sincronizado com o catálogo — não diverge mais.
      item.precoDivergenteCatalogo = false;
      // Sempre recalcula — garante totalCoreBrl e totalCoreUsd no subtotal
      this.calcularTotal(item);
    } catch (err) {
      console.error('[PedidoVenda] erro ao buscar preço EXC:', err);
    }
    // Foca QTD apenas quando chamado ao adicionar produto novo (não em modo edição).
    // Se o modal de "preço desatualizado" foi aberto (ver _preencherItemComProduto),
    // o foco já será devolvido ao fechar o modal — não faz aqui pra não competir com ele.
    if (focarQtd && !this.modalAvisoAberto) {
      this._focarQtdDoItem(item);
    }
  }

  /** F2 em qualquer input da tabela de itens → foca o mesmo campo na linha seguinte */
  onF2Navegar(event: Event): void {
    event.preventDefault();
    const input = event.target as HTMLElement;
    const td = input.closest('td');
    const tr = input.closest('tr');
    if (!td || !tr) return;
    const tdIndex = Array.from(tr.children).indexOf(td);
    const nextTr = tr.nextElementSibling as HTMLElement;
    if (!nextTr) return;
    const nextTd = nextTr.children[tdIndex] as HTMLElement;
    if (!nextTd) return;
    const nextInput = nextTd.querySelector<HTMLInputElement>('input:not([disabled])');
    if (nextInput) { nextInput.focus(); nextInput.select?.(); }
  }

  onArrowUpNavegar(event: Event): void {
    event.preventDefault();
    const input = event.target as HTMLElement;
    const td = input.closest('td');
    const tr = input.closest('tr');
    if (!td || !tr) return;
    const tdIndex = Array.from(tr.children).indexOf(td);
    const prevTr = tr.previousElementSibling as HTMLElement;
    if (!prevTr) return;
    const prevTd = prevTr.children[tdIndex] as HTMLElement;
    if (!prevTd) return;
    const prevInput = prevTd.querySelector<HTMLInputElement>('input:not([disabled])');
    if (prevInput) { prevInput.focus(); prevInput.select?.(); }
  }

  onVlrCoreBlur(item: ItemPedido, event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    const raw = (inputEl.value ?? '').replace(',', '.');
    const valor = parseFloat(raw);
    if (!isNaN(valor) && valor > 0) {
      const taxa = this.cotacaoValorNumerico;
      // Remove Core anterior dos preços antes de somar o novo
      const coreUsdAnterior = item.vlrCore ?? 0;
      const coreBrlAnterior = item.coreUnitBrl ?? 0;
      item.precoUsd      = parseFloat(Math.max(0, item.precoUsd - coreUsdAnterior).toFixed(2));
      item.precoUnitario = parseFloat(Math.max(0, item.precoUnitario - coreBrlAnterior).toFixed(2));
      // Soma o novo valor
      const novoVlrCore  = parseFloat((coreUsdAnterior + valor).toFixed(2));
      const novoCoreUnitBrl = taxa > 0 ? parseFloat((novoVlrCore * taxa).toFixed(2)) : 0;
      item.vlrCore       = novoVlrCore;
      item.coreUnitBrl   = novoCoreUnitBrl;
      item.precoUsd      = parseFloat((item.precoUsd + novoVlrCore).toFixed(2));
      item.precoUnitario = parseFloat((item.precoUnitario + novoCoreUnitBrl).toFixed(2));
      item.precoUsdStr   = this.formatarDecimal(item.precoUsd);
      this.calcularTotal(item);
    }
    // Limpa o input auxiliar
    inputEl.value = '';
  }

  /** Enter em QTD → foca Preço; Enter em Preço → foca Desconto */
  focarCampoItem(event: Event, item: ItemPedido, campo: 'precoUsd' | 'desconto' | 'vlrDesc' | 'vlrAcrescDesc'): void {
    event.preventDefault();
    const idx = this.itens.indexOf(item);
    const rows = document.querySelectorAll<HTMLElement>('.itens-table tbody tr');
    const inputs = rows[idx]?.querySelectorAll<HTMLInputElement>('.cell-desc-input');
    let input: HTMLInputElement | null = null;
    if (campo === 'precoUsd') {
      input = rows[idx]?.querySelector<HTMLInputElement>('.cell-preco-usd-input') ?? null;
    } else if (campo === 'desconto') {
      input = inputs?.[0] ?? null;
    } else if (campo === 'vlrDesc') {
      input = inputs?.[1] ?? null;
    } else if (campo === 'vlrAcrescDesc') {
      input = inputs?.[2] ?? null;
    }
    input?.focus();
    input?.select();
  }

  /** Enter no Desconto: confirma o item e abre nova linha */
  confirmarItem(item: ItemPedido, event: Event): void {
    event.preventDefault();
    const idx = this.itens.indexOf(item);
    if (idx === this.itens.length - 1) {
      this.itens.push(this._novoItem());
      setTimeout(() => this._focarUltimoPN(), 50);
    } else {
      setTimeout(() => {
        const inputs = document.querySelectorAll<HTMLInputElement>('.cell-pn-input');
        inputs[idx + 1]?.focus();
        inputs[idx + 1]?.select();
      }, 50);
    }
  }

  // ── Confirmação de remoção de item ──
  confirmarRemocaoAberta = false;
  private _idItemParaRemover: number | null = null;

  solicitarRemocaoItem(id: number): void {
    this._idItemParaRemover = id;
    this.confirmarRemocaoAberta = true;
  }

  confirmarRemocaoItem(): void {
    if (this._idItemParaRemover !== null) {
      this.itens = this.itens.filter(i => i.id !== this._idItemParaRemover);
      this._garantirLinhaEmBranco();
    }
    this.confirmarRemocaoAberta = false;
    this._idItemParaRemover = null;
  }

  cancelarRemocaoItem(): void {
    this.confirmarRemocaoAberta = false;
    this._idItemParaRemover = null;
  }

  removerItem(id: number): void {
    this.itens = this.itens.filter(i => i.id !== id);
    this._garantirLinhaEmBranco();
  }

  /**
   * Só recria a linha em branco quando ela deixou de existir (ex.: removeu o item
   * e não sobrou nenhuma linha vazia para continuar digitando). Se já existe uma
   * linha em branco, não faz nada — evita ficar empilhando linhas vazias.
   */
  private _garantirLinhaEmBranco(): void {
    const temLinhaEmBranco = this.itens.some(i => !i.codprodInterno && !i.descricao);
    if (!temLinhaEmBranco) {
      this.itens.push(this._novoItem());
    }
  }

  toggleCore(item: ItemPedido): void {
    if (item.controlaCore) {
      // Sim → Não: remove Core do precoUsd (U$) e do precoUnitario (R$)
      const coreUsd = item.vlrCore ?? 0;
      const coreBrl = item.coreUnitBrl ?? 0;
      item.controlaCore  = false;
      item.coreUnitBrl   = 0;
      item.precoUsd      = parseFloat(Math.max(0, item.precoUsd - coreUsd).toFixed(2));
      item.precoUnitario = parseFloat(Math.max(0, item.precoUnitario - coreBrl).toFixed(2));
      item.precoUsdStr   = item.precoUsd > 0 ? this.formatarDecimal(item.precoUsd) : '';
      this.calcularTotal(item);
    } else {
      // Não → Sim: soma Core ao precoUsd (U$) e ao precoUnitario (R$)
      if (!(item.vlrCore > 0)) return;
      const taxa        = this.cotacaoValorNumerico;
      const coreUsd     = item.vlrCore;
      const coreUnitBrl = taxa > 0 ? parseFloat((coreUsd * taxa).toFixed(2)) : 0;
      item.controlaCore  = true;
      item.coreUnitBrl   = coreUnitBrl;
      item.precoUsd      = parseFloat((item.precoUsd + coreUsd).toFixed(2));
      item.precoUnitario = parseFloat((item.precoUnitario + coreUnitBrl).toFixed(2));
      item.precoUsdStr   = this.formatarDecimal(item.precoUsd);
      this.calcularTotal(item);
    }
  }

  /**
   * Base do desconto por item: valor unitário×qty + IPI + ICMS-ST do item —
   * a pedido do usuário, o % ou R$ de desconto negociado por item incide
   * sobre produto+imposto, não só produto (mesmo padrão já usado no rateio
   * do Desconto Geral, ver aplicarRateioDesconto). Isso NÃO quebra o VLRTOT
   * gravado CHEIO (ver GeraNotaFiscalHelper#aplicarDescontoItens): o VLRDESC
   * resultante fica maior (carrega a fatia do imposto embutida), mas
   * calcularTotal() sempre faz item.total = produto − vlrDesc (base SÓ do
   * produto, não esta função) — então a reconstrução líquido+vlrDesc=VLRTOT
   * continua batendo com o produto cheio, e o líquido final (VLRTOT−VLRDESC)
   * sai coerente com produto+imposto−desconto menos o próprio imposto.
   */
  private _baseDescontoComImposto(item: ItemPedido): number {
    return item.quantidade * item.precoUnitario + (item.vlrIpi || 0) + (item.vlrIcmsst || 0);
  }

  /** Seleciona todo o texto do campo ao focar — usado no Desc/Acrs. % (input
   *  number). Sem isso, clicar no campo com "0" e digitar direto faz o
   *  navegador inserir o dígito do lado do zero existente em vez de
   *  substituir (ex.: digitar "5" quando o cursor cai antes do "0" vira
   *  "50" em vez de "5") — usuário relatou desconto/acréscimo saindo com
   *  percentual muito maior que o digitado por causa disso. */
  selecionarTextoCampo(event: FocusEvent): void {
    const alvo = event.target as HTMLInputElement | null;
    alvo?.select();
  }

  onDescontoPercChange(item: ItemPedido): void {
    const base = this._baseDescontoComImposto(item);
    if (base > 0) {
      // Desconto positivo não pode ultrapassar 100% (entraria no core)
      if ((item.desconto || 0) > 100) {
        this._abrirModalAviso(
          `O desconto não pode ultrapassar 100% do valor unitário + impostos (R$ ${this.formatarMoeda(base)}). Ajustado para 100%.`
        );
        item.desconto = 100;
      }
      item.vlrDesc = parseFloat((base * (item.desconto || 0) / 100).toFixed(2));
      item.vlrAcrescDesc = 0;
      item.vlrDescStr = item.vlrDesc !== 0
        ? (item.vlrDesc < 0 ? '-' + this.formatarDecimal(Math.abs(item.vlrDesc)) : this.formatarDecimal(item.vlrDesc))
        : '';
    }
    this.calcularTotal(item);
    this._atualizarEspelhoDescGeral();
  }

  onDescontoVlrChange(item: ItemPedido): void {
    // Sanitiza: aceita no máximo UM "-" (só como primeiro caractere, indicando
    // acréscimo). Digitar mais de um "-" deixava o texto e o cálculo
    // divergentes e bugava a tela — aqui já corrige o texto exibido também.
    let raw = item.vlrDescStr ?? '';
    const negativo = raw.trimStart().startsWith('-');
    raw = raw.replace(/-/g, '');
    if (negativo) raw = '-' + raw;
    if (raw !== item.vlrDescStr) {
      item.vlrDescStr = raw;
    }

    const normalizado = raw.replace(',', '.');
    const num = parseFloat(normalizado);
    if (!isNaN(num)) {  // permite negativo (acréscimo)
      item.vlrDesc      = num;
      item.vlrAcrescDesc = 0; // consolida acréscimo em vlrDesc negativo
      const base = this._baseDescontoComImposto(item);
      if (base > 0) {
        item.desconto = parseFloat((num / base * 100).toFixed(2));
      }
      // preservarVlrDesc=true: o vlrDesc já é o valor exato digitado (num) —
      // sem isso, calcularTotal recalculava vlrDesc de volta a partir do
      // desconto% já ARREDONDADO acima, corrompendo silenciosamente o valor
      // exato que o vendedor acabou de digitar por um centavo de diferença.
      this.calcularTotal(item, true);
      this._atualizarEspelhoDescGeral();
    }
  }

  onDescontoVlrBlur(item: ItemPedido): void {
    item.vlrAcrescDesc = 0; // consolida no vlrDesc (negativo = acréscimo)

    // Desconto positivo não pode ultrapassar a base (unitário+impostos = parte não-core)
    if ((item.vlrDesc || 0) > 0) {
      const base = this._baseDescontoComImposto(item);
      if ((item.vlrDesc || 0) > base) {
        this._abrirModalAviso(
          `O desconto não pode ultrapassar R$ ${this.formatarMoeda(base)} (valor unitário + impostos, sem core). Ajustado para o limite máximo.`
        );
        item.vlrDesc  = base;
        item.desconto = 100;
        this.calcularTotal(item);
      }
    }

    item.vlrDescStr = item.vlrDesc !== 0
      ? (item.vlrDesc < 0 ? '-' + this.formatarDecimal(Math.abs(item.vlrDesc)) : this.formatarDecimal(item.vlrDesc))
      : '';

    // Atualiza os campos gerais para refletir o desconto acumulado dos itens
    this._atualizarEspelhoDescGeral();
  }

  calcularTotal(item: ItemPedido, preservarVlrDesc = false): void {
    const base = item.quantidade * item.precoUnitario;
    // Mantém vlrDesc sincronizado com desconto% quando base muda (qtd ou preço alterados).
    // preservarVlrDesc=true (rateio, ou quando o próprio vlrDesc acabou de ser
    // digitado/calculado com precisão exata): mantém vlrDesc exato, não re-deriva do % arredondado.
    if (!preservarVlrDesc && base > 0 && (item.desconto || 0) !== 0) {
      // Base do desconto% inclui IPI/ICMS-ST do item — mesma base usada em
      // onDescontoPercChange/onDescontoVlrChange (ver _baseDescontoComImposto).
      const baseComImposto = this._baseDescontoComImposto(item);
      item.vlrDesc = parseFloat((baseComImposto * item.desconto / 100).toFixed(2));
      // BUG CORRIGIDO: antes o texto exibido na coluna "Desc/Acrs. Vlr"
      // (vlrDescStr) não era atualizado aqui — só o número (vlrDesc) usado no
      // cálculo. Isso fazia a coluna mostrar um valor de desconto ANTIGO
      // (de antes do preço/cotação/qtd mudar) mesmo com o Subtotal do item já
      // recalculado corretamente com o valor novo — confundindo o vendedor e
      // parecendo (na tela) que o desconto do item estava errado, embora o
      // valor realmente gravado (vlrDesc) sempre estivesse certo. Este branch
      // só roda quando NINGUÉM está digitando nesse campo agora mesmo (ver
      // preservarVlrDesc=true em onDescontoVlrChange/onTotalItemBlur), então
      // é seguro reformatar o texto aqui.
      item.vlrDescStr = item.vlrDesc !== 0
        ? (item.vlrDesc < 0 ? '-' + this.formatarDecimal(Math.abs(item.vlrDesc)) : this.formatarDecimal(item.vlrDesc))
        : '';
    }
    // Core rastreado para exibição — já está embutido em precoUnitario quando ativo
    item.totalCoreUsd = item.controlaCore ? parseFloat((item.quantidade * (item.vlrCore ?? 0)).toFixed(2)) : 0;
    item.totalCoreBrl = item.controlaCore ? parseFloat((item.quantidade * (item.coreUnitBrl ?? 0)).toFixed(2)) : 0;
    // vlrDesc negativo = acréscimo. Core já está em precoUnitario — não somar novamente.
    item.total = parseFloat((base - (item.vlrDesc || 0) + (item.vlrAcrescDesc || 0)).toFixed(2));
    const baseUsd = item.quantidade * item.precoUsd;
    // USD: Core em USD também já rastreado em totalCoreUsd, não somar ao totalUsd
    item.totalUsd = item.precoUsd > 0
      ? parseFloat((baseUsd - (baseUsd * (item.desconto || 0) / 100)).toFixed(2))
      : 0;
    // IPI: recalcula em tempo real sobre o total líquido do item (base de cálculo
    // = item.total, já com desconto aplicado) — confirmado pelo usuário como o
    // comportamento correto: o desconto reduz o valor do item e o IPI acompanha.
    // Estimativa local; o valor real (e o ICMS-ST, que essa fórmula não cobre)
    // vem do rascunho silencioso via ImpostosHelpper (ver _agendarRascunhoImpostos).
    if ((item.aliqIpi ?? 0) > 0) {
      item.vlrBaseIpi = item.total;
      item.vlrIpi     = parseFloat((item.total * (item.aliqIpi!) / 100).toFixed(2));
    } else {
      item.vlrBaseIpi = 0;
      item.vlrIpi     = 0;
    }
    this.validarQtdControlado(item);
    this._agendarRascunhoImpostos();
  }

  /** Timers de debounce (por item.id) da checagem mensal de produto controlado. */
  private _controladoTimers = new Map<number, ReturnType<typeof setTimeout>>();

  /**
   * Produto controlado (GPL_CONTROLADO='S' em TGFPRO): a quantidade vendida
   * para o mesmo cliente (CPF/CNPJ) é limitada POR MÊS — GPL_CTRL_LIM_PF
   * (CPF) ou GPL_CTRL_LIM_PJ (CNPJ) — somando o que esse cliente já comprou
   * em Pedidos de Venda (TOP 1001, não Orçamento — ver
   * buscarVendasControladasMes no addon) no mês corrente + a quantidade
   * deste item. A VALIDAÇÃO em si roda tanto em Orçamento (TOP 1000) quanto
   * em Pedido de Venda (TOP 1001) — só a fonte da "quantidade já vendida"
   * fica restrita a Pedido de Venda real.
   *
   * Bloqueia salvar() (ver itensControladosBloqueados) — não é confirmável
   * como o aviso de estoque insuficiente.
   */
  /** Limite padrão (fallback) de quantidade mensal pra produto controlado
   *  (GPL_CONTROLADO='S') quando o PRÓPRIO produto não tem um limite
   *  específico configurado em GPL_CTRL_LIM_PF/GPL_CTRL_LIM_PJ (TGFPRO).
   *  Um produto com esses campos preenchidos sempre usa o valor dele —
   *  este fallback só entra quando ficam vazios/nulos. */
  private static readonly LIMITE_CONTROLADO_PADRAO_CPF  = 5;
  private static readonly LIMITE_CONTROLADO_PADRAO_CNPJ = 200;

  validarQtdControlado(item: ItemPedido): void {
    // Reset defensivo: qualquer condição abaixo que não se aplique mais
    // precisa liberar o bloqueio anterior (ex.: trocou de cliente, zerou qtd).
    const limpar = () => { item.controladoBloqueado = false; item.controladoMensagem = undefined; };

    if (!item.controlado || !item.quantidade) { limpar(); return; }
    if (!item.codprodInterno || !this.clienteSelecionado) { limpar(); return; }

    const doc = (this.clienteSelecionado?.docparc ?? '').replace(/\D/g, '');
    const ehCnpj = doc.length === 14;
    const ehCpf  = doc.length === 11;
    if (!ehCpf && !ehCnpj) { limpar(); return; }

    // Limite específico do produto (TGFPRO.GPL_CTRL_LIM_PF/PJ) tem prioridade;
    // sem ele, cai no padrão da empresa (5 CPF / 200 CNPJ).
    const limiteProduto = ehCnpj ? item.ctrlLimPj : item.ctrlLimPf;
    const limite = limiteProduto ?? (ehCnpj
      ? PedidoVendaComponent.LIMITE_CONTROLADO_PADRAO_CNPJ
      : PedidoVendaComponent.LIMITE_CONTROLADO_PADRAO_CPF);

    const tipoDoc = ehCnpj ? 'CNPJ' : 'CPF';

    // O cliente pode ter adicionado o MESMO produto controlado em mais de uma
    // linha do pedido (ex.: 3 + 3 num limite de 5) — o limite é por
    // produto+cliente+mês, não por linha, então soma todas as linhas deste
    // produto no carrinho atual, não só a quantidade desta linha.
    const linhasMesmoProduto = this.itens.filter(i => i.codprodInterno === item.codprodInterno && i.controlado);
    const totalCarrinho = linhasMesmoProduto.reduce((acc, i) => acc + (i.quantidade || 0), 0);

    // Checagem local imediata (sem esperar o backend): mostra o aviso "logo
    // de cara" quando a soma das linhas deste produto já estoura o limite.
    if (totalCarrinho > limite) {
      const msg = linhasMesmoProduto.length > 1
        ? `Produto controlado (${item.codprod || item.codprodInterno}): quantidade máxima mensal para cliente ${tipoDoc} é ${limite}. Total somando as ${linhasMesmoProduto.length} linhas deste produto no pedido: ${totalCarrinho}.`
        : `Produto controlado (${item.codprod || item.codprodInterno}): quantidade máxima mensal para cliente ${tipoDoc} é ${limite}.`;
      linhasMesmoProduto.forEach(i => { i.controladoBloqueado = true; i.controladoMensagem = msg; });
      // Sem banner no topo aqui — a pedido do usuário, o único aviso visual
      // pra esse caso é o modal, aberto pela checagem confirmada do backend
      // (_checarLimiteMensalControlado) logo abaixo. Aqui só marca o bloqueio.
    } else {
      linhasMesmoProduto.forEach(i => { i.controladoBloqueado = false; i.controladoMensagem = undefined; });
    }

    // Checagem completa (debounced): soma com o que esse CPF/CNPJ já
    // comprou desse produto em Pedidos de Venda no mês corrente.
    clearTimeout(this._controladoTimers.get(item.id));
    this._controladoTimers.set(item.id, setTimeout(
      () => this._checarLimiteMensalControlado(item, limite, tipoDoc),
      400
    ));
  }

  /** Evita reabrir o modal de estouro repetidas vezes — uma vez por produto
   *  "em episódio de estouro" (várias linhas do mesmo produto disparariam o
   *  mesmo aviso em cascata sem isso). Removido no callback do modal. */
  private _controladoModalAbertoProduto = new Set<number>();

  private async _checarLimiteMensalControlado(item: ItemPedido, limite: number, tipoDoc: string): Promise<void> {
    // Revalida condições básicas — o estado pode ter mudado durante o debounce
    // (item removido, cliente trocado, produto deixou de ser controlado etc.).
    // Nota: a validação roda em Orçamento e em Pedido de Venda — só a soma de
    // "já vendido" (no backend) fica restrita a Pedido de Venda real.
    if (!item.controlado || !item.quantidade) return;
    if (!item.codprodInterno || !this.clienteSelecionado) return;

    const codprodInterno = item.codprodInterno;

    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarVendasControladasMes(
        codprodInterno,
        Number(this.clienteSelecionado.codparc),
        this.nunotaAtual ?? 0,
      ));
      const body = res?.responseBody ?? res;
      if (body?.sucesso === false) return; // falha na consulta: não bloqueia, só não valida agora

      const vendas: any[] = body?.vendas ?? [];
      const totalMes = Number(body?.totalMes ?? 0);

      // Recalcula na hora (o estado pode ter mudado durante o await) — soma
      // TODAS as linhas deste produto no pedido atual, não só esta.
      const linhasMesmoProduto = this.itens.filter(i => i.codprodInterno === codprodInterno && i.controlado);
      const totalCarrinho = linhasMesmoProduto.reduce((acc, i) => acc + (i.quantidade || 0), 0);
      const totalGeral = totalMes + totalCarrinho;

      if (totalGeral > limite) {
        const notas = vendas.map(v => `Nota ${v.nunota}`).join(', ');
        const mensagem =
          `Produto controlado (${item.codprod || codprodInterno}): limite mensal do cliente ${tipoDoc} é ${limite}. ` +
          (linhasMesmoProduto.length > 1
            ? `Total somando as ${linhasMesmoProduto.length} linhas deste produto no pedido + já vendido no mês: ${totalGeral}.`
            : `Total no mês somando este item: ${totalGeral}.`) +
          (notas ? ` Já vendido este mês em: ${notas}.` : '');

        linhasMesmoProduto.forEach(i => { i.controladoBloqueado = true; i.controladoMensagem = mensagem; });

        // Quantidade máxima total (somando todas as linhas deste produto)
        // que ainda cabe no limite mensal, já descontando o que esse
        // CPF/CNPJ comprou em OUTRAS vendas do mês (confirmado pelo backend).
        const qtdMaxima = Math.max(0, limite - totalMes);

        if (!this._controladoModalAbertoProduto.has(codprodInterno)) {
          this._controladoModalAbertoProduto.add(codprodInterno);
          const mensagemModal = mensagem + (qtdMaxima > 0
            ? ` A(s) quantidade(s) deste produto no pedido será(ão) ajustada(s) para não ultrapassar ${qtdMaxima} no total.`
            : ` Este cliente já atingiu o limite mensal — não é possível vender mais nenhuma unidade deste produto agora.`);

          this._abrirModalAviso(mensagemModal, () => {
            this._ajustarQuantidadesControladoParaLimite(codprodInterno, qtdMaxima);
            this._controladoModalAbertoProduto.delete(codprodInterno);
          });
        }
      } else {
        linhasMesmoProduto.forEach(i => { i.controladoBloqueado = false; i.controladoMensagem = undefined; });
      }
    } catch (err) {
      console.warn('[PedidoVenda] Falha ao checar limite mensal de produto controlado:', err);
    }
  }

  /** Distribui qtdMaxima entre as linhas do produto (na ordem em que aparecem
   *  no pedido) — as primeiras linhas ficam com prioridade. Linhas que
   *  ficariam com quantidade 0 são REMOVIDAS (não deixadas com "0" na grade —
   *  a pedido do usuário, zerar bagunça a visualização) e o foco vai pro
   *  campo PN da linha em branco seguinte, pronto pra digitar um novo item.
   *  Chamado pelo OK do modal de estouro de produto controlado. */
  private _ajustarQuantidadesControladoParaLimite(codprodInterno: number, qtdMaxima: number): void {
    let restante = qtdMaxima;
    const idsParaRemover: number[] = [];
    this.itens
      .filter(i => i.codprodInterno === codprodInterno && i.controlado)
      .forEach(i => {
        const qtd = Math.min(i.quantidade || 0, restante);
        restante -= qtd;
        if (qtd <= 0) {
          idsParaRemover.push(i.id);
        } else {
          i.quantidade = qtd;
          this.calcularTotal(i);
        }
      });

    if (idsParaRemover.length > 0) {
      this.itens = this.itens.filter(i => !idsParaRemover.includes(i.id));
    }
    // Foco pro PN da linha em branco seguinte -- SEMPRE, não só quando uma
    // linha é removida. Ajuste que só REDUZ a quantidade de uma linha (sem
    // zerar nenhuma) é o caso mais comum (ex.: 1+1 estourando um limite de
    // 5 vira 1+4) e antes ficava sem foco nenhum, porque esse bloco só
    // rodava dentro do "if" de remoção.
    this._garantirLinhaEmBranco();
    setTimeout(() => this._focarUltimoPN(), 50);
  }

  get itensPreenchiidos(): number {
    return this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0).length;
  }

  get subtotal(): number {
    // Apenas preços unitários × qty — usado em cálculos de desconto e rateio (sem Core)
    return this.itens.reduce((acc, i) => acc + (i.quantidade * i.precoUnitario), 0);
  }

  get subtotalUsd(): number {
    // Apenas preços USD × qty — usado em cálculos (sem Core)
    return this.itens.reduce((acc, i) => acc + (i.quantidade * (i.precoUsd || 0)), 0);
  }

  /** Subtotal R$ para exibição no footer — inclui Core (soma item.total de cada linha) */
  get subtotalExibicaoBrl(): number {
    return this.itens.reduce((acc, i) => acc + (i.total || 0), 0);
  }

  /** Subtotal U$ para exibição no footer — inclui Core (soma item.totalUsd de cada linha) */
  get subtotalExibicaoUsd(): number {
    return this.itens.reduce((acc, i) => acc + (i.totalUsd || 0), 0);
  }

  // ── Comissões ─────────────────────────────────────────────────
  private _recalcularTitulosComissao(c: ClienteSugestao | null): void {
    if (!c) {
      this.titulosComissaoPosicionados = [];
      this.comissaoInputStartX = this.CLIENTE_INPUT_TEXT_START_PX;
      return;
    }
    if (!this._comissaoCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._comissaoCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._comissaoCanvasCtx;
    if (!ctx) { this.titulosComissaoPosicionados = []; return; }
    ctx.font = this.CLIENTE_INPUT_FONT;
    // Campos e ordem TÊM que bater exatamente com _montarTextoCliente() --
    // é essa função que monta o texto real exibido em comissaoBusca
    // ("Nome   |   Doc   |   COM   |   IE", sem prefixo de codparc).
    const campos = [
      { label: 'CNPJ/CPF',      valor: c.docparc,      display: this.fmtDocumento(c.docparc) },
      { label: 'COM',            valor: c.adCom,         display: c.adCom },
      { label: 'Insc. Estadual', valor: c.inscEstadual,  display: this.fmtIE(c.inscEstadual) },
    ];
    const nomeBase = c.nomeparc || '';
    const larguraNome = ctx.measureText(nomeBase).width;
    this.comissaoInputStartX = this._calcularStartXInput('Parceiro', false, larguraNome);
    let offset = this.comissaoInputStartX + larguraNome;
    const titulos: TituloClientePosicionado[] = [];
    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }
    this.titulosComissaoPosicionados = titulos;
  }

  onComissaoInput(): void {
    this.comissaoUsuarioSelecionado = null;
    this.titulosComissaoPosicionados = [];
    this._comissaoAnterior = null;
    clearTimeout(this._comissaoTimer);
    const termo = this.comissaoBusca.trim();
    if (termo.length < 2) {
      this.comissaoSugestoes = [];
      this.mostrarDropdownComissao = false;
      return;
    }
    this._comissaoTimer = setTimeout(() => this._buscarUsuariosComissao(termo), 350);
  }

  onComissaoFocus(): void {
    if (this.comissaoUsuarioSelecionado) {
      this._comissaoAnterior = this.comissaoUsuarioSelecionado;
      this.comissaoUsuarioSelecionado = null;
      this.comissaoBusca = '';
      this.titulosComissaoPosicionados = [];
      this.comissaoSugestoes = [];
      this.mostrarDropdownComissao = false;
      return;
    }
    const termo = this.comissaoBusca.trim();
    if (termo.length >= 2) {
      this.mostrarDropdownComissao = true;
      if (this.comissaoSugestoes.length === 0) this._buscarUsuariosComissao(termo);
    }
  }

  onComissaoBlur(): void {
    setTimeout(() => {
      this.mostrarDropdownComissao = false;
      if (!this.comissaoUsuarioSelecionado) {
        if (this.comissaoBusca.trim() !== '' && this.comissaoSugestoes.length > 0) {
          // Auto-seleciona o primeiro resultado ao sair sem clicar
          this._comissaoAnterior = null;
          this.selecionarUsuarioComissao(this.comissaoSugestoes[0]);
        } else if (this.comissaoBusca.trim() === '' && this._comissaoAnterior) {
          this.selecionarUsuarioComissao(this._comissaoAnterior);
        } else {
          this.comissaoBusca = '';
          this.comissaoSugestoes = [];
          this.titulosComissaoPosicionados = [];
        }
      }
      this._comissaoAnterior = null;
    }, 200);
  }

  private async _buscarUsuariosComissao(termo: string): Promise<void> {
    this.comissaoCarregando = true;
    this.mostrarDropdownComissao = true;
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarClientePedidoVenda(termo));
      const lista = res?.responseBody?.lista ?? res?.lista ?? [];
      this.comissaoSugestoes = lista.slice(0, 20);
    } catch {
      this.comissaoSugestoes = [];
    } finally {
      this.comissaoCarregando = false;
    }
  }

  selecionarUsuarioComissao(c: ClienteSugestao): void {
    this.comissaoUsuarioSelecionado = c;
    this.comissaoBusca = this._montarTextoCliente(c);
    this._recalcularTitulosComissao(c);
    this.comissaoSugestoes = [];
    this.mostrarDropdownComissao = false;
  }

  adicionarComissao(): void {
    this.comissaoErro = '';
    if (!this.comissaoUsuarioSelecionado) { this.comissaoErro = 'Selecione um parceiro.'; return; }
    if (!this.comissaoPerc || this.comissaoPerc <= 0) { this.comissaoErro = 'Informe o percentual.'; return; }

    // Adiciona apenas em memória — será gravado no banco ao salvar o pedido
    this.comissoes.push({
      codpco:       0,   // 0 = ainda não salvo no banco
      codparc:      Number(this.comissaoUsuarioSelecionado.codparc),
      nomeparc:     this.comissaoUsuarioSelecionado.nomeparc,
      perccomissao: this.comissaoPerc,
    });
    this.comissaoBusca = '';
    this.comissaoUsuarioSelecionado = null;
    this.comissaoPerc = null;
    this.titulosComissaoPosicionados = [];
  }

  async removerComissao(codpco: number): Promise<void> {
    if (codpco > 0) {
      // Já está no banco — deletar
      try {
        await firstValueFrom(this.sankhyaGateway.removerComissaoPedido(codpco));
      } catch { /* silencioso */ }
    }
    // Sempre remove da lista local (seja novo ou do banco)
    this.comissoes = this.comissoes.filter(c => c.codpco !== codpco);
  }

  private async _salvarComissoesPendentes(nunota: number): Promise<void> {
    const novas = this.comissoes.filter(c => c.codpco === 0);
    for (const c of novas) {
      try {
        const res: any = await firstValueFrom(
          this.sankhyaGateway.adicionarComissaoPedido(nunota, c.codparc, c.perccomissao)
        );
        const body = res?.responseBody ?? res;
        if (body?.sucesso) {
          c.codpco = Number(body.codpco); // atualiza com PK real — impede re-gravação
        }
      } catch { /* silencioso — não bloqueia o fluxo */ }
    }
  }

  async _carregarComissoes(nunota: number): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.listarComissoesPedido(nunota));
      const body = res?.responseBody ?? res;
      this.comissoes = (body?.lista ?? []).map((c: any) => ({
        codpco:       Number(c.codpco),
        codparc:      Number(c.codparc),  // CODPARC = parceiro da comissão
        nomeparc:     c.nomeparc ?? '',
        perccomissao: Number(c.perccomissao),
        datacriacao:  c.datacriacao ?? '',
      }));
    } catch { this.comissoes = []; }
  }

  // Valor calculado da comissão em R$ (sobre o Total do Pedido)
  vlrComissaoBrl(perc: number): number {
    return parseFloat((this.totalPedido * perc / 100).toFixed(2));
  }

  // Valor em U$ (sobre o Total U$)
  vlrComissaoUsd(perc: number): number {
    return parseFloat((this.totalPedidoUsd * perc / 100).toFixed(2));
  }

  get totalPercComissao(): number {
    return this.comissoes.reduce((a, c) => a + (c.perccomissao || 0), 0);
  }

  get totalVlrComissaoBrl(): number {
    return this.comissoes.reduce((a, c) => a + this.vlrComissaoBrl(c.perccomissao), 0);
  }

  get totalVlrComissaoUsd(): number {
    return this.comissoes.reduce((a, c) => a + this.vlrComissaoUsd(c.perccomissao), 0);
  }

  /** Bloqueia digitar um segundo "-" nos campos Desc\Acrs Geral (%, R$, U$) —
   *  esses campos aceitam negativo (acréscimo) mas o input type="number" do
   *  browser não impede "--5", só invalida o valor silenciosamente.
   *  Só olha se o valor atual JÁ tem um "-" — não usa selectionStart porque
   *  <input type="number"> não suporta essa API (retorna null em qualquer
   *  navegador), e null !== 0 fazia a checagem bloquear até o PRIMEIRO "-"
   *  digitado, quebrando o acréscimo por completo. */
  bloquearSinalDuplicado(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    if (event.key === '-' && input.value.includes('-')) {
      event.preventDefault();
    }
  }

  /** Mesma proteção do bloquearSinalDuplicado, mas para colar texto (Ctrl+V) —
   *  considera também um "-" que já esteja no valor atual do campo, não só
   *  os que vêm dentro do texto colado. */
  bloquearColagemSinalDuplicado(event: ClipboardEvent): void {
    const input = event.target as HTMLInputElement;
    const texto = event.clipboardData?.getData('text') ?? '';
    const totalTracos = (input.value.match(/-/g) || []).length + (texto.match(/-/g) || []).length;
    if (totalTracos > 1) {
      event.preventDefault();
    }
  }

  /** Modalidades de CIF/FOB (campo nativo Sankhya CIF_FOB, mesmas 6 opções
   *  usadas na NF-e: CIF/Remetente, FOB/Destinatário, Terceiros, Próprio
   *  Remetente, Próprio Destinatário, Sem Ocorrência de Transporte) que
   *  travam e zeram o Vlr. Frete — regra de negócio pedida explicitamente:
   *  se quem paga o frete é o próprio destinatário direto à transportadora
   *  (ou não há transporte cobrado), não faz sentido a nossa nota carregar
   *  um valor de frete. Casamos pelo TEXTO da opção (não um código fixo)
   *  porque o combo nativo varia por instalação do Sankhya — mesmo padrão
   *  defensivo já usado alhures nesta tela (ex.: FABNAC/ALTCOT).
   *  "Transp. Próprio Remetente" foi movido pro grupo bloqueado a pedido do
   *  usuário (correção do documento original, que tinha colocado no grupo
   *  liberado) — usa 'PRÓPRIO'+'REMETENTE' juntos pra não pegar o CIF puro
   *  ("Contratação do Frete por conta do Remetente"), que TEM que continuar
   *  liberado (regra principal do documento). */
  private static readonly CIFFOB_KEYWORDS_BLOQUEIA = ['FOB', 'DESTINAT', 'SEM OCORR', 'SEM FRETE'];

  /** true quando a modalidade de CIF/FOB selecionada exige travar (e zerar)
   *  o Vlr. Frete: quando nenhuma modalidade foi escolhida ainda
   *  ("Selecione" — não faz sentido liberar cobrança de frete sem saber a
   *  modalidade), quando bate uma das palavras-chave de bloqueio, ou quando
   *  é "Transporte Próprio por conta do Remetente" (ver comentário acima).
   *  Se a opção escolhida não bater com nada disso, fica liberado por
   *  padrão (não trava por engano num dicionário customizado). */
  get vlrFreteBloqueado(): boolean {
    if (!this.cifFob) return true;
    const label = (this.cifFobOpcoes.find(o => o.valor === this.cifFob)?.opcao ?? '').toUpperCase();
    if (!label) return true;
    if (PedidoVendaComponent.CIFFOB_KEYWORDS_BLOQUEIA.some(k => label.includes(k))) return true;
    const ehProprio = label.includes('PRÓPRIO') || label.includes('PROPRIO');
    const ehRemetente = label.includes('REMETENTE');
    return ehProprio && ehRemetente;
  }

  /** Ao trocar CIF/FOB, ajusta os dois campos dependentes:
   *  1) Vlr. Frete: se a nova modalidade travar (ver vlrFreteBloqueado —
   *     inclui também "Selecione"/vazio e Transp. Próprio Remetente), zera
   *     na hora — não dá pra deixar um valor antigo "esquecido" no campo já
   *     desabilitado.
   *  2) Tipo do Frete: usa o MESMO agrupamento liberado/bloqueado da trava
   *     acima. Modalidade LIBERADA (CIF, Terceiros — casos em que SOMOS
   *     responsáveis pelo frete e podemos cobrá-lo) → "Incluso" (soma no
   *     Total do Pedido). Modalidade BLOQUEADA (Selecione/vazio, FOB,
   *     Transp. Próprio Remetente, Transp. Próprio Destinatário, Sem
   *     Ocorrência de Transporte) → "Extra Nota" — na prática o valor já
   *     fica sempre zero nesses casos (não afeta o total de qualquer
   *     forma), isso só evita deixar o campo em branco; a opção "Incluso"
   *     também fica desabilitada no combo Tipo do Frete enquanto estiver
   *     bloqueado (ver HTML). Se a opção "Incluso"/"Extra Nota" não existir
   *     no dicionário TIPFRETE desse Sankhya, não altera nada. */
  onCifFobChange(): void {
    if (this.vlrFreteBloqueado) {
      this.vlrFrete = 0;
    }
    // CIF/FOB voltou pro "Selecione" (vazio) — Tipo do Frete acompanha e
    // também volta pro "Selecione", em vez de cair em "Extra Nota". Pedido
    // do usuário: sem modalidade escolhida, não faz sentido nenhuma opção
    // de Tipo do Frete estar marcada.
    if (!this.cifFob) {
      this.tipFrete = '';
      return;
    }
    const alvo = this.vlrFreteBloqueado ? 'EXTRA' : 'INCLUS';
    const opcaoTipFrete = this.tipFreteOpcoes.find(o => o.opcao.toUpperCase().includes(alvo));
    if (opcaoTipFrete) this.tipFrete = opcaoTipFrete.valor;
  }

  /** Verdadeiro quando o Tipo do Frete atual é "Incluso" — nesse caso o Vlr.
   *  Frete soma no Total do Pedido (ver getter totalPedido). Quando é "Extra
   *  Nota" (ou nenhuma opção escolhida), o frete é cobrado à parte do
   *  cliente e NÃO soma no total exibido. */
  get vlrFreteIncluso(): boolean {
    const label = (this.tipFreteOpcoes.find(o => o.valor === this.tipFrete)?.opcao ?? '').toUpperCase();
    return label.includes('INCLUS');
  }

  // Sync bidirecional: Desconto Geral valor ↔ Percentual Geral
  onDescGeralVlrChange(): void {
    // Edição manual: vlrDescGeral passa a ser funcional (não é mais espelho)
    this._vlrDescGeralEhEspelho = false;
    const base = this.subtotal - this.totalDesconto + this.totalAcrescDesc;
    if (base > 0) {
      this.percDescGeral = parseFloat(((this.vlrDescGeral || 0) / base * 100).toFixed(2));
    }
    // Valida: desconto geral não pode ultrapassar o subtotal líquido (Core não é descontável)
    const maxDesc = parseFloat((this.subtotal - this.totalDesconto + this.totalAcrescDesc).toFixed(2));
    if ((this.vlrDescGeral || 0) > maxDesc) {
      this._abrirModalAviso(
        `O Desconto Geral não pode ultrapassar R$ ${this.formatarMoeda(maxDesc)} (limite: subtotal sem core). Ajustado para o máximo.`
      );
      this.vlrDescGeral  = maxDesc > 0 ? maxDesc : 0;
      this.percDescGeral = base > 0 ? parseFloat(((this.vlrDescGeral || 0) / base * 100).toFixed(2)) : null;
    }
  }

  onDescGeralPercChange(): void {
    // Edição manual: vlrDescGeral passa a ser funcional (não é mais espelho)
    this._vlrDescGeralEhEspelho = false;
    const base = this.subtotal - this.totalDesconto + this.totalAcrescDesc;
    if (base > 0) {
      this.vlrDescGeral = parseFloat((base * (this.percDescGeral || 0) / 100).toFixed(2));
    }
    // Valida: % não pode ultrapassar o subtotal líquido (Core não é descontável)
    const maxDesc = parseFloat((this.subtotal - this.totalDesconto + this.totalAcrescDesc).toFixed(2));
    if ((this.vlrDescGeral || 0) > maxDesc) {
      const maxPerc = base > 0 ? parseFloat((maxDesc / base * 100).toFixed(2)) : 0;
      this._abrirModalAviso(
        `O Percentual Geral não pode resultar em desconto acima de R$ ${this.formatarMoeda(maxDesc)} (limite: subtotal sem core). Ajustado para ${this.formatarDecimal(maxPerc)}%.`
      );
      this.vlrDescGeral  = maxDesc > 0 ? maxDesc : 0;
      this.percDescGeral = maxPerc;
    }
  }

  /**
   * Ao sair dos campos Desc\Acrs. Geral (%, R$ ou U$), rateia o desconto/acréscimo entre os itens.
   * Mesma lógica do onTotalPedidoBlur, mas partindo do vlrDescGeral já definido.
   */
  onDescGeralBlur(): void {
    const descGeral = this.vlrDescGeral || 0;

    // Se zerou, limpa descontos/acréscimos em todos os itens
    if (descGeral === 0) {
      this.itens.forEach(item => {
        if ((item.vlrDesc || 0) !== 0 || (item.desconto || 0) !== 0) {
          item.vlrDesc      = 0;
          item.desconto     = 0;
          item.vlrDescStr   = '';
          item.vlrAcrescDesc = 0;
          this.calcularTotal(item);
        }
      });
      this.vlrDescGeral  = null;
      this.percDescGeral = null;
      this._vlrDescGeralEhEspelho = false;
      return;
    }

    // totalDesejado = total resultante do desconto geral (Core já está em subtotal)
    const totalDesejado = parseFloat(
      (this.subtotal - descGeral + this.totalIpi + this.totalIcmsst).toFixed(2)
    );

    // Sempre substitui (zera) o desconto/acréscimo anterior de cada item antes
    // de aplicar o novo rateio — a pedido do usuário, sem perguntar
    // "somar ou substituir" (o modal de conflito confundia o fluxo).
    this.aplicarRateioDesconto(totalDesejado, false);
  }

  // ── Total do Item (Subtotal R$) editável — cálculo reverso de desconto ──
  onTotalItemFocus(item: ItemPedido): void {
    item.totalItemStr = '';
  }

  /** Se o campo Qtd ficar vazio/zerado ao sair do campo, assume 1 por padrão
   *  (pedido do usuário — evita item com quantidade em branco). */
  onQtdBlur(item: ItemPedido): void {
    if (!item.quantidade || item.quantidade <= 0) {
      item.quantidade = 1;
      this.calcularTotal(item);
    }
  }

  onTotalItemBlur(item: ItemPedido): void {
    const raw = (item.totalItemStr ?? '').replace(',', '.');
    const totalDesejado = parseFloat(raw);
    if (isNaN(totalDesejado) || totalDesejado <= 0) { item.totalItemStr = ''; return; }
    if (item.quantidade <= 0) { item.totalItemStr = ''; return; }

    const base = item.quantidade * item.precoUnitario;
    if (base <= 0) { item.totalItemStr = ''; return; }

    // Sempre substitui (zera) o desconto/acréscimo anterior do item — a
    // pedido do usuário, sem perguntar "somar ou substituir".
    // novoVlrDesc > 0 = desconto (totalDesejado < base); < 0 = acréscimo (totalDesejado > base)
    const novoVlrDesc = parseFloat((base - totalDesejado).toFixed(2));

    item.vlrDesc = novoVlrDesc;
    item.vlrAcrescDesc = 0;

    item.desconto = base > 0
      ? parseFloat((item.vlrDesc / base * 100).toFixed(2))
      : 0;
    item.vlrDescStr = item.vlrDesc !== 0
      ? (item.vlrDesc < 0
          ? '-' + this.formatarDecimal(Math.abs(item.vlrDesc))
          : this.formatarDecimal(item.vlrDesc))
      : '';

    // calcularTotal: total = base - vlrDesc = totalDesejado ✓
    // preservarVlrDesc=true: mesmo motivo do onDescontoVlrChange — vlrDesc já
    // é o valor exato calculado acima (base - totalDesejado); sem isso,
    // calcularTotal re-derivava vlrDesc a partir do desconto% arredondado,
    // fazendo o total real ficar um pouco diferente do totalDesejado digitado.
    this.calcularTotal(item, true);
    item.totalItemStr = '';

    // Atualiza espelho geral após alterar desconto de um item
    this._atualizarEspelhoDescGeral();
  }

  onTotalItemEnter(item: ItemPedido, event: Event): void {
    (event.target as HTMLInputElement).blur();
  }

  // ── Total do Pedido editável — rateia desconto entre todos os itens ──
  onTotalPedidoFocus(): void {
    this.totalPedidoDesejadoStr = '';
  }

  onTotalPedidoBlur(): void {
    const raw = this.totalPedidoDesejadoStr.replace(',', '.');
    const totalDesejado = parseFloat(raw);
    if (isNaN(totalDesejado) || totalDesejado <= 0) {
      this.totalPedidoDesejadoStr = '';
      return;
    }

    // Validação: total não pode ficar abaixo do Core + impostos (desconto só no Vl. Unit.)
    const minimoPermitido = parseFloat((this.totalCoreBrl + this.totalIpi + this.totalIcmsst).toFixed(2));
    if (minimoPermitido > 0 && totalDesejado < minimoPermitido) {
      this._abrirModalAviso(
        `O Total do Pedido não pode ficar abaixo do valor total do CORE (mínimo: R$ ${this.formatarMoeda(minimoPermitido)}). ` +
        `Será aplicado 100% de desconto sobre os preços unitários.`
      );
      this.aplicarRateioDesconto(minimoPermitido, false);
      this.totalPedidoDesejadoStr = '';
      return;
    }

    // Sempre substitui (zera) o desconto/acréscimo anterior de cada item antes
    // de aplicar o novo rateio — a pedido do usuário, sem perguntar
    // "somar ou substituir" (o modal de conflito confundia o fluxo).
    this.aplicarRateioDesconto(totalDesejado, false);
    this.totalPedidoDesejadoStr = '';
  }

  onTotalPedidoEnter(event: Event): void {
    (event.target as HTMLInputElement).blur();
  }

  /**
   * Atualiza vlrDescGeral e percDescGeral como espelho da soma dos descontos por item.
   * _vlrDescGeralEhEspelho=true → totalPedido não subtrai vlrDescGeral (evita double-count).
   * Limpa o espelho se não houver nenhum desconto por item.
   */
  private _atualizarEspelhoDescGeral(): void {
    const totalDesc = this.totalDesconto;   // sum(max(vlrDesc,0))
    const totalAcre = this.totalAcrescDesc; // sum(max(-vlrDesc,0))
    const netDesc   = totalDesc - totalAcre; // pode ser negativo (acréscimo líquido)

    if (netDesc === 0) {
      // Sem desconto líquido: limpa espelho se estava ativo
      if (this._vlrDescGeralEhEspelho) {
        this._vlrDescGeralEhEspelho = false;
        this.vlrDescGeral  = null;
        this.percDescGeral = null;
      }
      return;
    }

    this._vlrDescGeralEhEspelho = true;
    // Desconto Geral mostra o total (positivo = desconto, negativo = acréscimo)
    this.vlrDescGeral = parseFloat(netDesc.toFixed(2));
    // Percentual calculado sobre o valor unitário total (sem Core) — média ponderada real
    const baseUnitaria = this.itens.reduce((acc, i) => acc + i.quantidade * i.precoUnitario, 0);
    this.percDescGeral = baseUnitaria > 0
      ? parseFloat((netDesc / baseUnitaria * 100).toFixed(2))
      : null;
  }

  aplicarRateioDesconto(totalDesejado: number, manterAjuste = false): void {
    const itensProdutos = this.itens.filter(
      i => i.codprodInterno && i.codprodInterno > 0 && i.precoUnitario > 0
    );
    if (itensProdutos.length === 0) return;

    // baseTotal = sum(precoUnitario × qty) — Core já embutido em precoUnitario quando ativo
    const baseTotal = itensProdutos.reduce(
      (acc, i) => acc + i.quantidade * i.precoUnitario, 0
    );
    if (baseTotal <= 0) return;

    // Extras fixos = apenas IPI e ICMSST (Core já está em precoUnitario, não é "extra")
    const extras         = this.totalIpi + this.totalIcmsst;
    const totalParaItens = parseFloat((totalDesejado - extras).toFixed(2));

    // Desconto total necessário sobre os preços unitários (positivo = desconto, negativo = acréscimo)
    const descontoTotal = parseFloat((baseTotal - totalParaItens).toFixed(2));

    // ── Rateio por item (vlrDesc funcional) ────────────────────────────────
    let acumulado = 0;

    itensProdutos.forEach((item, idx) => {
      const base      = item.quantidade * item.precoUnitario;
      const proporcao = base / baseTotal;

      // Parcela do desconto para este item (último absorve arredondamento)
      let vlrDescItem: number;
      if (idx === itensProdutos.length - 1) {
        vlrDescItem = parseFloat((descontoTotal - acumulado).toFixed(2));
      } else {
        vlrDescItem = parseFloat((descontoTotal * proporcao).toFixed(2));
        acumulado  += vlrDescItem;
      }

      // somar=true → acumula ao vlrDesc existente; false → substitui
      item.vlrDesc = manterAjuste
        ? parseFloat(((item.vlrDesc || 0) + vlrDescItem).toFixed(2))
        : vlrDescItem;
      item.vlrAcrescDesc = 0;

      item.desconto = base > 0
        ? parseFloat((item.vlrDesc / base * 100).toFixed(2))
        : 0;
      item.vlrDescStr = item.vlrDesc !== 0
        ? (item.vlrDesc < 0
            ? '-' + this.formatarDecimal(Math.abs(item.vlrDesc))
            : this.formatarDecimal(item.vlrDesc))
        : '';

      // preservarVlrDesc=true → mantém o vlrDesc exato do rateio, evita re-arredondar pelo %
      this.calcularTotal(item, true);
      item.totalItemStr = '';
    });

    // ── Desconto Geral como espelho da soma dos itens ───────────────────────
    // _vlrDescGeralEhEspelho=true → totalPedido ignora vlrDescGeral (não double-conta).
    // O campo Percentual Geral % e Desconto Geral R$ mostram o total rateado.
    this._vlrDescGeralEhEspelho = true;
    // descontoTotal > 0 = desconto, < 0 = acréscimo — usa sempre o valor calculado do rateio
    this.vlrDescGeral  = descontoTotal !== 0 ? parseFloat(descontoTotal.toFixed(2)) : null;
    this.percDescGeral = baseTotal > 0 && descontoTotal !== 0
      ? parseFloat((descontoTotal / baseTotal * 100).toFixed(2))
      : null;
  }

  get totalDesconto(): number {
    // Soma apenas descontos positivos (exclui acréscimos negativos)
    return this.itens.reduce((acc, i) => acc + Math.max(i.vlrDesc || 0, 0), 0);
  }

  get totalAcrescDesc(): number {
    // Acréscimo via vlrDesc negativo + vlrAcrescDesc legacy
    return this.itens.reduce(
      (acc, i) => acc + Math.max(-(i.vlrDesc || 0), 0) + (i.vlrAcrescDesc || 0), 0
    );
  }

  get totalDescontoUsd(): number {
    // desconto negativo = acréscimo → resultado negativo → subtração vira soma em totalPedidoUsd
    return this.itens.reduce((acc, i) => {
      const baseUsd = i.quantidade * (i.precoUsd || 0);
      return acc + (baseUsd * (i.desconto || 0) / 100);
    }, 0);
  }

  get totalCoreUsd(): number {
    return this.itens.reduce((acc, i) => acc + (i.totalCoreUsd ?? 0), 0);
  }

  get totalCoreBrl(): number {
    return this.itens.reduce((acc, i) => acc + (i.totalCoreBrl ?? 0), 0);
  }

  get totalPedido(): number {
    // Quando vlrDescGeral é espelho de totalDesconto (rateio por item), não subtrai novamente.
    const descGeral = this._vlrDescGeralEhEspelho ? 0 : (this.vlrDescGeral || 0);
    // Core já está embutido em precoUnitario (e portanto em subtotal) — não somar novamente
    return this.subtotal
      - this.totalDesconto
      + this.totalAcrescDesc
      - descGeral
      + this.totalIpi
      + this.totalIcmsst
      // Vlr. Frete só soma no Total quando o Tipo do Frete é "Incluso" — em
      // "Extra Nota" o frete é cobrado à parte do cliente, fora da nota (ver
      // onCifFobChange/vlrFreteIncluso).
      + (this.vlrFreteIncluso ? (this.vlrFrete || 0) : 0)
      + (this.vlrOutros || 0);
  }

  get totalIpi(): number {
    return this.itens.reduce((acc, i) => acc + (i.vlrIpi || 0), 0);
  }

  get totalIcmsst(): number {
    return this.itens.reduce((acc, i) => acc + (i.vlrIcmsst || 0), 0);
  }

  /** Mostra painel fiscal em edição sempre que houver itens com codprodInterno */
  get temImpostosFiscais(): boolean {
    return this.modoEdicao && this.itens.some(i => i.codprodInterno && i.codprodInterno > 0);
  }

  /** Todos os itens com produto (para o painel fiscal em edição) */
  get itensFiscais(): ItemPedido[] {
    return this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
  }

  get totalPedidoUsd(): number {
    const cambio = this.cotacaoValorNumerico || 1;
    // IPI e ST vêm em BRL do TGFDIN — converter para USD pela cotação ativa
    const impostosBrl = this.totalIpi + this.totalIcmsst;
    // Espelho: quando vlrDescGeral é reflexo dos descontos por item, não subtrai novamente em USD
    const descGeralUsd = this._vlrDescGeralEhEspelho ? 0 : (this.vlrDescGeral || 0) / cambio;
    // Frete é lançado em R$ — converte pela cotação ativa, igual aos impostos.
    // Só entra no total quando o Tipo do Frete é "Incluso" (mesma regra do
    // totalPedido em R$ — ver vlrFreteIncluso).
    const freteUsd = this.vlrFreteIncluso ? (this.vlrFrete || 0) / cambio : 0;
    // Core USD rastreado em totalCoreUsd mas não somado aqui (está em precoUnitario BRL)
    return this.subtotalUsd
      - this.totalDescontoUsd
      - descGeralUsd
      + (impostosBrl / cambio)
      + freteUsd;
  }

  formatarMoeda(valor: number): string {
    return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formatarDecimal(valor: number): string {
    return (valor ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /**
   * Converte Valor Moeda → Valor R$ na tela de Busca de Peças (F3), principal
   * e alternativos. Sempre multiplica pela cotação do dia — a não-conversão
   * por "Fabricante Nacional" foi removida daqui (ver Fabricante 70 no
   * onPrecoUnitarioChange, que trata o caso análogo só nos Itens do Pedido).
   */
  valorEmReaisBusca(vlrVenda: number | null | undefined, _origemNacional: boolean | null | undefined, cotacao: number): number | null {
    if (vlrVenda == null) return null;
    return cotacao > 0 ? vlrVenda * cotacao : null;
  }

  /** Valor unitário do IPI (R$) do produto na Busca de Peças — preço R$ × alíquota IPI
   *  (a alíquota já vem no resultado da busca, via JOIN com TGFIPI no backend). */
  vlrIpiUnitarioBusca(p: any, cotacao: number): number {
    const precoBrl = this.valorEmReaisBusca(p?.vlrVenda, p?.origemNacional, cotacao);
    const aliq = parseFloat(String(p?.aliqIpi ?? p?.aliq_ipi ?? '0').replace(',', '.')) || 0;
    return precoBrl != null && aliq > 0 ? parseFloat((precoBrl * aliq / 100).toFixed(2)) : 0;
  }

  /** Valor Moeda (U$) já somado o IPI unitário (IPI é sempre em R$, convertido pela cotação). */
  valorMoedaComIpiBusca(p: any, cotacao: number): number | null {
    if (p?.vlrVenda == null) return null;
    const ipiUsd = cotacao > 0 ? this.vlrIpiUnitarioBusca(p, cotacao) / cotacao : 0;
    return parseFloat((p.vlrVenda + ipiUsd).toFixed(2));
  }

  /** Valor R$ já somado o IPI unitário. */
  valorReaisComIpiBusca(p: any, cotacao: number): number | null {
    const precoBrl = this.valorEmReaisBusca(p?.vlrVenda, p?.origemNacional, cotacao);
    if (precoBrl == null) return null;
    return parseFloat((precoBrl + this.vlrIpiUnitarioBusca(p, cotacao)).toFixed(2));
  }

  // ── Ordenação da tabela de resultados (Busca de Peças / F3) ──────────────
  buscaPecasOrdenarCampo: string | null = null;
  buscaPecasOrdemAsc = true;

  // ── Filtro por coluna (em tela, sobre os resultados já carregados) ───────
  filtrosBusca: { [campo: string]: string } = {};

  /** Resultados exibidos na tabela: buscaPecasResultados após aplicar os
   *  filtros de coluna ativos em filtrosBusca. Não muta buscaPecasResultados
   *  (a ordenação continua funcionando normalmente sobre a lista completa). */
  get buscaPecasResultadosExibidos(): any[] {
    const campos = Object.keys(this.filtrosBusca).filter(c => (this.filtrosBusca[c] || '').trim().length > 0);
    if (campos.length === 0) return this.buscaPecasResultados;
    return this.buscaPecasResultados.filter(p => campos.every(campo => {
      const termo = this.filtrosBusca[campo].trim().toLowerCase();
      const valor = this._valorOrdenacaoBusca(p, campo);
      return String(valor ?? '').toLowerCase().includes(termo);
    }));
  }

  limparFiltroBusca(campo: string, event?: Event): void {
    event?.stopPropagation();
    delete this.filtrosBusca[campo];
  }

  temFiltroBusca(campo: string): boolean {
    return !!(this.filtrosBusca[campo] || '').trim();
  }

  /** Coluna cujo campo de filtro está aberto para digitação (inline no
   *  próprio cabeçalho, ao clicar no nome da coluna) — só uma por vez. */
  colunaFiltroAberta: string | null = null;

  toggleFiltroBusca(campo: string, event?: Event): void {
    event?.stopPropagation();
    this.colunaFiltroAberta = this.colunaFiltroAberta === campo ? null : campo;
    if (this.colunaFiltroAberta === campo) {
      setTimeout(() => document.getElementById('filtro-busca-' + campo)?.focus(), 0);
    }
  }

  /** Fecha o campo de digitação ao perder o foco/Enter — o filtro
   *  continua aplicado normalmente, só o input inline é que recolhe. */
  fecharFiltroBusca(): void {
    this.colunaFiltroAberta = null;
  }

  ordenarBuscaPecas(campo: string): void {
    if (this.buscaPecasOrdenarCampo === campo) {
      this.buscaPecasOrdemAsc = !this.buscaPecasOrdemAsc;
    } else {
      this.buscaPecasOrdenarCampo = campo;
      this.buscaPecasOrdemAsc = true;
    }
    const dir = this.buscaPecasOrdemAsc ? 1 : -1;
    this.buscaPecasResultados = [...this.buscaPecasResultados].sort((a, b) => {
      const va = this._valorOrdenacaoBusca(a, campo);
      const vb = this._valorOrdenacaoBusca(b, campo);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;  // sem valor sempre por último, nas duas direções
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  private _valorOrdenacaoBusca(p: any, campo: string): string | number | null {
    switch (campo) {
      case 'pn':          return String(p.refforn ?? p.referencia ?? p.codprod ?? '');
      case 'cd':           return String(p.condicao ?? '');
      case 'descricao':    return String(p.descricao ?? '');
      case 'alternativo':  return String(p.alternativo ?? '');
      case 'un':           return String(p.codvol ?? '');
      case 'estoque':      return p.estoque ?? 0;
      case 'valorMoedaIpi': return this.valorMoedaComIpiBusca(p, this.cotacaoValorNumerico) ?? null;
      case 'valorReaisIpi': return this.valorReaisComIpiBusca(p, this.cotacaoValorNumerico) ?? null;
      case 'vlrIpi':        return this.vlrIpiUnitarioBusca(p, this.cotacaoValorNumerico);
      case 'fabricante':    return String(p.marca ?? '');
      case 'dataUltAtual':  return this._dataBrParaOrdenacao(p.dataUltAtualPreco);
      case 'limiteDias':    return p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : null;
      case 'codigo':        return p.codprod ?? null;
      default:              return null;
    }
  }

  /** Converte "dd/MM/yyyy" num número comparável (yyyyMMdd) pra ordenar por data
   *  sem depender de new Date(str), que é ambíguo entre browsers/locales. */
  private _dataBrParaOrdenacao(dataBr: string | null | undefined): number | null {
    if (!dataBr) return null;
    const partes = dataBr.split('/');
    if (partes.length !== 3) return null;
    const dd = parseInt(partes[0], 10), mm = parseInt(partes[1], 10), yyyy = parseInt(partes[2], 10);
    if (!dd || !mm || !yyyy) return null;
    return yyyy * 10000 + mm * 100 + dd;
  }

  /**
   * Preço do item SEM o Core embutido — usado para o destaque "Sem Preço" na tabela.
   * item.precoUsd já vem somado com o Core quando ativo (ver buscarPrecoExc), então
   * subtraímos aqui para não confundir "só tem valor de Core" com "tem preço".
   */
  precoBaseItem(item: ItemPedido): number {
    const core = item.controlaCore ? (item.vlrCore || 0) : 0;
    return (item.precoUsd || 0) - core;
  }

  // Chamado enquanto o usuário digita — atualiza cálculos sem reformatar o texto
  onPrecoUsdChange(item: ItemPedido): void {
    const raw = (item.precoUsdStr ?? '').replace(',', '.');
    const num = parseFloat(raw);
    if (!isNaN(num) && num >= 0) {
      item.precoUsd = num;
      const taxa = this.cotacaoValorNumerico;
      if (taxa > 0) {
        item.precoUnitario = parseFloat((num * taxa).toFixed(2));
      }
      this.calcularTotal(item);
    }
  }

  // Chamado ao sair do campo — formata o valor exibido
  onPrecoUsdBlur(item: ItemPedido): void {
    item.precoUsdStr = item.precoUsd > 0 ? this.formatarDecimal(item.precoUsd) : '';
  }

  // ── Fabricante 70: Vl. Unit. R$ é o campo mestre — calcula o U$ de forma
  // inversa (R$ ÷ cotação do dia), ao contrário do fluxo normal acima.
  onPrecoUnitarioChange(item: ItemPedido): void {
    const raw = (item.precoUnitarioStr ?? '').replace(',', '.');
    const num = parseFloat(raw);
    if (!isNaN(num) && num >= 0) {
      item.precoUnitario = num;
      const cotacao = this.cotacaoValorNumerico;
      if (cotacao > 0) {
        item.precoUsd    = parseFloat((num / cotacao).toFixed(2));
        item.precoUsdStr = item.precoUsd > 0 ? this.formatarDecimal(item.precoUsd) : '';
      }
      this.calcularTotal(item);
    }
  }

  onPrecoUnitarioBlur(item: ItemPedido): void {
    item.precoUnitarioStr = item.precoUnitario > 0 ? this.formatarDecimal(item.precoUnitario) : '';
  }

  // ── Alerta ─────────────────────────────────────────────────
  abrirAlerta(mensagem: string, tipo: 'sucesso' | 'erro' | 'aviso'): void {
    this.alerta = { mensagem, tipo };
    setTimeout(() => this.alerta = null, 5000);
  }

  /** Vendedor precisa ser um código válido -- "0" é o registro fictício
   *  "<SEM VENDEDOR>" do Sankhya e não conta como preenchido. */
  get vendedorValido(): boolean {
    const codigo = String(this.codVendLogado ?? '').trim();
    return codigo !== '' && codigo !== '0';
  }

  /** Idem pro Tipo Negociação -- "0" é "<SEM TIPO DE VENDA>". */
  get tipoNegociacaoValido(): boolean {
    const codigo = String(this.tipoNegociacaoSelecionado ?? '').trim();
    return codigo !== '' && codigo !== '0';
  }

  get formularioValido(): boolean {
    return !!this.clienteSelecionado && !!this.tipoOperacao && !!this.dataEmissao && !!this.dtNegociacao
      && this.vendedorValido && this.tipoNegociacaoValido;
  }

  // ── Confirmação de estoque insuficiente ────────────────────
  confirmacaoEstoqueAberta = false;
  confirmacaoEstoqueItens: { pn: string; descricao: string; qtd: number; estoque: number; unidade: string }[] = [];
  private _salvarForcado = false;

  /** Snapshot (JSON) do payload financeiro do pedido (cliente, forma de
   *  negociação, itens, frete, desconto...) capturado logo após carregar
   *  para edição — usado só pelo fluxo de "Finalizar Venda" (ver
   *  forcarFinalizarAoSalvar) pra decidir se basta um UPDATE isolado de
   *  GPL_STATUS ou se algo financeiro mudou e precisa da gravação completa. */
  private _snapshotFinanceiroCarregado: string | null = null;

  /** Monta o mesmo payload de _montarPayloadPedido, mas sem o gplStatus
   *  (que estamos prestes a mudar de propósito) — usado só pra comparação
   *  de "mudou algo financeiro?" no fluxo de Finalizar Venda. */
  private _payloadFinanceiroComparavel(itensValidos: ItemPedido[]): string {
    const payload = this._montarPayloadPedido(itensValidos);
    delete payload.cabecalho.gplStatus;
    return JSON.stringify(payload);
  }

  /** Monta o payload de gravação (cabeçalho + itens) a partir do estado atual
   *  do formulário — usado tanto pelo salvar() explícito do usuário quanto
   *  pela sincronização silenciosa do rascunho de impostos. */
  private _montarPayloadPedido(itensValidos: ItemPedido[]): any {
    return {
      cabecalho: {
        // CODEMP REAL sempre — TGFCAB.CODEMP é FK pra TSIEMP nativa, não existe
        // linha lá pro "código" de uma empresa virtual (8/9/10). empresaState.codEmpReal
        // já traduz: empresa virtual selecionada → CODEMP real por trás dela; empresa
        // real selecionada → ela mesma. A segregação por filial fica em
        // GPL_EMPRESA_VIRTUAL (gravado à parte, ver sincronizarEmpresaVirtual no addon).
        codEmp:       Number(this.empresaState.codEmpReal || this.empresaSelecionada || 1),
        codParc:      Number(this.clienteSelecionado!.codparc),
        codTipOper:   Number(this.tipoOperacao),
        codTipVenda:  Number(this.tipoNegociacaoSelecionado),
        codCenCus:    Number(this.centroResultadoSelecionado ?? 0),
        codNat:       Number(this.naturezaSelecionada ?? 0),
        observacao:   this._observacaoSincronizada(),
        obsInterna:   this.observacaoInterna ?? '',
        numTitulo:    this.numTitulo ?? '',
        tipoNumTitulo: 'VEN',
        adObs:        this.adObs ?? '',
        adFreteObs:   this.adFreteObs ?? '',
        numPedido2:   this.numPedido2 ?? '',
        codVend:      this.codVendLogado ? Number(this.codVendLogado) : null,
        dataEmissao:  this._isoToBr(this.dataEmissao),
        dtNegociacao: this._isoToBr(this.dtNegociacao),
        tipFrete:     this.tipFrete ?? '',
        codParcTransp: this.codParcTransp ?? null,
        cifFob:       this.cifFob ?? '',
        formaEnvio:   this.formaEnvio ?? '',
        qtdVol:       this.qtdVol ?? null,
        pesoBruto:    this.pesoBruto ?? null,
        vlrFrete:     this.vlrFrete ?? null,
        vlrFreteTtl:  this.vlrFreteTotalTransporte ?? null,
        prioridade:   this.prioridade ?? '',
        gplComissao:  this.gplComissao,
        despachar:    this.despachar ?? '',
        fatImediato:  this.fatImediato ?? '',
        tipoGpl:      this.tipoGpl ?? '',
        adCategoria:  this.adCategoria ?? '',
        gplStatus:    this.forcarFinalizarAoSalvar ? 'FINALIZADO' : (this.gplStatus || 'ABERTO'),
        // 0 (não null!) quando não há aeronave selecionada — mesmo motivo do
        // vlrDescTot/percDesc logo abaixo: null é tratado como "não alterar"
        // tanto no XML de gravação (GeraNotaFiscalHelper) quanto no
        // atualizarCamposAdicionais, então nunca conseguia limpar o
        // AD_CODAERO depois que o vendedor removia a aeronave do pedido —
        // o vínculo antigo ficava no banco e continuava travando o
        // Finalizar com "Aeronave não pertence a este parceiro".
        codAero:      this.aeronaveSelecionada ? Number(this.aeronaveSelecionada) : 0,
        codParcDest:  this.codparcEntregaSelecionado ? Number(this.codparcEntregaSelecionado) : null,
        vlrMoeda:     this.cotacaoValorNumerico || null,
        // Desconto do cabeçalho: SEMPRE enviamos 0 para TGFCAB.
        // O desconto é exibido em tela (carregado de vlrDescTot/percDesc ao abrir o pedido
        // e calculado via rateio quando o usuário digita um Total desejado), mas é
        // PERSISTIDO apenas rateado nos itens (TGFITE.VLRDESC / PERCDESC).
        // Gravar desconto no cabeçalho do Sankhya causa double-counting com o desconto
        // por item, distorcendo o VLRNOTA final — a regra é: cabeçalho sempre 0,
        // desconto real fica nos itens.
        vlrDescTot:   0,
        percDesc:     0,
        // "Outros" (VLROUTROS) — sempre mandamos o valor explícito da tela (0
        // inclusive), pra que o backend priorize ele sobre a soma automática
        // calculada a partir dos itens (ver PedidoVendaComponent.gravarPedido).
        vlrOutros:    this.vlrOutros ?? 0,
        // Diz pro backend se o Vlr. Frete deve somar no VLRNOTA gravado — só a
        // tela sabe se o Tipo do Frete escolhido corresponde a "Incluso" (o
        // código do combo nativo TIPFRETE varia por instalação do Sankhya, ver
        // getter vlrFreteIncluso). Backend usa isso pra recalcular o Total
        // mostrado na Lista de Pedidos de Venda igual ao Total exibido aqui.
        vlrFreteIncluso: this.vlrFreteIncluso,
      },
      itens: itensValidos.map(i => {
        // percdesc de ALTA PRECISÃO (não o "i.desconto" arredondado em 2 casas
        // que aparece na tela). MOTIVO: o motor nativo do Sankhya, ao gravar o
        // item (GeraNotaFiscalHelper → XML PERCDESC/VLRDESC), RECALCULA
        // VLRDESC = VLRUNIT × QTDNEG × PERCDESC / 100 usando o PERCDESC
        // recebido — mesmo quando VLRDESC exato também é enviado. Como
        // "i.desconto" só carrega 2 casas decimais (ex.: 3,82%, arredondado
        // pra exibição/edição no grid), o valor recalculado pelo Sankhya
        // divergia do vlrDesc exato do rateio (ex.: R$342,95 em vez de
        // R$342,83), fazendo o Total do Pedido "andar" uns centavos entre a
        // tela, a Lista de Pedidos de Venda e o pedido reaberto — em TODOS os
        // casos usando o mesmo valor errado já gravado em TGFITE.VLRDESC.
        // Recalculando aqui o percentual real (vlrDesc/base×100) com 6 casas,
        // sem arredondar pra 2, o Sankhya reproduz o vlrDesc exato ao
        // recalcular — sem precisar tocar no addon (Java só repassa o que
        // chega no JSON). O campo "i.desconto" da tela continua com 2 casas,
        // intacto — só o payload de gravação usa o percentual preciso.
        const baseItem = (i.quantidade || 0) * (i.precoUnitario || 0);
        // percdescPreciso mantém o SINAL de vlrDesc (negativo = acréscimo) —
        // mesma convenção usada em toda a tela (totalDesconto/totalAcrescDesc/
        // aplicarRateioDesconto). Sem arredondar pra 2 casas (ver comentário
        // acima sobre o motor nativo recalcular VLRDESC a partir do PERCDESC).
        const percdescPreciso = (i.vlrDesc || 0) !== 0 && baseItem > 0
          ? Number(((i.vlrDesc || 0) / baseItem * 100).toFixed(6))
          : (i.desconto || 0);
        return {
          codprod:  i.codprodInterno!,
          codvol:   i.unidade || 'UN',
          qtdneg:   i.quantidade || 1,
          // vlrunit = preço unitário em R$ exibido na tela (inclui Core quando ativo)
          vlrunit:     i.precoUnitario || 0,
          // vlrunitmoe = preço unitário em U$ — gravado em TGFITE.VLRUNITMOE
          vlrunitmoe:  i.precoUsd || 0,
          // vlrtotmoe = Subtotal U$ da linha — gravado em TGFITE.VLRTOTMOE
          vlrtotmoe:   i.totalUsd || 0,
          // Acréscimo grava no MESMO campo do desconto (TGFITE.VLRDESC/PERCDESC),
          // só que com valor NEGATIVO — a pedido do usuário, mesma convenção já
          // usada em toda a tela (rateio, totais, carregamento). Não usa mais
          // VLRACRESCDESC pra isso (esse campo virou legado: só sobra pra itens
          // antigos que ainda tenham algo lá, "vlrAcrescDesc" abaixo). Histórico:
          // uma versão anterior desviava o acréscimo pra VLRACRESCDESC porque
          // mandar um PERCDESC POSITIVO (de Math.abs(i.desconto), incondicional)
          // JUNTO com VLRACRESCDESC preenchido pro mesmo item já causou erro no
          // motor nativo do Sankhya ao recalcular a base de substituição
          // tributária ("Valor da substituição não pode ficar negativo") — mas
          // essa era uma combinação INCONSISTENTE (percdesc dizendo "desconto"
          // enquanto vlrdesc ficava zerado). Enviando percdesc e vlrdesc com o
          // MESMO sinal (os dois negativos num acréscimo, nunca um positivo e
          // outro zerado), a combinação fica consistente.
          percdesc: (i.vlrDesc || 0) !== 0 ? percdescPreciso : 0,
          vlrdesc:  i.vlrDesc || 0,
          vlracrescdesc: i.vlrAcrescDesc || 0,
          codlocal: i.codlocal ?? i.codlocalpadrao ?? 0,
          // vlrtot = subtotal do item já com Core incluso (vlrunit×qty - desc + acrésc + coreUnitBrl×qty)
          vlrtot: i.total || 0,
          // IPI e ICMS-ST calculados no formulário — persistidos em TGFITE para coerência com a lista
          vlripi:   i.vlrIpi    || 0,
          vlrsubst: i.vlrIcmsst || 0,
          // Campos CORE — preservam a negociação, não o cadastro atual do produto
          // AD_COREATIVO é campo real (gravável) em TGFITE; AD_INFORMACORE é calculado (somente leitura)
          ad_core: i.controlaCore ? 'S' : 'N',
          ad_vlrcore:   i.vlrCore || 0,
        };
      }),
    };
  }

  /** Agenda (debounced) a sincronização silenciosa do rascunho de impostos —
   *  chamado a cada recálculo de item e ao selecionar cliente. Filtros
   *  baratos aqui evitam empilhar trabalho desnecessário no Subject; a
   *  validação completa acontece de novo em _sincronizarRascunhoImpostos. */
  private _agendarRascunhoImpostos(): void {
    if (this.modoEdicao || this.somenteCabecalho) return; // só pedido NOVO
    if (!this.clienteSelecionado || !this.tipoOperacao || !this.tipoNegociacaoSelecionado) return;
    const temItemValido = this.itens.some(i => i.codprodInterno && i.codprodInterno > 0 && i.quantidade > 0);
    if (!temItemValido) return;
    // Produto controlado acima do limite: não grava nem o rascunho silencioso
    // no Sankhya — senão o NUNOTA é criado/atualizado com a quantidade
    // irregular em segundo plano, mesmo sem o usuário nunca clicar em Salvar.
    if (this.itens.some(i => i.controladoBloqueado)) return;
    this._rascunhoSubject.next();
  }

  /** Grava o cabeçalho + itens atuais em segundo plano (sem toast, sem reset,
   *  sem navegação) só para o ImpostosHelpper nativo calcular IPI/ICMS-ST de
   *  verdade (ver ImpostoRepository no addon). Reaproveita o mesmo NUNOTA em
   *  chamadas seguintes — nunca cria um segundo pedido. Falha aqui é
   *  silenciosa: os campos continuam mostrando a estimativa local de IPI. */
  private async _sincronizarRascunhoImpostos(): Promise<void> {
    if (this._rascunhoEmAndamento || this.salvando()) return;
    if (this.modoEdicao || this.somenteCabecalho) return;
    if (!this.clienteSelecionado || !this.tipoOperacao || !this.tipoNegociacaoSelecionado) return;

    const itensValidos = this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0 && i.quantidade > 0);
    if (itensValidos.length === 0) return;

    // Segunda trava (defesa em profundidade — ver _agendarRascunhoImpostos):
    // o debounce de 400ms da checagem mensal de produto controlado pode
    // ainda não ter terminado quando o Subject do rascunho dispara; reforça
    // aqui pra nunca gravar (nem em segundo plano) com item bloqueado.
    if (itensValidos.some(i => i.controladoBloqueado)) return;

    this._rascunhoEmAndamento = true;
    try {
      const payload = this._montarPayloadPedido(itensValidos);
      if (this.nunotaRascunho) {
        payload.cabecalho.nunota = this.nunotaRascunho;
      }

      const res: any = await firstValueFrom(this.sankhyaGateway.gravarPedidoVenda(payload));
      const body = res?.responseBody ?? res;

      if (body?.sucesso === true || body?.sucesso === 'true') {
        const nunota = Number(body?.nunota) || null;
        if (nunota) {
          this.nunotaRascunho = nunota;
          this._ultimoPayloadRascunho = payload;
          await this._aplicarImpostosCalculados(nunota, itensValidos);
        }
      }
    } catch (err) {
      console.warn('[PedidoVenda] Falha ao sincronizar rascunho de impostos (segue com estimativa local de IPI):', err);
    } finally {
      this._rascunhoEmAndamento = false;
    }
  }

  /** Após gravar o rascunho, busca de volta o pedido para pegar os valores
   *  REAIS de IPI/ICMS-ST calculados pelo ImpostosHelpper (TGFITE) e aplica
   *  nos itens em tela, na mesma ordem em que foram enviados — sem mexer em
   *  mais nada (descrição, ids, etc. continuam os que o usuário está editando). */
  private async _aplicarImpostosCalculados(nunota: number, itensEnviados: ItemPedido[]): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.sankhyaGateway.buscarDetalhesPedidoVenda(nunota));
      const body = res?.responseBody ?? res;
      const d = body?.sucesso ? (body.detalhe ?? body) : null;
      const itensRetornados: any[] = Array.isArray(d?.itens) ? d.itens : [];
      if (itensRetornados.length === 0) return;

      itensEnviados.forEach((item, idx) => {
        const it = itensRetornados[idx];
        if (!it) return;
        item.ncm             = it.ncm || item.ncm || '';
        item.aliqIpi       = Number(it.aliqipi)       || 0;
        item.vlrBaseIpi     = Number(it.vlrbaseipi)    || 0;
        item.vlrIpi         = Number(it.vlripi)        || 0;
        item.aliqIcmsst     = Number(it.aliqicmsst)    || 0;
        item.vlrBaseIcmsst  = Number(it.vlrbaseicmsst) || 0;
        item.vlrIcmsst       = Number(it.vlricmsst)     || 0;
      });
    } catch (err) {
      console.warn('[PedidoVenda] Falha ao reler impostos calculados do rascunho:', err);
    }
  }

  /** Retorna true quando o pedido foi efetivamente gravado com sucesso —
   *  usado pelo fluxo de "Gerar Venda a Partir da O.S" para decidir se pode
   *  manter o formulário escondido (sucesso) ou precisa exibi-lo de volta
   *  (validação falhou, falta estoque, ou erro ao gravar). */
  async salvar(forcado = false): Promise<boolean> {
    if (this.salvando()) return false;    // guard contra duplo clique
    if (!this.clienteSelecionado || !this.tipoOperacao || !this.dataEmissao || !this.dtNegociacao) {
      this.abrirAlerta('Preencha Cliente, Tipo de Operação, Data de Emissão e Data de Negociação.', 'aviso');
      return false;
    }
    if (!this.vendedorValido) {
      this.abrirAlerta('Selecione um Vendedor válido antes de gravar o pedido.', 'aviso');
      return false;
    }
    if (!this.tipoNegociacaoValido) {
      this.abrirAlerta('Selecione um Tipo Negociação (Condição de Pagamento) válido antes de gravar o pedido.', 'aviso');
      return false;
    }

    const itensValidos = this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
    if (itensValidos.length === 0) {
      this.abrirAlerta('Adicione pelo menos um item com PN válido (pressione ENTER no campo PN).', 'aviso');
      return false;
    }

    // Não pode existir venda/orçamento sem cotação (o campo já não pode mais
    // ser limpo pela tela — botão "X" removido — mas essa checagem é o que
    // de fato bloqueia gravar: usuário relatou conseguir gravar um pedido
    // mesmo com a cotação zerada antes dessa validação existir).
    if (this.cotacaoValorNumerico <= 0) {
      this.abrirAlerta('Selecione uma cotação do dólar antes de gravar o pedido.', 'aviso');
      return false;
    }

    // Trava de Vlr. Frete por modalidade CIF/FOB (ver vlrFreteBloqueado) —
    // o campo já vem desabilitado na tela pra essas modalidades, mas essa
    // checagem aqui é o que de fato impede gravar caso o valor tenha vindo
    // de outro jeito (rascunho salvo antes de trocar a modalidade, edição
    // de pedido antigo, instabilidade da tela etc.).
    if (this.vlrFreteBloqueado && (this.vlrFrete || 0) > 0) {
      this.abrirAlerta(
        'Para fretes do tipo FOB ou por conta do destinatário, o valor do frete deve ser zero. O transporte será pago pelo cliente diretamente à transportadora.',
        'erro'
      );
      return false;
    }

    // Produto controlado: bloqueio rígido (não é confirmável como o de estoque
    // insuficiente) — quantidade do mês (já vendido + este pedido) para o
    // CPF/CNPJ do cliente excede o limite (GPL_CTRL_LIM_PF/PJ).
    const itensControladosBloqueados = itensValidos.filter(i => i.controladoBloqueado);
    if (itensControladosBloqueados.length > 0) {
      const primeiraMsg = itensControladosBloqueados[0].controladoMensagem;
      this.abrirAlerta(
        primeiraMsg || 'Há item(ns) de produto controlado acima do limite mensal permitido para este cliente.',
        'erro'
      );
      return false;
    }

    // Verificar itens com estoque insuficiente (apenas na empresa selecionada)
    if (!forcado) {
      const semEstoque = itensValidos.filter(i => (i.estoque ?? 0) < i.quantidade);
      if (semEstoque.length > 0) {
        this.confirmacaoEstoqueItens = semEstoque.map(i => ({
          pn:       i.codprod,
          descricao: i.descricao,
          qtd:      i.quantidade,
          estoque:  i.estoque ?? 0,
          unidade:  i.unidade || 'UN',
        }));
        this.confirmacaoEstoqueAberta = true;
        // Defensivo: garante que quem chamou salvar() sem forçar sempre tenha
        // uma mensagem em this.alerta, mesmo que não exiba o modal (ex.: um
        // fluxo silencioso que nunca deveria ter caído aqui).
        this.abrirAlerta('Há itens com estoque insuficiente — confirmação necessária.', 'aviso');
        return false;
      }
    }

    // % Comissão nunca pode ir vazio ou negativo para o backend.
    this.onBlurGplComissao();

    // "Finalizar Venda": se nada financeiro mudou desde que o pedido foi
    // carregado (cliente, forma de negociação, itens, frete, desconto...),
    // não precisa reenviar o cabeçalho inteiro pro motor nativo do Sankhya —
    // só atualiza o GPL_STATUS. Isso evita revalidações nativas
    // desnecessárias (ex.: "Configurações incoerentes" moeda x TOP) quando
    // o usuário só está confirmando o pedido como já está gravado. Se algo
    // financeiro foi alterado no formulário, cai no fluxo normal abaixo,
    // que grava tudo de novo — necessário pra recalcular valores/impostos.
    if (this.forcarFinalizarAoSalvar && this.modoEdicao && this.nunotaAtual && this._snapshotFinanceiroCarregado) {
      const snapshotAtual = this._payloadFinanceiroComparavel(itensValidos);
      if (snapshotAtual === this._snapshotFinanceiroCarregado) {
        return this._finalizarSomenteStatus();
      }
    }

    this.salvando.set(true);
    try {
      const payload: any = this._montarPayloadPedido(itensValidos);

      if (this.modoEdicao && this.nunotaAtual) {
        payload.cabecalho.nunota = this.nunotaAtual;
      } else if (this.nunotaRascunho) {
        // Reaproveita o NUNOTA do rascunho já gravado em segundo plano
        // (cálculo de impostos em tempo real) — evita criar pedido duplicado.
        payload.cabecalho.nunota = this.nunotaRascunho;
      }

      const res: any = await firstValueFrom(
        this.sankhyaGateway.gravarPedidoVenda(payload)
      );
      const body = res?.responseBody ?? res;

      if (body?.sucesso === true || body?.sucesso === 'true') {
        const nunota = body?.nunota ?? '';
        // Salvar comissões pendentes (adicionadas antes de ter o NUNOTA)
        if (nunota) await this._salvarComissoesPendentes(Number(nunota));
        // Guarda antes do reset — _resetarFormulario não mexe nesta flag, mas
        // não custa nada garantir que capturamos o valor certo aqui.
        const origemOS = this.excelImportOrigemOS;
        // pendente=true: o motor nativo do Sankhya detectou um bloqueio com
        // liberação configurada ao gravar (ex.: desconto acima do permitido —
        // "Liberação solicitada para o movimento") — o pedido foi gravado
        // normalmente, mas o backend já marcou GPL_STATUS=PENDENTE e ele
        // aparece na tela de Liberação, aguardando aprovação do gestor.
        const pendente = body?.pendente === true || body?.pendente === 'true';
        // descontoAplicado=false: a fase separada que aplica o desconto real
        // (depois do item já ter sido gravado a preço cheio e os impostos
        // recalculados) falhou no Sankhya — o pedido foi gravado, mas SEM o
        // desconto. body?.avisoDesconto traz a exceção completa do Sankhya,
        // pra dar pra diagnosticar direto aqui sem precisar de log do
        // servidor. Campo undefined (backend antigo) = trata como aplicado.
        const descontoAplicado = body?.descontoAplicado !== false && body?.descontoAplicado !== 'false';
        if (pendente) {
          this.abrirAlerta(
            body?.mensagem ?? `Pedido #${nunota} gravado, mas ficou PENDENTE de liberação do gestor.`,
            'aviso'
          );
        } else if (!descontoAplicado) {
          this.abrirAlerta(
            `Pedido #${nunota} gravado, mas o DESCONTO NÃO foi aplicado. Motivo: ${body?.avisoDesconto ?? 'desconhecido'}`,
            'erro'
          );
        } else {
          this.abrirAlerta(`Pedido gravado com sucesso! NUNOTA: ${nunota}`, 'sucesso');
        }
        this._resetarFormulario();
        if (!this._suprimirNavegacaoAutomatica) {
          setTimeout(() => {
            if (origemOS && nunota) {
              // Veio de "Gerar Venda a Partir da O.S" — volta para a Lista de
              // Pedidos com o pedido recém-gravado já selecionado/destacado.
              this.osVendaGravada.emit(Number(nunota));
            } else {
              this.voltarLista.emit();
            }
          }, 1500);
        }
        // Quando _suprimirNavegacaoAutomatica está ativo (ação de status
        // silenciosa disparada pela Lista), quem decide a navegação é
        // _executarAcaoStatusSilenciosa, via acaoStatusConcluida.
        return true;
      } else {
        const erro = body?.erro ?? res?.statusMessage ?? 'Erro desconhecido ao gravar.';
        this.abrirAlerta(erro, 'erro');
        return false;
      }
    } catch (err: any) {
      console.error('[PedidoVenda] erro ao gravar:', err);
      const msg = err?.error?.detail
        ?? err?.error?.statusMessage
        ?? err?.error?.message
        ?? err?.message
        ?? 'Erro ao gravar pedido.';
      this.abrirAlerta(msg, 'erro');
      return false;
    } finally {
      this.salvando.set(false);
    }
  }

  /** Fast-path de "Finalizar Venda" (ver salvar()): quando o snapshot
   *  financeiro capturado no carregamento bate com o estado atual do
   *  formulário, não há nada pra recalcular no Sankhya — só grava o
   *  GPL_STATUS via UPDATE isolado (mesmo endpoint já usado por
   *  Estornar/Cancelar/Finalizar Conferência), evitando reenviar o
   *  cabeçalho inteiro pro motor nativo e disparar revalidações completas
   *  desnecessárias (ex.: "Configurações incoerentes" moeda x TOP). */
  private async _finalizarSomenteStatus(): Promise<boolean> {
    this.salvando.set(true);
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.atualizarGplStatusPedidoVenda(this.nunotaAtual!, 'FINALIZADO')
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        this.gplStatus = 'FINALIZADO';
        this.abrirAlerta(`Pedido #${this.nunotaAtual} finalizado com sucesso!`, 'sucesso');
        this._resetarFormulario();
        if (!this._suprimirNavegacaoAutomatica) {
          setTimeout(() => this.voltarLista.emit(), 1500);
        }
        return true;
      } else {
        const erro = body?.erro ?? body?.mensagem ?? body?.message ?? body?.statusMessage
          ?? res?.erro ?? res?.mensagem ?? res?.statusMessage
          ?? 'Erro desconhecido ao finalizar.';
        if (erro === 'Erro desconhecido ao finalizar.') {
          // Nao conseguimos achar a mensagem em nenhum campo conhecido —
          // loga a resposta crua pra facilitar diagnostico no DevTools.
          console.error('[_finalizarSomenteStatus] resposta sem campo de erro reconhecido:', res);
        }
        this.abrirAlerta(erro, 'erro');
        return false;
      }
    } catch (err: any) {
      const msg = err?.error?.erro ?? err?.error?.mensagem ?? err?.error?.message
        ?? err?.error?.responseBody?.erro ?? err?.error?.responseBody?.mensagem
        ?? err?.message ?? 'Erro ao finalizar pedido.';
      if (msg === 'Erro ao finalizar pedido.') {
        console.error('[_finalizarSomenteStatus] erro HTTP sem campo reconhecido:', err);
      }
      this.abrirAlerta(msg, 'erro');
      return false;
    } finally {
      this.salvando.set(false);
    }
  }

  async carregarPedidoParaEdicao(nunota: number): Promise<void> {
    this.carregandoEdicao = true;
    try {
      const res: any = await firstValueFrom(
        this.sankhyaGateway.buscarDetalhesPedidoVenda(nunota)
      );
      const body = res?.responseBody ?? res;
      const d    = body?.sucesso ? (body.detalhe ?? body) : null;
      if (!d) {
        const errMsg = body?.erro || 'Pedido nao encontrado para edicao.';
        this.abrirAlerta(errMsg, 'erro');
        return;
      }

      // CODEMP real do pedido — precisa vir ANTES de tudo e sobrescrever o
      // seletor de empresa global do sistema. Sem isso, salvar "Dados da
      // Venda" reenviava o cabeçalho com o codEmp que estivesse selecionado
      // globalmente (não necessariamente o mesmo do pedido), fazendo o
      // Sankhya nativo validar regras de negócio (TOP, tabela de preço, etc.)
      // contra a empresa ERRADA — ex.: "TOP 1001 não configurada pra moeda"
      // mesmo a TOP estando certa na empresa real do pedido (pedido #1717).
      // Prioriza a empresa VIRTUAL do pedido (GPL_EMPRESA_VIRTUAL — ex.: Rio Verde),
      // se houver — sem isso, reabrir um pedido de uma filial virtual pra edição
      // fazia o seletor voltar pra "Empresa 1" (CODEMP real), e qualquer item NOVO
      // adicionado dali pra frente resolvia o Local errado de novo (voltava a
      // "melhor saldo disponível" na empresa 1 inteira, em vez do Local fixo
      // daquela filial). Só cai no CODEMP real quando o pedido não tem empresa
      // virtual associada (fluxo antigo, empresas sem filial virtual).
      //
      // empresaSelecionada é o seletor GLOBAL (EmpresaStateService, persistido
      // em localStorage) — usado também pela Lista de Pedidos, Painéis, etc.
      // Guarda o valor de ANTES de entrar na edição (só na primeira vez) pra
      // devolver ao sair (ver ngOnDestroy) — sem isso, editar um pedido de
      // empresa virtual (ex.: 10-Rio Verde) trocava o seletor global pra
      // sempre, e ao clicar Voltar a Lista (e qualquer outra tela) continuava
      // filtrando por Rio Verde até o usuário trocar manualmente de novo.
      if (this._empresaSelecionadaAntesDaEdicao === null) {
        this._empresaSelecionadaAntesDaEdicao = this.empresaSelecionada;
      }
      if (d.gplEmpresaVirtual != null && Number(d.gplEmpresaVirtual) > 0) {
        this.empresaSelecionada = String(d.gplEmpresaVirtual);
      } else if (d.codemp != null && Number(d.codemp) > 0) {
        this.empresaSelecionada = String(d.codemp);
      }
      if (d.dtmovIso) {
        this.dataEmissao  = d.dtmovIso;
        this.dtNegociacao = d.dtmovIso;
      }
      if (d.codtipoper)        this.tipoOperacao               = String(d.codtipoper);
      // "0 - <SEM TIPO DE VENDA>" / "0 - <SEM VENDEDOR>" são registros
      // fictícios do Sankhya pra pedido sem esses dados definidos -- não
      // conta como valor válido, o campo tem que ficar vazio (obrigando o
      // usuário a escolher um valor de verdade antes de salvar).
      if (d.codtipvenda && String(d.codtipvenda).trim() !== '0') this.tipoNegociacaoSelecionado = d.codtipvenda;
      if (d.codcencus != null) this.centroResultadoSelecionado  = d.codcencus;
      if (d.codnat    != null) this.naturezaSelecionada          = d.codnat;
      if (d.codvend   != null && String(d.codvend).trim() !== '0') this.codVendLogado = d.codvend;
      if (d.observacao  != null) this.observacao        = d.observacao;
      if (d.obsInterna  != null) this.observacaoInterna = d.obsInterna;
      if (d.numTitulo   != null) this.numTitulo = d.numTitulo;
      if (d.adObs       != null) this.adObs             = d.adObs;
      if (d.adFreteObs  != null) this.adFreteObs        = d.adFreteObs;
      if (d.numPedido2  != null) this.numPedido2        = d.numPedido2;
      if (d.tipFrete    != null) this.tipFrete            = d.tipFrete;
      if (d.codParcTransp && Number(d.codParcTransp) > 0) {
        this._buscarTranspPorCodigo(Number(d.codParcTransp));
      }
      if (d.cifFob      != null) this.cifFob            = d.cifFob;
      // CIF/FOB nunca foi escolhido pra este pedido — o Tipo do Frete que
      // veio do Sankhya nesse caso é só o default nativo do campo (TGFCAB.
      // TIPFRETE), não uma escolha real do vendedor. Não mostra "Incluso"/
      // "Extra Nota" como se fosse (mesma regra do onCifFobChange — pedido
      // do usuário: "quando não tem nenhum [CIF/FOB] gravado ainda").
      if (!this.cifFob) this.tipFrete = '';
      if (d.formaEnvio  != null) this.formaEnvio        = d.formaEnvio;
      if (d.prioridade  != null) this.prioridade        = d.prioridade;
      if (d.gplComissao != null) this.gplComissao       = Number(d.gplComissao);
      if (d.despachar   != null) this.despachar         = d.despachar;
      if (d.fatImediato != null) this.fatImediato       = d.fatImediato;
      if (d.tipoGpl     != null) this.tipoGpl           = d.tipoGpl;
      if (d.adCategoria != null) this.adCategoria       = d.adCategoria;
      // GPL_STATUS: se null ou "Aberto"/"ABERTO", mantém "ABERTO"; caso contrário usa o valor atual
      this.gplStatus = (d.gplStatus && d.gplStatus.toUpperCase() !== 'ABERTO') ? d.gplStatus : 'ABERTO';
      
      // Define modo leitura conforme o status atual:
      // - "Editar Dados da Venda" (somenteCabecalho): permite editar em QUALQUER
      //   status, exceto Finalizado e Faturado (Faturado ainda não existe no
      //   sistema — status futuro já contemplado aqui). LOGISTICA foi tirada
      //   daqui a pedido do usuário — agora edita Dados da Venda normalmente
      //   mesmo com o pedido em Logística.
      // - Edição normal do pedido: só permite em Aberto/Pendente (como já era).
      const statusAtivo = (this.gplStatus || '').toUpperCase();
      if (this.somenteCabecalho) {
        const STATUS_BLOQUEADOS_CABECALHO = ['FINALIZADO', 'FATURADO'];
        this.modoSomenteLeitura = STATUS_BLOQUEADOS_CABECALHO.includes(statusAtivo);
      } else {
        this.modoSomenteLeitura = (statusAtivo !== 'ABERTO' && statusAtivo !== 'PENDENTE');
      }
      
      if (d.qtdVol      != null) this.qtdVol            = Number(d.qtdVol)    || null;
      if (d.pesoBruto   != null) this.pesoBruto         = Number(d.pesoBruto) || null;
      if (d.vlrFrete    != null) this.vlrFrete          = Number(d.vlrFrete)  || null;
      if (d.vlrFreteTtl != null) this.vlrFreteTotalTransporte = Number(d.vlrFreteTtl) || null;
      if (d.vlrDescTot  != null && Number(d.vlrDescTot)  > 0) this.vlrDescGeral  = Number(d.vlrDescTot);
      if (d.percDesc    != null && Number(d.percDesc)    > 0) this.percDescGeral = Number(d.percDesc);
      this.vlrOutros = d.vlrOutros != null ? (Number(d.vlrOutros) || 0) : 0;

      // Carregar comissões da nota
      this._carregarComissoes(nunota);
      if (d.vlrMoeda && Number(d.vlrMoeda) > 0) {
        const taxa = Number(d.vlrMoeda);
        this.cotacaoTexto = taxa.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
        this.cotacaoSelecionada = { valor: String(taxa), data: '' } as any;
      }

      if (d.codparc && d.cliente) {
        // Buscar dados completos do cliente (inscEstadual, adCom/ANAC, etc.)
        // para que os card-title das abas exibam tudo corretamente.
        let clienteObj: ClienteSugestao = { codparc: d.codparc, nomeparc: d.cliente, docparc: d.docparc ?? '' };
        try {
          const resCli: any = await firstValueFrom(
            this.sankhyaGateway.buscarClientePedidoVenda(String(d.codparc))
          );
          const bodyCli = resCli?.responseBody ?? resCli;
          const listaCli: ClienteSugestao[] = bodyCli?.lista ?? [];
          const encontrado = listaCli.find((c: any) => String(c.codparc) === String(d.codparc));
          if (encontrado) {
            clienteObj = encontrado;
          }
        } catch { /* fallback: usa clienteObj parcial */ }
        await this.selecionarCliente(clienteObj);
        this.aeronaveNaoVinculadaAoCliente = false;
        if (d.codAero && Number(d.codAero) > 0) {
          this.aeronaveSelecionada = d.codAero;
          // _carregarAeronaves (disparado por selecionarCliente) traz só as aeronaves
          // vinculadas a este CODPARC (e exclui vínculo OFICINA) — se a aeronave salva
          // no pedido não estiver nessa lista, o getter de exibição fica vazio mesmo com
          // o valor certo selecionado. Busca ela direto por CODAERO e injeta na lista.
          const encontrada = this.aeronaveOpcoes.find(a => String(a.codaero) === String(d.codAero));
          if (encontrada) {
            // Já estava na lista (caso mais comum) — só faltava preencher o
            // texto exibido no campo, que "selecionarCliente" limpa sempre.
            this.aeronaveBusca = encontrada.prefixo;
          } else {
            try {
              const resAero: any = await firstValueFrom(
                this.sankhyaGateway.buscarAeronavePorCodigo(d.codAero)
              );
              const bodyAero = resAero?.responseBody ?? resAero;
              const aero = bodyAero?.aeronave;
              if (bodyAero?.sucesso && aero?.prefixo) {
                this.aeronaveOpcoes = [...this.aeronaveOpcoes, {
                  codaero: aero.codaero,
                  prefixo: aero.prefixo,
                  nomeProprietario: aero.nomeProprietario,
                }];
                this.aeronaveBusca = aero.prefixo;
              }
              // A aeronave gravada no pedido não está vinculada ao cliente atual
              // (não veio na lista escopada por CODPARC) — mostramos ela mesmo
              // assim pra não esconder o dado histórico, mas sinalizamos com um
              // aviso: se o usuário salvar sem trocar, o Sankhya nativo bloqueia
              // com "Aeronave não pertence a este parceiro" (regra
              // SANKHYA_EV_INLCUIOBS_GLOBAL) — melhor avisar antes do que deixar
              // ele descobrir só depois de clicar em Salvar/Finalizar.
              this.aeronaveNaoVinculadaAoCliente = true;
            } catch (err) {
              console.error('[PedidoVenda] erro ao buscar aeronave por código (fallback edição):', err);
            }
          }
        }
        // Restaurar endereço e pessoa de entrega APÓS selecionarCliente
        if (d.codParcDest && Number(d.codParcDest) > 0) {
          this.codparcEntregaSelecionado = Number(d.codParcDest);
          const itemEnd = this.enderecosDisponiveis.find(
            e => String(e.codparc) === String(d.codParcDest)
          );
          if (itemEnd) {
            // Pessoa de entrega é do mesmo grupo do cliente — usa a lista já carregada
            this.enderecosEntregaDisponiveis = [...this.enderecosDisponiveis];
            this.endEntrega = this._converterEnderecoDisponivel(itemEnd);
            this.endEntregaIgualFaturamento = String(d.codParcDest) === String(d.codparc);
            const pessoaEnd: ClienteSugestao = {
              codparc:      itemEnd.codparc,
              nomeparc:     itemEnd.nomeparc,
              docparc:      this.clienteSelecionado?.docparc || '',
              inscEstadual: this.clienteSelecionado?.inscEstadual || '',
            };
            this.pessoaEntregaSelecionada = pessoaEnd;
            this.pessoaEntregaBusca = this._montarTextoCliente(pessoaEnd);
            this._recalcularTitulosPessoaEntrega(pessoaEnd);
          } else {
            // codParcDest é outra pessoa — buscar dados e endereços
            try {
              const res: any = await firstValueFrom(
                this.sankhyaGateway.buscarClientePedidoVenda(String(d.codParcDest))
              );
              const body = res?.responseBody ?? res;
              const lista = body?.lista ?? [];
              const found = lista.find((x: any) => String(x.codparc) === String(d.codParcDest));
              if (found) {
                this.pessoaEntregaSelecionada = found;
                this.pessoaEntregaBusca = this._montarTextoCliente(found);
                this._recalcularTitulosPessoaEntrega(found);
                // Carregar lista de endereços desta pessoa
                const resList: any = await firstValueFrom(
                  this.sankhyaGateway.buscarEnderecosPorCnpjPedidoVenda((found.docparc || '').replace(/\D/g, ''))
                );
                const bodyList = resList?.responseBody ?? resList;
                const addrLista: EnderecoDisponivel[] = bodyList?.enderecos ?? [];
                this.enderecosEntregaDisponiveis = bodyList?.sucesso && addrLista.length > 0 ? addrLista : [];
                // Aplicar o endereço do codParcDest salvo
                const endSalvo = this.enderecosEntregaDisponiveis.find(
                  e => String(e.codparc) === String(d.codParcDest)
                );
                if (endSalvo) {
                  this.endEntrega = this._converterEnderecoDisponivel(endSalvo);
                } else {
                  // Fallback: carregar endereço principal
                  const resEnd: any = await firstValueFrom(
                    this.sankhyaGateway.buscarEnderecoClientePedidoVenda(d.codParcDest)
                  );
                  const bodyEnd = resEnd?.responseBody ?? resEnd;
                  if (bodyEnd?.sucesso) {
                    const fat = bodyEnd.faturamento ?? {};
                    this.endEntrega = {
                      logradouro: fat.ENDERECO ?? '', numero: fat.NUMEND ?? '',
                      complemento: fat.COMPLEMENTO ?? '', bairro: fat.BAIRRO ?? '',
                      cep: fat.CEP ?? '', cidade: fat.NOMECID ?? '', uf: fat.UF ?? '',
                    };
                  }
                }
                this.endEntregaIgualFaturamento = false;
              }
            } catch { /* mantém o que selecionarCliente carregou */ }
          }
        }
      }

      // Diagnóstico: se o backend não conseguiu buscar colunas IPI/ST, loga no console
      if (d.avisoFiscal) {
        console.warn('[PedidoVenda] Fiscal:', d.avisoFiscal);
      }

      // Declarado FORA do if abaixo (precisa ficar em escopo lá embaixo, no
      // Promise.all antes de _verificarItensPrecoDesatualizadoEPerguntar —
      // ver comentário junto da declaração original mais abaixo).
      const promessasPrecoExc: Promise<void>[] = [];
      if (Array.isArray(d.itens) && d.itens.length > 0) {
        let nextId = 1;
        this.itens = d.itens.map((it: any) => {
          let cond = String(it.adCondicao ?? it.ad_condicao ?? it.AD_CONDICAO ?? it.adcondicao ?? '').trim();
          if (cond.toLowerCase() === 'null' || cond.toLowerCase() === 'undefined') cond = '';
          return {
            id:             nextId++,
            codprod:        it.refforn    ?? it.referencia ?? String(it.codprod ?? ''),
            adCondicao:     cond,
            codprodInterno: Number(it.codprod),
          descricao:      it.descricao  ?? '',
          unidade:        it.codvol     ?? 'UN',
          quantidade:     Number(it.qtd ?? it.qtdneg) || 1,  // backend retorna 'qtd'
          precoUsd:       Number(it.precoUsd) || 0,
          precoUsdStr:    Number(it.precoUsd) > 0 ? this.formatarDecimal(Number(it.precoUsd)) : '',
          precoUnitario:  Number(it.vlrunit)  || 0,
          // Arredondado pra 2 casas só pra EXIBIÇÃO/edição na tela — o Sankhya
          // agora guarda PERCDESC em alta precisão (ver payload de gravação),
          // o que mostrava algo como "3,81870%" no grid. O vlrDesc exato (linha
          // abaixo) continua intacto e é o que preservarVlrDesc=true usa pra
          // não perder precisão no Total; ao salvar de novo, o percdesc de
          // alta precisão é recalculado a partir do vlrDesc exato, não deste
          // valor arredondado aqui.
          desconto:       Math.round((Number(it.percdesc) || 0) * 100) / 100,
          vlrDesc:        Number(it.vlrdesc)       || 0,
          // Formata pros dois sinais — vlrdesc negativo (acréscimo) também
          // precisa aparecer no campo "Desc. Vlr" ao reabrir o pedido, mesmo
          // padrão usado em onDescontoVlrBlur/aplicarRateioDesconto (o '-' vai
          // na frente do texto, não fica embutido no formatarDecimal).
          vlrDescStr:     Number(it.vlrdesc) !== 0
            ? (Number(it.vlrdesc) < 0
                ? '-' + this.formatarDecimal(Math.abs(Number(it.vlrdesc)))
                : this.formatarDecimal(Number(it.vlrdesc)))
            : '',
          totalItemStr:   '',
          vlrAcrescDesc:  Number(it.vlracrescdesc) || 0,
          // TGFITE.VLRTOT agora é gravado CHEIO (sem abater desconto — mesmo
          // padrão do resto do Sankhya, ver GeraNotaFiscalHelper#aplicarDescontoItens).
          // A tela sempre mostrou o Subtotal do item LÍQUIDO (com desconto já
          // abatido) — reconstrói aqui subtraindo vlrdesc, senão reabrir um
          // pedido com desconto mostraria o subtotal cheio na grade.
          total:          (Number(it.vlrtot) || 0) - (Number(it.vlrdesc) || 0),
          totalUsd:       0,
          vlrCore:        Number(it.vlrCore)  || 0,
          coreUnitBrl:    0,
          totalCoreUsd:   0,
          totalCoreBrl:   0,
          controlaCore:   String(it.controlaCore ?? 'N').toUpperCase() === 'S',
          estoque:        Number(it.estoque) || 0,
          codlocalpadrao: Number(it.codlocal) || 0,
          codlocal:       Number(it.codlocal) || 0,
          descrLocal:     it.local || undefined,
          ncm:            it.ncm || '',
          aliqIpi:        Number(it.aliqipi)       || 0,
          vlrBaseIpi:     Number(it.vlrbaseipi)    || 0,
          vlrIpi:         Number(it.vlripi)        || 0,
          aliqIcmsst:     Number(it.aliqicmsst)    || 0,
          vlrBaseIcmsst:  Number(it.vlrbaseicmsst) || 0,
          vlrIcmsst:      Number(it.vlricmsst)     || 0,
          } as ItemPedido;
        });
        this._proximoId = nextId;
        const taxa = this.cotacaoValorNumerico;
        for (const item of this.itens) {
          // Salva o PN original para restaurar caso o usuário apague parcialmente e saia do campo
          item.codprodOriginal = item.codprod;
          // Modo edição: preserva os valores negociados (TGFITE), não re-busca do catálogo.
          // precoUsd é derivado do vlrunit / cambio do pedido (ambos salvos em TGFITE/TGFCAB).
          if (taxa > 0 && item.precoUnitario > 0 && item.precoUsd === 0) {
            item.precoUsd    = parseFloat((item.precoUnitario / taxa).toFixed(2));
            item.precoUsdStr = this.formatarDecimal(item.precoUsd);
          }
          if (item.controlaCore && item.vlrCore > 0) {
            // vlrunit (TGFITE.VLRUNIT) e precoUsd JÁ foram salvos com o Core embutido
            // (é assim que precoUnitario/precoUsd são mantidos em todo o resto da tela —
            // ver calcularTotal(): "Core já está em precoUnitario — não somar novamente").
            // Aqui só recalcula coreUnitBrl (usado no toggle e no total Core informativo),
            // SEM somar de novo em precoUsd/precoUnitario — isso causava o valor em dobro
            // ao reabrir um pedido salvo com Core ativo.
            item.coreUnitBrl = taxa > 0 ? parseFloat((item.vlrCore * taxa).toFixed(2)) : 0;
          }
          // preservarVlrDesc=true — usa o vlrDesc EXATO já carregado de TGFITE.VLRDESC
          // (linha 6061 acima), em vez de re-derivá-lo do percentual arredondado em 2
          // casas (item.desconto/TGFITE.PERCDESC). Sem isso, calcularTotal() recalculava
          // vlrDesc = base × desconto% / 100 toda vez que um pedido com desconto geral
          // rateado era reaberto, introduzindo um desvio de centavos por item (e portanto
          // no Total do Pedido) em relação ao valor realmente salvo — o pedido "andava"
          // uns centavos a cada vez que era reaberto e resalvo sem nenhuma edição real.
          this.calcularTotal(item, true);
          // Busca apenas o estoque atual — preserva preços negociados com o cliente
          promessasPrecoExc.push(this._buscarPrecoExcItem(item, false, true));
          // AD_CONDICAO (se faltando) e CODMARCA (Fabricante 70) — necessário mesmo
          // em edição, para que o vendedor possa reeditar o Vl. Unit. R$ corretamente.
          this._buscarDadosProdutoCompleto(item);
        }

        // Se itens carregados têm desconto OU acréscimo por item (rateio salvo
        // em TGFITE.VLRDESC, negativo = acréscimo), ativar espelho para evitar
        // double-counting com vlrDescGeral do cabeçalho. Antes só somava
        // Math.max(vlrDesc,0) (só desconto positivo) — um pedido com SÓ
        // acréscimo (todo vlrDesc negativo) nunca disparava o espelho, e os
        // totais gerais (R$/% /U$) ficavam em branco ao reabrir, mesmo com o
        // acréscimo certinho nos itens. Agora conta qualquer item não-zero.
        const temDescOuAcrescItens = this.itens.some(i => (i.vlrDesc || 0) !== 0);
        if (temDescOuAcrescItens) {
          this._vlrDescGeralEhEspelho = true;
          this._atualizarEspelhoDescGeral();
        }
      }

      // Snapshot financeiro pós-carga (ver _payloadFinanceiroComparavel) — os
      // fetches assíncronos disparados acima por item (_buscarPrecoExcItem
      // com "só estoque", _buscarDadosProdutoCompleto) não tocam nos campos
      // que entram nesse payload, então é seguro capturar aqui de forma síncrona.
      const itensParaSnapshot = this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
      this._snapshotFinanceiroCarregado = this._payloadFinanceiroComparavel(itensParaSnapshot);

      // ALTCOT — pedido antigo (Data de Emissão além do limite configurado)?
      // Pergunta se atualiza o preço de venda. Roda só aqui, no fim do
      // carregamento (depois de modoSomenteLeitura e dataEmissao definidos).
      // Reforça o carregamento do parâmetro aqui (await) em vez de confiar
      // só no fire-and-forget do ngOnInit — sem isso havia uma corrida real:
      // se a chamada de _carregarParametros() disparada no ngOnInit ainda
      // não tivesse voltado quando chegasse aqui, _parametrosCache['ALTCOT']
      // estava vazio e a checagem abaixo simplesmente não disparava a
      // pergunta (bug reportado: pedido de 30 dias não mostrou o aviso).
      await this._carregarParametros();
      this._verificarAltcotEPerguntar();

      // ALTPRECO — itens com preço desatualizado (TGFEXC.DHALTREG do produto
      // há mais de N dias sem atualização)? Espera os fetches de preço de
      // cada item (disparados no loop acima) resolverem antes de checar,
      // senão item.dataUltAtualPreco ainda estaria vazio pra a maioria.
      // Roda DEPOIS do ALTCOT de propósito — se o ALTCOT já abriu sua
      // pergunta, essa aqui fica pra próxima vez (algumModalAberto() bloqueia).
      if (promessasPrecoExc.length > 0) {
        await Promise.all(promessasPrecoExc);
      }
      this._verificarItensPrecoDesatualizadoEPerguntar();
    } catch (err: any) {
      this.abrirAlerta('Erro ao carregar pedido para edicao: ' + (err?.message ?? ''), 'erro');
    } finally {
      this.carregandoEdicao = false;
    }
  }

  confirmarGravarComEstoqueInsuficiente(): void {
    this.confirmacaoEstoqueAberta = false;
    this.confirmacaoEstoqueItens  = [];
    this.salvar(true);
  }

  cancelarConfirmacaoEstoque(): void {
    this.confirmacaoEstoqueAberta = false;
    this.confirmacaoEstoqueItens  = [];
  }

  confirmacaoSairAberta = false;

  onVoltarClick(): void {
    if (this.modoSomenteLeitura) {
      this.voltarLista.emit();
    } else {
      this.confirmacaoSairAberta = true;
    }
  }

  /** Ação a executar quando o usuário confirmar a saída — setada por quem
   *  pediu a saída (menu, via solicitarSaida) ou null quando é o botão
   *  Voltar padrão (nesse caso confirmarSair só emite voltarLista). */
  private _aoConfirmarSaida: (() => void) | null = null;

  confirmarSair(): void {
    this.confirmacaoSairAberta = false;
    if (this._aoConfirmarSaida) {
      const cb = this._aoConfirmarSaida;
      this._aoConfirmarSaida = null;
      cb();
    } else {
      this.voltarLista.emit();
    }
  }

  cancelarSair(): void {
    this.confirmacaoSairAberta = false;
    this._aoConfirmarSaida = null;
  }

  /**
   * Troca de empresa pelo seletor do MENU enquanto o Pedido de Venda está
   * aberto (novo ou em edição) — mudar de empresa muda o Local usado pra
   * calcular a quantidade Disponível de cada item, então pergunta antes de
   * aplicar de verdade (ver EmpresaStateService.registrarGuardaTroca /
   * MenuComponent.selecionarEmpresa). Confirmando, recalcula o Disponível
   * de todos os itens já adicionados pra nova empresa.
   */
  confirmacaoTrocaEmpresaAberta = false;
  private _novoCodEmpPendente: string | null = null;

  private _guardaTrocaEmpresa = (novoCodEmp: string): boolean => {
    this._novoCodEmpPendente = novoCodEmp;
    this.confirmacaoTrocaEmpresaAberta = true;
    return false; // segura a troca até o usuário confirmar/cancelar
  };

  confirmarTrocaEmpresa(): void {
    this.confirmacaoTrocaEmpresaAberta = false;
    const novoCodEmp = this._novoCodEmpPendente;
    this._novoCodEmpPendente = null;
    if (novoCodEmp == null) return;
    this.empresaState.selecionada = novoCodEmp;
    this._atualizarDisponivelTodosItens();
  }

  cancelarTrocaEmpresa(): void {
    this.confirmacaoTrocaEmpresaAberta = false;
    this._novoCodEmpPendente = null;
  }

  /** Recalcula item.estoque (Disponível) de todos os itens já adicionados
   *  ao pedido — chamado depois de confirmar a troca de empresa, já que o
   *  Local usado pro cálculo muda junto com a empresa selecionada. */
  private _atualizarDisponivelTodosItens(): void {
    for (const item of this.itens) {
      if (item.codprodInterno) {
        this._buscarPrecoExcItem(item, false, true);
      }
    }
  }

  /**
   * Chamado pelo gateway antes de trocar de tela pelo clique em outro item
   * do menu, enquanto o Pedido de Venda (Nova Venda ou edição) está aberto.
   * Reaproveita a mesma confirmação do botão Voltar — se estiver em modo
   * somente leitura, libera a navegação na hora (retorna true); caso
   * contrário, abre o modal e só executa "aoConfirmar" se o usuário
   * confirmar a saída (retorna false, sinalizando que a navegação deve
   * esperar).
   */
  solicitarSaida(aoConfirmar: () => void): boolean {
    if (this.modoSomenteLeitura) {
      return true;
    }
    this._aoConfirmarSaida = aoConfirmar;
    this.confirmacaoSairAberta = true;
    return false;
  }

  private _resetarFormulario(): void {
    this.itens = [{ id: 1, codprod: '', descricao: '', unidade: 'UN', quantidade: 1,
      precoUsd: 0, precoUnitario: 0, desconto: 0, vlrDesc: 0, vlrAcrescDesc: 0,
      total: 0, totalUsd: 0,
      vlrCore: 0, coreUnitBrl: 0, totalCoreUsd: 0, totalCoreBrl: 0,
      controlaCore: false, estoque: 0, codlocalpadrao: 0 }];
    this._proximoId = 2;
    this.observacao = '';
    this.observacaoInterna = '';
    this.numTitulo = '';
    this.adObs = '';
    this.adFreteObs = '';
    this.numPedido2 = '';
    this.qtdVol = null;
    this.pesoBruto = null;
    this.vlrFrete = null;
    this.vlrFreteTotalTransporte = null;
    this.vlrDescGeral  = null;
    this.percDescGeral = null;
    this._vlrDescGeralEhEspelho = false;
    this.vlrOutros = 0;
    this.comissoes = [];
    this.comissaoBusca = '';
    this.comissaoSugestoes = [];
    this.comissaoUsuarioSelecionado = null;
    this.comissaoCarregando = false;
    this.mostrarDropdownComissao = false;
    this.comissaoPerc = null;
    this.comissaoErro = '';
    clearTimeout(this._comissaoTimer);
    this.abaPrincipalAtiva = 'dados';
    this.modoEdicao  = false;
    this.nunotaAtual = null;
    // Pedido acabou de ser salvo de verdade (ou o rascunho foi finalizado
    // como o pedido real) — não há mais rascunho pendente para descartar.
    this.nunotaRascunho = null;
    this._ultimoPayloadRascunho = null;
  }

  /** Converte data de ISO (YYYY-MM-DD) para o formato esperado pelo backend Oracle (DD/MM/YYYY). */
  private _isoToBr(iso: string | null | undefined): string {
    if (!iso) return '';
    const parts = iso.split('-');
    if (parts.length !== 3) return iso;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  fmtQtd(valor: any, unidade?: string | null): string {
    if (valor == null || valor === '') return '0';
    let numStr = String(valor).replace(/,/g, '.');
    let num = parseFloat(numStr);
    if (isNaN(num)) return String(valor);

    if (Number.isFinite(num) && Math.abs(num - Math.round(num)) < 1e-6) {
      return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
    }
    return num.toLocaleString('pt-BR', { maximumFractionDigits: 4 });
  }

  fmtQtdEstoqueLocal(valor?: number | null): string {
    return this.fmtQtd(valor, this.buscaPecasProdutoSelecionado?.codvol);
  }
}

